;(function (factory) {
  typeof define === 'function' && define.amd
    ? define('index', factory)
    : factory()
})(function () {
  'use strict'

  function _classCallCheck (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError('Cannot call a class as a function')
    }
  }

  function _defineProperties (target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i]
      descriptor.enumerable = descriptor.enumerable || !1
      descriptor.configurable = !0
      if ('value' in descriptor) descriptor.writable = !0
      Object.defineProperty(target, descriptor.key, descriptor)
    }
  }

  function _createClass (Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps)
    if (staticProps) _defineProperties(Constructor, staticProps)
    return Constructor
  }

  function _defineProperty (obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      })
    } else {
      obj[key] = value
    }
    return obj
  }

  function _inherits (subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
      throw new TypeError('Super expression must either be null or a function')
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: !0,
        configurable: !0
      }
    })
    if (superClass) _setPrototypeOf(subClass, superClass)
  }

  function _getPrototypeOf (o) {
    _getPrototypeOf = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function _getPrototypeOf (o) {
          return o.__proto__ || Object.getPrototypeOf(o)
        }
    return _getPrototypeOf(o)
  }

  function _setPrototypeOf (o, p) {
    _setPrototypeOf =
      Object.setPrototypeOf ||
      function _setPrototypeOf (o, p) {
        o.__proto__ = p
        return o
      }
    return _setPrototypeOf(o, p)
  }

  function _isNativeReflectConstruct () {
    if (typeof Reflect === 'undefined' || !Reflect.construct) return !1
    if (Reflect.construct.sham) return !1
    if (typeof Proxy === 'function') return !0
    try {
      Boolean.prototype.valueOf.call(
        Reflect.construct(Boolean, [], function () {})
      )
      return !0
    } catch (e) {
      return !1
    }
  }

  function _construct (Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct
    } else {
      _construct = function _construct (Parent, args, Class) {
        var a = [null]
        a.push.apply(a, args)
        var Constructor = Function.bind.apply(Parent, a)
        var instance = new Constructor()
        if (Class) _setPrototypeOf(instance, Class.prototype)
        return instance
      }
    }
    return _construct.apply(null, arguments)
  }

  function _isNativeFunction (fn) {
    return Function.toString.call(fn).indexOf('[native code]') !== -1
  }

  function _wrapNativeSuper (Class) {
    var _cache = typeof Map === 'function' ? new Map() : undefined
    _wrapNativeSuper = function _wrapNativeSuper (Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class
      if (typeof Class !== 'function') {
        throw new TypeError(
          'Super expression must either be null or a function'
        )
      }
      if (typeof _cache !== 'undefined') {
        if (_cache.has(Class)) return _cache.get(Class)
        _cache.set(Class, Wrapper)
      }

      function Wrapper () {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor)
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      })
      return _setPrototypeOf(Wrapper, Class)
    }
    return _wrapNativeSuper(Class)
  }

  function _assertThisInitialized (self) {
    if (self === void 0) {
      throw new ReferenceError(
        "this hasn't been initialised - super() hasn't been called"
      )
    }
    return self
  }

  function _possibleConstructorReturn (self, call) {
    if (call && (typeof call === 'object' || typeof call === 'function')) {
      return call
    }
    return _assertThisInitialized(self)
  }

  function _createSuper (Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct()
    return function _createSuperInternal () {
      var Super = _getPrototypeOf(Derived),
        result
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor
        result = Reflect.construct(Super, arguments, NewTarget)
      } else {
        result = Super.apply(this, arguments)
      }
      return _possibleConstructorReturn(this, result)
    }
  }
  var Responsive = (function () {
    function Responsive () {
      var _this = this
      _classCallCheck(this, Responsive)
      this.currentBreakpoint = Responsive.getCurrentBreakpoint()
      window.addEventListener('resize', function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint()
        if (_this.currentBreakpoint === newBreakpoint) {
          return
        }
        document.dispatchEvent(
          new CustomEvent('breakpoint:changed', {
            detail: {
              previousBreakpoint: _this.currentBreakpoint,
              currentBreakpoint: newBreakpoint
            }
          })
        )
        _this.currentBreakpoint = newBreakpoint
      })
    }
    _createClass(Responsive, null, [
      {
        key: 'matchesBreakpoint',
        value: function matchesBreakpoint (breakpoint) {
          switch (breakpoint) {
            case 'phone':
              return window.matchMedia('screen and (max-width: 640px)').matches
            case 'tablet':
              return window.matchMedia(
                'screen and (min-width: 641px) and (max-width: 1007px)'
              ).matches
            case 'tablet-and-up':
              return window.matchMedia('screen and (min-width: 641px)').matches
            case 'pocket':
              return window.matchMedia('screen and (max-width: 1007px)').matches
            case 'lap':
              return window.matchMedia(
                'screen and (min-width: 1008px) and (max-width: 1279px)'
              ).matches
            case 'lap-and-up':
              return window.matchMedia('screen and (min-width: 1008px)').matches
            case 'desk':
              return window.matchMedia('screen and (min-width: 1280px)').matches
            case 'widescreen':
              return window.matchMedia('screen and (min-width: 1600px)').matches
            case 'supports-hover':
              return window.matchMedia('(hover: hover) and (pointer: fine)')
                .matches
          }
        }
      },
      {
        key: 'getCurrentBreakpoint',
        value: function getCurrentBreakpoint () {
          if (window.matchMedia('screen and (max-width: 640px)').matches) {
            return 'phone'
          }
          if (
            window.matchMedia(
              'screen and (min-width: 641px) and (max-width: 1007px)'
            ).matches
          ) {
            return 'tablet'
          }
          if (
            window.matchMedia(
              'screen and (min-width: 1008px) and (max-width: 1279px)'
            ).matches
          ) {
            return 'lap'
          }
          if (window.matchMedia('screen and (min-width: 1280px)').matches) {
            return 'desk'
          }
        }
      }
    ])
    return Responsive
  })()
  var Carousel = (function () {
    function Carousel (element) {
      var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
      var overrideSettings =
        arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}
      _classCallCheck(this, Carousel)
      this.element = element
      this.initialConfig = Object.assign(
        JSON.parse(element.getAttribute('data-flickity-config')),
        overrideSettings
      )
      this.options = options
      this._attachListeners()
      this._build()
    }
    _createClass(Carousel, [
      {
        key: 'destroy',
        value: function destroy () {
          this.flickityInstance.destroy()
          if (this.initialConfig.breakpoints !== undefined) {
            document.removeEventListener(
              'breakpoint:changed',
              this._onBreakpointChangedListener
            )
          }
        }
      },
      {
        key: 'getFlickityInstance',
        value: function getFlickityInstance () {
          return this.flickityInstance
        }
      },
      {
        key: 'selectCell',
        value: function selectCell (index) {
          var shouldPause =
            arguments.length > 1 && arguments[1] !== undefined
              ? arguments[1]
              : !1
          var shouldAnimate =
            arguments.length > 2 && arguments[2] !== undefined
              ? arguments[2]
              : !0
          if (shouldPause) {
            this.flickityInstance.pausePlayer()
          }
          this.flickityInstance.select(index, !1, !shouldAnimate)
        }
      },
      {
        key: 'next',
        value: function next () {
          this.flickityInstance.next()
        }
      },
      {
        key: 'previous',
        value: function previous () {
          this.flickityInstance.previous()
        }
      },
      {
        key: 'pausePlayer',
        value: function pausePlayer () {
          this.flickityInstance.pausePlayer()
        }
      },
      {
        key: 'unpausePlayer',
        value: function unpausePlayer () {
          this.flickityInstance.unpausePlayer()
        }
      },
      {
        key: 'resize',
        value: function resize () {
          this.flickityInstance.resize()
        }
      },
      {
        key: 'getSelectedIndex',
        value: function getSelectedIndex () {
          return this.flickityInstance.selectedIndex
        }
      },
      {
        key: 'getSelectedCell',
        value: function getSelectedCell () {
          return this.flickityInstance.selectedCell.element
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          if (this.initialConfig.breakpoints !== undefined) {
            this._onBreakpointChangedListener =
              this._onBreakpointChanged.bind(this)
            document.addEventListener(
              'breakpoint:changed',
              this._onBreakpointChangedListener
            )
          }
        }
      },
      {
        key: '_build',
        value: function _build () {
          var _this = this
          var config = this._processConfig()
          this.flickityInstance = new Flickity(this.element, config)
          this._validateDraggable()
          this.selectedIndex = this.flickityInstance.selectedIndex
          this.flickityInstance.on('resize', this._validateDraggable.bind(this))
          if (this.options.onSelect) {
            this.flickityInstance.on('select', function () {
              if (
                _this.selectedIndex !== _this.flickityInstance.selectedIndex
              ) {
                _this.options.onSelect(
                  _this.flickityInstance.selectedIndex,
                  _this.flickityInstance.selectedCell.element
                )
                _this.selectedIndex = _this.flickityInstance.selectedIndex
              }
            })
          }
          if (this.options.onSettle) {
            this.flickityInstance.on('settle', function (index) {
              _this.options.onSettle(
                index,
                _this.flickityInstance.selectedCell.element
              )
            })
          }
          if (this.options.onClick) {
            this.flickityInstance.on(
              'staticClick',
              function (event, pointer, cell, index) {
                _this.options.onClick(cell, index)
              }
            )
          }
        }
      },
      {
        key: '_validateDraggable',
        value: function _validateDraggable () {
          var isActive = this.flickityInstance.isActive || !1
          if (!isActive || !this.flickityInstance.options.draggable) {
            return
          }
          if (
            undefined === this.flickityInstance.selectedElements ||
            this.flickityInstance.selectedElements.length ===
              this.flickityInstance.cells.length
          ) {
            this.flickityInstance.unbindDrag()
          } else {
            this.flickityInstance.bindDrag()
          }
        }
      },
      {
        key: '_processConfig',
        value: function _processConfig () {
          var config = Object.assign({}, this.initialConfig)
          delete config.breakpoints
          if (this.initialConfig.breakpoints === undefined) {
            return config
          }
          var breakpoints = this.initialConfig.breakpoints
          breakpoints.forEach(function (breakpoint) {
            if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
              config = Object.assign(config, breakpoint['settings'])
            }
          })
          return config
        }
      },
      {
        key: '_onBreakpointChanged',
        value: function _onBreakpointChanged () {
          this.flickityInstance.destroy()
          this._build()
        }
      }
    ])
    return Carousel
  })()
  var Animation = (function () {
    function Animation () {
      _classCallCheck(this, Animation)
    }
    _createClass(Animation, null, [
      {
        key: 'slideUp',
        value: function slideUp (element) {
          element.style.height = ''.concat(element.scrollHeight, 'px')
          element.offsetHeight
          element.style.height = 0
        }
      },
      {
        key: 'slideDown',
        value: function slideDown (element) {
          if (element.style.height === 'auto') {
            return
          }
          element.style.height = ''.concat(
            element.firstElementChild.scrollHeight,
            'px'
          )
          var transitionEnded = function transitionEnded (event) {
            if (event.propertyName === 'height') {
              element.style.height = 'auto'
              element.removeEventListener('transitionend', transitionEnded)
            }
          }
          element.addEventListener('transitionend', transitionEnded)
        }
      }
    ])
    return Animation
  })()
  var Dom = (function () {
    function Dom () {
      _classCallCheck(this, Dom)
    }
    _createClass(Dom, null, [
      {
        key: 'getSiblings',
        value: function getSiblings (element, filter) {
          var includeSelf =
            arguments.length > 2 && arguments[2] !== undefined
              ? arguments[2]
              : !1
          var siblings = []
          var currentElement = element
          while ((currentElement = currentElement.previousElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement)
            }
          }
          if (includeSelf) {
            siblings.push(element)
          }
          currentElement = element
          while ((currentElement = currentElement.nextElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
              siblings.push(currentElement)
            }
          }
          return siblings
        }
      },
      {
        key: 'nodeListToArray',
        value: function nodeListToArray (nodeList, filter) {
          var items = []
          for (var i = 0; i !== nodeList.length; ++i) {
            if (!filter || nodeList[i].matches(filter)) {
              items.push(nodeList[i])
            }
          }
          return items
        }
      },
      {
        key: 'outerWidthWithMargin',
        value: function outerWidthWithMargin (element) {
          var width = element.offsetWidth,
            style = getComputedStyle(element)
          width += parseInt(style.marginLeft) + parseInt(style.marginRight)
          return width
        }
      },
      {
        key: 'outerHeightWithMargin',
        value: function outerHeightWithMargin (element) {
          var height = element.offsetHeight,
            style = getComputedStyle(element)
          height += parseInt(style.marginTop) + parseInt(style.marginBottom)
          return height
        }
      }
    ])
    return Dom
  })()
  var Collapsible = (function () {
    function Collapsible () {
      _classCallCheck(this, Collapsible)
      this.domDelegate = new domDelegate.Delegate(document.body)
      this._attachListeners()
    }
    _createClass(Collapsible, [
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.domDelegate.on(
            'click',
            '[data-action="toggle-collapsible"]',
            this._toggleCollapsible.bind(this)
          )
        }
      },
      {
        key: '_toggleCollapsible',
        value: function _toggleCollapsible (event, target) {
          var _this = this
          var parentCollapsible = target.closest('.Collapsible')
          if (
            parentCollapsible.classList.contains('Collapsible--autoExpand') &&
            Responsive.matchesBreakpoint('tablet-and-up')
          ) {
            return
          }
          var isOpen = target.getAttribute('aria-expanded') === 'true'
          if (isOpen) {
            this._close(parentCollapsible, target)
          } else {
            this._open(parentCollapsible, target)
          }
          Dom.getSiblings(parentCollapsible).forEach(function (
            collapsibleToClose
          ) {
            return _this._close(collapsibleToClose)
          })
          event.preventDefault()
        }
      },
      {
        key: '_open',
        value: function _open (collapsible) {
          var toggleButton = collapsible.querySelector('.Collapsible__Button'),
            collapsibleInner = collapsible.querySelector('.Collapsible__Inner')
          if (
            !collapsibleInner ||
            toggleButton.getAttribute('aria-expanded') === 'true'
          ) {
            return
          }
          toggleButton.setAttribute('aria-expanded', 'true')
          collapsibleInner.style.overflow = 'visible'
          Animation.slideDown(collapsibleInner)
          setTimeout(function () {
            collapsible.style.overflow = 'visible'
          }, 350)
        }
      },
      {
        key: '_close',
        value: function _close (collapsible) {
          var toggleButton = collapsible.querySelector('.Collapsible__Button'),
            collapsibleInner = collapsible.querySelector('.Collapsible__Inner')
          if (
            !collapsibleInner ||
            toggleButton.getAttribute('aria-expanded') === 'false'
          ) {
            return
          }
          toggleButton.setAttribute('aria-expanded', 'false')
          collapsibleInner.style.overflow = 'hidden'
          collapsible.style.overflow = 'hidden'
          Animation.slideUp(collapsibleInner)
        }
      }
    ])
    return Collapsible
  })()
  var Accessibility = (function () {
    function Accessibility () {
      _classCallCheck(this, Accessibility)
    }
    _createClass(Accessibility, null, [
      {
        key: 'trapFocus',
        value: function trapFocus (container, namespace) {
          this.listeners = this.listeners || {}
          var elementToFocus =
            container.querySelector('[autofocus]') || container
          container.setAttribute('tabindex', '-1')
          elementToFocus.focus()
          this.listeners[namespace] = function (event) {
            if (
              container !== event.target &&
              !container.contains(event.target)
            ) {
              container.focus()
            }
          }
          document.addEventListener('focusin', this.listeners[namespace])
        }
      },
      {
        key: 'removeTrapFocus',
        value: function removeTrapFocus (container, namespace) {
          if (container) {
            container.removeAttribute('tabindex')
          }
          if (this.listeners && this.listeners[namespace]) {
            document.removeEventListener('focusin', this.listeners[namespace])
          }
        }
      },
      {
        key: 'clearTrapFocus',
        value: function clearTrapFocus () {
          for (var key in this.listeners) {
            if (this.listeners.hasOwnProperty(key)) {
              document.removeEventListener('focusin', this.listeners[key])
            }
          }
          this.listeners = {}
        }
      }
    ])
    return Accessibility
  })()
  var Drawer = (function () {
    function Drawer (element) {
      var options =
        arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}
      _classCallCheck(this, Drawer)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.delegateBody = new domDelegate.Delegate(document.body)
      this.onOpen = options.onOpen || function () {}
      this.onClose = options.onClose || function () {}
      this.isOpen = !1
      this.direction = this.element.classList.contains('Drawer--fromLeft')
        ? 'fromLeft'
        : 'fromRight'
      this.pageOverlayElement = document.querySelector('.PageOverlay')
      this._attachListeners()
    }
    _createClass(Drawer, [
      {
        key: 'destroy',
        value: function destroy () {
          this.delegateBody.off(
            'click',
            '[data-action="open-drawer"][data-drawer-id="'.concat(
              this.element.id,
              '"]'
            )
          )
          this.delegateBody.off(
            'click',
            '[data-action="close-drawer"][data-drawer-id="'.concat(
              this.element.id,
              '"]'
            )
          )
          window.removeEventListener('resize', this._calculateMaxHeightListener)
        }
      },
      {
        key: 'toggle',
        value: function toggle () {
          this.isOpen ? this.close() : this.open()
        }
      },
      {
        key: 'open',
        value: function open (event) {
          if (this.isOpen) {
            return
          }
          this.element.dispatchEvent(
            new CustomEvent('search:close', {
              bubbles: !0
            })
          )
          if (event) {
            event.preventDefault()
          }
          this.element.setAttribute('aria-hidden', 'false')
          this._calculateMaxHeight()
          document.documentElement.classList.add('no-scroll')
          Accessibility.trapFocus(this.element, 'drawer')
          document.querySelector('#shopify-section-header').style.zIndex = ''
          this.pageOverlayElement.classList.add('is-visible')
          this.pageOverlayElement.addEventListener('click', this._closeListener)
          this.isOpen = !0
          this.onOpen()
          return !1
        }
      },
      {
        key: 'close',
        value: function close (event) {
          if (!this.isOpen) {
            return
          }
          if (event) {
            event.preventDefault()
          }
          this.element.setAttribute('aria-hidden', 'true')
          document.documentElement.classList.remove('no-scroll')
          Accessibility.removeTrapFocus(this.element, 'drawer')
          this.pageOverlayElement.classList.remove('is-visible')
          this.pageOverlayElement.removeEventListener(
            'click',
            this._closeListener
          )
          this.isOpen = !1
          this.onClose()
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._openListener = this.open.bind(this)
          this._closeListener = this.close.bind(this)
          this._calculateMaxHeightListener = this._calculateMaxHeight.bind(this)
          this.delegateBody.on(
            'click',
            '[data-action="open-drawer"][data-drawer-id="'.concat(
              this.element.id,
              '"]'
            ),
            this._openListener
          )
          this.delegateBody.on(
            'click',
            '[data-action="close-drawer"][data-drawer-id="'.concat(
              this.element.id,
              '"]'
            ),
            this._closeListener
          )
          this.element.addEventListener(
            'keyup',
            this._handleKeyboard.bind(this)
          )
          window.addEventListener('resize', this._calculateMaxHeightListener)
        }
      },
      {
        key: '_calculateMaxHeight',
        value: function _calculateMaxHeight () {
          this.element.style.maxHeight = window.innerHeight + 'px'
        }
      },
      {
        key: '_handleKeyboard',
        value: function _handleKeyboard (event) {
          if (this.isOpen && event.keyCode === 27) {
            this.close()
          }
        }
      }
    ])
    return Drawer
  })()
  var LoadingBar = (function () {
    function LoadingBar () {
      _classCallCheck(this, LoadingBar)
      this.element = document.querySelector('.LoadingBar')
      document.addEventListener(
        'theme:loading:start',
        this._onLoadingStart.bind(this)
      )
      document.addEventListener(
        'theme:loading:end',
        this._onLoadingEnd.bind(this)
      )
      this.element.addEventListener(
        'transitionend',
        this._onTransitionEnd.bind(this)
      )
    }
    _createClass(LoadingBar, [
      {
        key: '_onLoadingStart',
        value: function _onLoadingStart () {
          this.element.classList.add('is-visible')
          this.element.style.width = '40%'
        }
      },
      {
        key: '_onLoadingEnd',
        value: function _onLoadingEnd () {
          this.element.style.width = '100%'
          this.element.classList.add('is-finished')
        }
      },
      {
        key: '_onTransitionEnd',
        value: function _onTransitionEnd (event) {
          if (
            event.propertyName === 'width' &&
            this.element.classList.contains('is-finished')
          ) {
            this.element.classList.remove('is-visible')
            this.element.classList.remove('is-finished')
            this.element.style.width = '0'
          }
        }
      }
    ])
    return LoadingBar
  })()
  var Modal = (function () {
    function Modal () {
      _classCallCheck(this, Modal)
      this.domDelegate = new domDelegate.Delegate(document.body)
      this.activeModal = null
      this.wasLocked = !1
      this.pageOverlayElement = document.querySelector('.PageOverlay')
      this._attachListeners()
      this._checkOpenByHash()
    }
    _createClass(Modal, [
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._closeListener = this._closeModal.bind(this)
          this._handleKeyboardListener = this._handleKeyboard.bind(this)
          this.domDelegate.on(
            'click',
            '[data-action="open-modal"]',
            this._openModalEvent.bind(this)
          )
          this.domDelegate.on(
            'click',
            '[data-action="close-modal"]',
            this._closeModal.bind(this)
          )
        }
      },
      {
        key: '_openModalEvent',
        value: function _openModalEvent (event, target) {
          this._openModal(
            document.getElementById(target.getAttribute('aria-controls'))
          )
          event.preventDefault()
          event.stopPropagation()
        }
      },
      {
        key: '_openModal',
        value: function _openModal (modal) {
          var _this = this
          if (this.activeModal || !modal) {
            return
          }
          this.activeModal = modal
          this.domDelegate.on('keyup', this._handleKeyboardListener)
          if (document.documentElement.classList.contains('no-scroll')) {
            this.wasLocked = !0
          }
          fastdom.mutate(function () {
            Accessibility.clearTrapFocus()
            _this._onTransitionEndedListener =
              _this._onTransitionEnded.bind(_this)
            _this.activeModal.addEventListener(
              'transitionend',
              _this._onTransitionEndedListener
            )
            _this.activeModal.setAttribute('aria-hidden', 'false')
            document.documentElement.classList.add('no-scroll')
            if (!_this.activeModal.classList.contains('Modal--fullScreen')) {
              _this.pageOverlayElement.classList.add('is-visible')
              _this.pageOverlayElement.addEventListener(
                'click',
                _this._closeListener
              )
            }
          })
        }
      },
      {
        key: '_closeModal',
        value: function _closeModal () {
          var _this2 = this
          if (!this.activeModal) {
            return
          }
          this.activeModal.removeEventListener(
            'keyup',
            this._handleKeyboardListener
          )
          this.domDelegate.off('keyup')
          fastdom.mutate(function () {
            if (_this2.activeModal.classList.contains('Modal--videoContent')) {
              _this2._resetVideoListener = _this2._resetVideo.bind(_this2)
              _this2.activeModal.addEventListener(
                'transitionend',
                _this2._resetVideoListener
              )
            }
            Accessibility.removeTrapFocus(_this2.activeModal, 'modal')
            if (!_this2.activeModal.classList.contains('Modal--fullScreen')) {
              _this2.pageOverlayElement.classList.remove('is-visible')
              _this2.pageOverlayElement.removeEventListener(
                'click',
                _this2._closeListener
              )
            }
            _this2.activeModal.setAttribute('aria-hidden', 'true')
            _this2.activeModal = null
            if (!_this2.wasLocked) {
              document.documentElement.classList.remove('no-scroll')
            }
          })
        }
      },
      {
        key: '_onTransitionEnded',
        value: function _onTransitionEnded (event) {
          if (event.propertyName !== 'visibility') {
            return
          }
          Accessibility.trapFocus(this.activeModal, 'modal')
          this.activeModal.removeEventListener(
            'transitionend',
            this._onTransitionEndedListener
          )
        }
      },
      {
        key: '_resetVideo',
        value: function _resetVideo (event) {
          if (event.propertyName !== 'visibility') {
            return
          }
          var iframe = event.target.querySelector('iframe')
          iframe.parentNode.innerHTML =
            '<iframe class="Image--lazyLoad" data-src='.concat(
              iframe.getAttribute('data-src'),
              ' frameborder="0" allowfullscreen>'
            )
          event.target.removeEventListener(
            'transitionend',
            this._resetVideoListener
          )
        }
      },
      {
        key: '_checkOpenByHash',
        value: function _checkOpenByHash () {
          var hash = window.location.hash,
            modal = document.getElementById(hash.replace('#', ''))
          if (modal && modal.classList.contains('Modal')) {
            this._openModal(modal)
          }
        }
      },
      {
        key: '_handleKeyboard',
        value: function _handleKeyboard (event) {
          if (null !== this.activeModal && event.keyCode === 27) {
            this._closeModal()
          }
        }
      }
    ])
    return Modal
  })()
  var Popover = (function () {
    function Popover (element, options) {
      _classCallCheck(this, Popover)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.activator =
        options.activator ||
        document.querySelector(
          '[aria-controls="'.concat(element.getAttribute('id'), '"]')
        )
      this.preferredPosition = options.preferredPosition || 'bottom'
      this.preferredAlignment = options.preferredAlignment || undefined
      this.threshold = options.threshold || 20
      this.isOpen = !1
      this.onValueChanged = options.onValueChanged || function () {}
      this.onOpen = options.onOpen || function () {}
      this.onClose = options.onClose || function () {}
      this.showOverlay =
        options.showOverlay === undefined ? !0 : options.showOverlay
      this.pageOverlayElement = document.querySelector('.PageOverlay')
      this._attachListeners()
    }
    _createClass(Popover, [
      {
        key: 'destroy',
        value: function destroy () {
          this.element.removeEventListener(
            'keyup',
            this._handleKeyboardListener
          )
          this.delegateElement.off('click')
          this.activator.removeEventListener('click', this._toggleListener)
        }
      },
      {
        key: 'toggle',
        value: function toggle () {
          this.isOpen ? this.close() : this.open()
        }
      },
      {
        key: 'open',
        value: function open () {
          var _this = this
          if (
            this.isOpen ||
            this.activator.getAttribute('aria-controls') !== this.element.id
          ) {
            return
          }
          this.element.setAttribute('aria-hidden', 'false')
          this.activator.setAttribute('aria-expanded', 'true')
          disableBodyScroll(!0, '[data-scrollable]')
          document.documentElement.classList.add('no-scroll')
          if (Responsive.matchesBreakpoint('lap-and-up')) {
            document.body.addEventListener('click', this._clickOutsideListener)
            this._position()
            this.element.setAttribute('tabindex', '-1')
            this.element.addEventListener(
              'transitionend',
              function () {
                _this.element.focus()
              },
              {
                once: !0
              }
            )
          } else {
            this.element.removeAttribute('style')
            if (this.showOverlay) {
              this.pageOverlayElement.classList.add('is-visible')
              this.pageOverlayElement.addEventListener(
                'click',
                this._closeListener
              )
            }
          }
          this.onOpen(this)
          this.isOpen = !0
        }
      },
      {
        key: 'close',
        value: function close () {
          if (!this.isOpen) {
            return
          }
          this.element.setAttribute('aria-hidden', 'true')
          this.activator.setAttribute('aria-expanded', 'false')
          disableBodyScroll(!1, '[data-scrollable]')
          document.documentElement.classList.remove('no-scroll')
          if (Responsive.matchesBreakpoint('lap-and-up')) {
            document.body.removeEventListener(
              'click',
              this._clickOutsideListener
            )
          } else if (this.showOverlay) {
            this.pageOverlayElement.classList.remove('is-visible')
            this.pageOverlayElement.removeEventListener(
              'click',
              this._closeListener
            )
          }
          this.element.removeAttribute('tabindex')
          this.activator.focus()
          this.onClose(this)
          this.isOpen = !1
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._handleKeyboardListener = this._handleKeyboard.bind(this)
          this._clickOutsideListener = this._clickOutside.bind(this)
          this._closeListener = this.close.bind(this)
          this._toggleListener = this.toggle.bind(this)
          this.element.addEventListener('keyup', this._handleKeyboardListener)
          this.activator &&
            this.activator.addEventListener('click', this._toggleListener)
          this.delegateElement.on(
            'click',
            '[data-action="close-popover"]',
            this.close.bind(this)
          )
          this.delegateElement.on(
            'click',
            '[data-action="select-value"]',
            this._valueChanged.bind(this)
          )
          if (this.element.hasAttribute('id')) {
            this.delegateElement.on(
              'focusout',
              '#'.concat(this.element.getAttribute('id')),
              this._onFocusOut.bind(this)
            )
          }
        }
      },
      {
        key: '_valueChanged',
        value: function _valueChanged (event) {
          Dom.getSiblings(event.target, '.is-selected').forEach(function (
            item
          ) {
            return item.classList.remove('is-selected')
          })
          event.target.classList.add('is-selected')
          this.onValueChanged(
            event.target.getAttribute('data-value'),
            event.target,
            this.activator
          )
          this.close()
        }
      },
      {
        key: '_onFocusOut',
        value: function _onFocusOut (event) {
          if (
            !this.element.contains(event.relatedTarget) &&
            event.relatedTarget !== this.activator
          ) {
            this.close()
          }
        }
      },
      {
        key: '_clickOutside',
        value: function _clickOutside (event) {
          if (
            !event.target.closest('.Popover') &&
            !event.target.closest('.Modal') &&
            event.target !== this.activator &&
            !this.activator.contains(event.target)
          ) {
            this.close()
          }
        }
      },
      {
        key: '_position',
        value: function _position () {
          var _this2 = this
          var topPosition = 0,
            rightPosition = 0,
            position = '',
            alignment = '',
            threshold = this.threshold
          fastdom.measure(function () {
            var windowHeight = window.innerHeight,
              activatorBoundingRect = _this2.activator.getBoundingClientRect(),
              halfHeight = windowHeight / 2
            if (_this2.preferredPosition === 'bottom') {
              alignment = 'right'
              if (
                _this2.element.clientHeight <=
                  windowHeight - (activatorBoundingRect.bottom + threshold) ||
                windowHeight - activatorBoundingRect.bottom >= halfHeight
              ) {
                position = 'bottom'
              } else {
                position = 'top'
              }
            } else if (_this2.preferredPosition === 'top') {
              alignment = 'right'
              if (
                _this2.element.clientHeight <=
                  activatorBoundingRect.top - threshold ||
                activatorBoundingRect.top >= halfHeight
              ) {
                position = 'top'
              } else {
                position = 'bottom'
              }
            } else {
              position = 'left'
              var halfElementHeight = _this2.element.clientHeight / 2
              if (
                activatorBoundingRect.top >= halfElementHeight &&
                windowHeight - activatorBoundingRect.bottom >= halfElementHeight
              ) {
                alignment = 'center'
              } else if (
                windowHeight - activatorBoundingRect.bottom >=
                halfElementHeight
              ) {
                alignment = 'bottom'
              } else {
                alignment = 'top'
              }
            }
            if (_this2.preferredAlignment) {
              alignment = _this2.preferredAlignment
            }
            if (position === 'top') {
              topPosition =
                activatorBoundingRect.top -
                _this2.element.clientHeight -
                threshold
              if (alignment === 'center') {
                rightPosition =
                  window.innerWidth -
                  activatorBoundingRect.right -
                  _this2.element.clientWidth / 2 +
                  3
              } else {
                rightPosition = window.innerWidth - activatorBoundingRect.right
              }
            } else if (position === 'bottom') {
              topPosition = activatorBoundingRect.bottom + threshold
              if (alignment === 'center') {
                rightPosition =
                  window.innerWidth -
                  activatorBoundingRect.right -
                  _this2.element.clientWidth / 2 +
                  3
              } else {
                rightPosition = window.innerWidth - activatorBoundingRect.right
              }
            } else {
              rightPosition =
                window.innerWidth - activatorBoundingRect.left + threshold
              if (alignment === 'center') {
                topPosition =
                  activatorBoundingRect.top -
                  _this2.element.clientHeight / 2 +
                  _this2.activator.clientHeight / 2
              } else if (alignment === 'top') {
                topPosition =
                  activatorBoundingRect.bottom - _this2.element.clientHeight
              } else {
                topPosition = activatorBoundingRect.top
              }
            }
          })
          fastdom.mutate(function () {
            ;[
              'Popover--positionBottom',
              'Popover--positionTop',
              'Popover--positionCenter',
              'Popover--alignTop',
              'Popover--alignCenter',
              'Popover--alignBottom'
            ].map(function (item) {
              return _this2.element.classList.remove(item)
            })
            _this2.element.classList.add(
              'Popover--position'.concat(
                position.charAt(0).toUpperCase() + position.slice(1)
              )
            )
            _this2.element.classList.add(
              'Popover--align'.concat(
                alignment.charAt(0).toUpperCase() + alignment.slice(1)
              )
            )
            _this2.element.setAttribute(
              'style',
              'top: '
                .concat(parseInt(topPosition), 'px; right: ')
                .concat(parseInt(rightPosition), 'px;')
            )
          })
        }
      },
      {
        key: '_handleKeyboard',
        value: function _handleKeyboard (event) {
          if (this.isOpen && event.keyCode === 27) {
            this.close()
          }
        }
      }
    ])
    return Popover
  })()
  var PageTransition = (function () {
    function PageTransition () {
      _classCallCheck(this, PageTransition)
      this.domDelegate = new domDelegate.Delegate(document.body)
      this.pageTransition = document.querySelector('.PageTransition')
      this._attachListeners()
    }
    _createClass(
      PageTransition,
      [
        {
          key: '_attachListeners',
          value: function _attachListeners () {
            this.domDelegate.on(
              'click',
              'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])',
              this._onPageUnload.bind(this)
            )
          }
        },
        {
          key: '_onPageUnload',
          value: function _onPageUnload (event, target) {
            var _this = this
            if (
              event.defaultPrevented ||
              event.ctrlKey ||
              event.metaKey ||
              !window.theme.showPageTransition ||
              !this.pageTransition
            ) {
              return
            }
            event.preventDefault()
            if (window.theme.showPageTransition && this.pageTransition) {
              var doTransition = function doTransition (event) {
                if (event.propertyName === 'opacity') {
                  _this.pageTransition.removeEventListener(
                    'transitionend',
                    doTransition
                  )
                  window.location.href = target.href
                }
              }
              this.pageTransition.addEventListener(
                'transitionend',
                doTransition
              )
              this.pageTransition.style.visibility = 'visible'
              this.pageTransition.style.opacity = '1'
            }
          }
        }
      ],
      [
        {
          key: 'getInstance',
          value: function getInstance () {
            if (!this.instance) {
              this.instance = new PageTransition()
            }
            return this.instance
          }
        }
      ]
    )
    return PageTransition
  })()
  var ProductItemColorSwatch = (function () {
    function ProductItemColorSwatch (element) {
      _classCallCheck(this, ProductItemColorSwatch)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.delegateElement.on(
        'change',
        '.ColorSwatch__Radio',
        this._colorChanged.bind(this)
      )
    }
    _createClass(ProductItemColorSwatch, [
      {
        key: '_colorChanged',
        value: function _colorChanged (event, target) {
          var productItem = target.closest('.ProductItem'),
            variantUrl = target.getAttribute('data-variant-url')
          productItem
            .querySelector('.ProductItem__ImageWrapper')
            .setAttribute('href', variantUrl)
          productItem
            .querySelector('.ProductItem__Title > a')
            .setAttribute('href', variantUrl)
          var originalImageElement = productItem.querySelector(
            '.ProductItem__Image:not(.ProductItem__Image--alternate)'
          )
          if (
            target.hasAttribute('data-image-url') &&
            target.getAttribute('data-image-id') !==
              originalImageElement.getAttribute('data-image-id')
          ) {
            var newImageElement = document.createElement('img')
            newImageElement.className =
              'ProductItem__Image Image--fadeIn Image--lazyLoad'
            newImageElement.setAttribute(
              'data-image-id',
              target.getAttribute('data-image-id')
            )
            newImageElement.setAttribute(
              'data-src',
              target.getAttribute('data-image-url')
            )
            newImageElement.setAttribute(
              'data-widths',
              target.getAttribute('data-image-widths')
            )
            newImageElement.setAttribute('data-sizes', 'auto')
            if (window.theme.productImageSize === 'natural') {
              originalImageElement.parentNode.style.paddingBottom = ''.concat(
                100.0 / target.getAttribute('data-image-aspect-ratio'),
                '%'
              )
            }
            originalImageElement.parentNode.style.setProperty(
              '--aspect-ratio',
              target.getAttribute('data-image-aspect-ratio')
            )
            originalImageElement.parentNode.replaceChild(
              newImageElement,
              originalImageElement
            )
          }
        }
      }
    ])
    return ProductItemColorSwatch
  })()
  var Image = (function () {
    function Image () {
      _classCallCheck(this, Image)
    }
    _createClass(Image, null, [
      {
        key: 'getSizedImageUrl',
        value: function getSizedImageUrl (src, size) {
          if (size === null) {
            return src
          }
          if (size === 'master') {
            return src.replace(/http(s)?:/, '')
          }
          var match = src.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
          )
          if (match) {
            var prefix = src.split(match[0])
            var suffix = match[0]
            return (prefix[0] + '_' + size + suffix).replace(/http(s)?:/, '')
          } else {
            return null
          }
        }
      },
      {
        key: 'getSupportedSizes',
        value: function getSupportedSizes (image, desiredSizes) {
          var supportedSizes = [],
            imageWidth = image.width
          desiredSizes.forEach(function (width) {
            if (imageWidth >= width) {
              supportedSizes.push(width)
            }
          })
          return supportedSizes
        }
      }
    ])
    return Image
  })()
  var ProductImageZoom = (function () {
    function ProductImageZoom (element, slideshow) {
      _classCallCheck(this, ProductImageZoom)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.delegateRoot = new domDelegate.Delegate(document.body)
      this.slideshow = slideshow
      this._attachListeners()
    }
    _createClass(ProductImageZoom, [
      {
        key: 'destroy',
        value: function destroy () {
          this.delegateElement.off('click')
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'click',
            '[data-action="open-product-zoom"]',
            this._initPhotoSwipe.bind(this)
          )
          this.delegateElement.on(
            'click',
            '.Product__SlideItem--image',
            this._initPhotoSwipeFromImageClick.bind(this)
          )
        }
      },
      {
        key: '_initPhotoSwipe',
        value: function _initPhotoSwipe () {
          var images = []
          this.slideshow.flickityInstance.cells.forEach(function (item) {
            if (
              item.element.classList.contains('Product__SlideItem--image') &&
              !item.element.classList.contains('.HideVariant__Image')
            ) {
              images.push(item.element.querySelector('img'))
            }
          })
          this._createPhotoSwipeInstance(
            this._createPhotoSwipeItemsFromImages(images),
            parseInt(
              this.slideshow.flickityInstance.selectedElement.getAttribute(
                'data-image-media-position'
              )
            )
          )
        }
      },
      {
        key: '_initPhotoSwipeFromImageClick',
        value: function _initPhotoSwipeFromImageClick (event, target) {
          var images = Dom.nodeListToArray(
            this.element.querySelectorAll(
              '.Product__SlideItem--image:not(.HideVariant__Image) img'
            )
          )
          this._createPhotoSwipeInstance(
            this._createPhotoSwipeItemsFromImages(images),
            parseInt(target.getAttribute('data-image-media-position'))
          )
        }
      },
      {
        key: '_createPhotoSwipeItemsFromImages',
        value: function _createPhotoSwipeItemsFromImages (images) {
          return images.map(function (image) {
            var maxWidth = parseInt(image.getAttribute('data-max-width')),
              maxHeight = parseInt(image.getAttribute('data-max-height')),
              maxDimension = Responsive.matchesBreakpoint('phone')
                ? 1200
                : 1800,
              reduceFactor = 1.0
            if (maxWidth >= maxHeight) {
              reduceFactor = Math.max(maxWidth / maxDimension, 1.0)
            } else {
              reduceFactor = Math.max(maxHeight / maxDimension, 1.0)
            }
            var requestedWidth = Math.floor(maxWidth / reduceFactor)
            var requestedHeight = Math.floor(maxHeight / reduceFactor)
            return {
              msrc: image.currentSrc || image.src,
              w: requestedWidth,
              h: requestedHeight,
              initialZoomLevel: 0.65,
              src: Image.getSizedImageUrl(
                image.getAttribute('data-original-src'),
                requestedWidth + 'x' + requestedHeight
              )
            }
          })
        }
      },
      {
        key: '_createPhotoSwipeInstance',
        value: function _createPhotoSwipeInstance (items, selectedImageIndex) {
          var _this = this
          var photoswipeContainer = document.querySelector('.pswp')
          this.photoSwipeInstance = new PhotoSwipe(
            photoswipeContainer,
            !1,
            items,
            {
              index: selectedImageIndex,
              showHideOpacity: !0,
              showAnimationDuration: 500,
              loop: !1,
              history: !1,
              closeOnVerticalDrag: !1,
              allowPanToNext: !1,
              pinchToClose: !1,
              errorMsg:
                '<p class="pswp__error-msg">' +
                window.languages.productImageLoadingError +
                '</p>',
              scaleMode: 'zoom',
              getDoubleTapZoom: function getDoubleTapZoom (isMouseClick, item) {
                if (isMouseClick) {
                  return 1.6
                } else {
                  return item.initialZoomLevel < 0.7 ? 1 : 1.33
                }
              },
              getThumbBoundsFn: function getThumbBoundsFn (index) {
                var selectThumb = _this.element.querySelectorAll(
                  '.Product__Slideshow .Product__SlideItem--image:not(.HideVariant__Image)'
                )[index]
                var thumbnail = selectThumb.querySelector('img')
                var pageYScroll =
                  window.pageYOffset || document.documentElement.scrollTop
                var rect = thumbnail.getBoundingClientRect()
                return {
                  x: rect.left,
                  y: rect.top + pageYScroll,
                  w: rect.width
                }
              }
            }
          )
          var originalUpdateSize = this.photoSwipeInstance.updateSize,
            lastWidth = null
          this.photoSwipeInstance.updateSize = function () {
            if (lastWidth === null || lastWidth !== window.innerWidth) {
              originalUpdateSize(this, arguments)
            }
            lastWidth = window.innerWidth
          }
          this.photoSwipeInstance.listen(
            'beforeChange',
            this._onSlideChanged.bind(this)
          )
          this.photoSwipeInstance.listen(
            'destroy',
            this._destroyPhotoSwipe.bind(this)
          )
          this.photoSwipeInstance.listen(
            'doubleTap',
            this._onDoubleTap.bind(this)
          )
          this.photoSwipeInstance.listen(
            'initialZoomIn',
            this._onInitialZoomIn.bind(this)
          )
          this.photoSwipeInstance.listen(
            'initialZoomOut',
            this._onInitialZoomOut.bind(this)
          )
          this.delegateRoot.on(
            'pswpTap',
            '.pswp__scroll-wrap',
            this._onSingleTap.bind(this)
          )
          this.delegateRoot.on(
            'pswpTap',
            '.pswp__button--close',
            this.photoSwipeInstance.close
          )
          this.delegateRoot.on(
            'pswpTap',
            '.pswp__button--prev',
            this.photoSwipeInstance.prev
          )
          this.delegateRoot.on(
            'pswpTap',
            '.pswp__button--next',
            this.photoSwipeInstance.next
          )
          this.photoSwipeInstance.init()
        }
      },
      {
        key: '_onSlideChanged',
        value: function _onSlideChanged () {
          if (this.photoSwipeInstance.getCurrentIndex() === 0) {
            this.photoSwipeInstance.scrollWrap
              .querySelector('.pswp__button--prev')
              .setAttribute('disabled', 'disabled')
          } else {
            this.photoSwipeInstance.scrollWrap
              .querySelector('.pswp__button--prev')
              .removeAttribute('disabled')
          }
          if (
            this.photoSwipeInstance.getCurrentIndex() + 1 ===
            this.photoSwipeInstance.options.getNumItemsFn()
          ) {
            this.photoSwipeInstance.scrollWrap
              .querySelector('.pswp__button--next')
              .setAttribute('disabled', 'disabled')
          } else {
            this.photoSwipeInstance.scrollWrap
              .querySelector('.pswp__button--next')
              .removeAttribute('disabled')
          }
        }
      },
      {
        key: '_onSingleTap',
        value: function _onSingleTap (event) {
          if (!event.detail || event.detail.pointerType === 'mouse') {
            if (event.target.classList.contains('pswp__img')) {
              this.photoSwipeInstance.toggleDesktopZoom(
                event.detail.releasePoint
              )
            }
          } else {
            if (event.target.classList.contains('pswp__button')) {
              return
            }
            event.target
              .closest('.pswp')
              .querySelector('.pswp__ui')
              .classList.toggle('pswp__ui--hidden')
          }
        }
      },
      {
        key: '_onDoubleTap',
        value: function _onDoubleTap (point) {
          var initialZoomLevel =
            this.photoSwipeInstance.currItem.initialZoomLevel
          if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
            this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333)
          } else {
            this.photoSwipeInstance.zoomTo(
              initialZoomLevel < 0.7 ? 1 : 1.33,
              point,
              333
            )
          }
        }
      },
      {
        key: '_onInitialZoomIn',
        value: function _onInitialZoomIn () {
          document
            .querySelector('.pswp__ui')
            .classList.remove('pswp__ui--hidden')
        }
      },
      {
        key: '_onInitialZoomOut',
        value: function _onInitialZoomOut () {
          document.querySelector('.pswp__ui').classList.add('pswp__ui--hidden')
        }
      },
      {
        key: '_destroyPhotoSwipe',
        value: function _destroyPhotoSwipe () {
          this.delegateRoot.off('pswpTap')
          this.photoSwipeInstance = null
        }
      }
    ])
    return ProductImageZoom
  })()
  var ProductModel = (function () {
    function ProductModel (element, stackProductImages) {
      _classCallCheck(this, ProductModel)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.delegateRoot = new domDelegate.Delegate(document.documentElement)
      this.stackProductImages = stackProductImages
      this._attachListeners()
      var stylesheet = document.createElement('link')
      stylesheet.rel = 'stylesheet'
      stylesheet.href =
        'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css'
      document.head.appendChild(stylesheet)
      window.Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this._setupModelViewerUI.bind(this)
        },
        {
          name: 'shopify-xr',
          version: '1.0'
        }
      ])
    }
    _createClass(ProductModel, [
      {
        key: 'destroy',
        value: function destroy () {}
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          var _this = this
          this.element
            .querySelector('model-viewer')
            .addEventListener(
              'shopify_model_viewer_ui_toggle_play',
              function () {
                _this.element.dispatchEvent(
                  new CustomEvent('model:played', {
                    bubbles: !0
                  })
                )
              }
            )
          this.element
            .querySelector('model-viewer')
            .addEventListener(
              'shopify_model_viewer_ui_toggle_pause',
              function () {
                _this.element.dispatchEvent(
                  new CustomEvent('model:paused', {
                    bubbles: !0
                  })
                )
              }
            )
        }
      },
      {
        key: 'hasBeenSelected',
        value: function hasBeenSelected () {
          if (Responsive.matchesBreakpoint('supports-hover')) {
            this.modelUi.play()
          }
        }
      },
      {
        key: 'hasBeenDeselected',
        value: function hasBeenDeselected () {
          this.modelUi.pause()
        }
      },
      {
        key: '_setupModelViewerUI',
        value: function _setupModelViewerUI () {
          this.modelElement = this.element.querySelector('model-viewer')
          this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement)
        }
      }
    ])
    return ProductModel
  })()
  var ProductReviews = (function () {
    function ProductReviews (container) {
      _classCallCheck(this, ProductReviews)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.delegateElement.on(
        'click',
        '.spr-summary-actions-newreview',
        this._onNewReviewClicked.bind(this)
      )
      window.SPRCallbacks = {}
      window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this)
      window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this)
    }
    _createClass(ProductReviews, [
      {
        key: 'destroy',
        value: function destroy () {
          this.delegateElement.off()
        }
      },
      {
        key: '_updatePagination',
        value: function _updatePagination (event, target) {
          SPR.$(target).data(
            'page',
            parseInt(target.getAttribute('data-page')) + 1
          )
        }
      },
      {
        key: '_onFormSuccess',
        value: function _onFormSuccess () {
          var formSuccess = this.element.querySelector(
            '.spr-form-message-success'
          )
          window.scrollTo(0, formSuccess.offsetTop - 45)
        }
      },
      {
        key: '_onReviewsLoad',
        value: function _onReviewsLoad () {
          var sprSummaryActions = this.element.querySelector(
              '.spr-summary-actions'
            ),
            previousSprPaginationNext = sprSummaryActions.querySelector(
              '.spr-pagination-next'
            ),
            sprPaginationNext = this.element.querySelector(
              '.spr-pagination .spr-pagination-next'
            )
          if (previousSprPaginationNext) {
            previousSprPaginationNext.remove()
          }
          if (sprPaginationNext) {
            sprSummaryActions.insertBefore(
              sprPaginationNext,
              sprSummaryActions.firstChild
            )
          }
        }
      },
      {
        key: '_onNewReviewClicked',
        value: function _onNewReviewClicked (event, target) {
          target.style.display = 'none'
          if (target.previousElementSibling) {
            target.previousElementSibling.style.display = 'none'
          }
        }
      }
    ])
    return ProductReviews
  })()
  var Form = (function () {
    function Form () {
      _classCallCheck(this, Form)
    }
    _createClass(Form, null, [
      {
        key: 'serialize',
        value: function serialize (form) {
          function stringKey (key, value) {
            var beginBracket = key.lastIndexOf('[')
            if (beginBracket === -1) {
              var _hash = {}
              _hash[key] = value
              return _hash
            }
            var newKey = key.substr(0, beginBracket)
            var newValue = {}
            newValue[key.substring(beginBracket + 1, key.length - 1)] = value
            return stringKey(newKey, newValue)
          }
          var hash = {}
          for (var i = 0, len = form.elements.length; i < len; i++) {
            var formElement = form.elements[i]
            if (formElement.name === '' || formElement.disabled) {
              continue
            }
            if (
              formElement.name &&
              !formElement.disabled &&
              (formElement.checked ||
                /select|textarea/i.test(formElement.nodeName) ||
                /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                  formElement.type
                ))
            ) {
              var stringKeys = stringKey(formElement.name, formElement.value)
              hash = Form.extend(hash, stringKeys)
            }
          }
          return hash
        }
      },
      {
        key: 'extend',
        value: function extend () {
          var extended = {}
          var i = 0
          var merge = function merge (obj) {
            for (var prop in obj) {
              if (obj.hasOwnProperty(prop)) {
                if (
                  Object.prototype.toString.call(obj[prop]) ===
                  '[object Object]'
                ) {
                  extended[prop] = Form.extend(extended[prop], obj[prop])
                } else {
                  extended[prop] = obj[prop]
                }
              }
            }
          }
          for (; i < arguments.length; i++) {
            merge(arguments[i])
          }
          return extended
        }
      }
    ])
    return Form
  })()
  var Currency = (function () {
    function Currency () {
      _classCallCheck(this, Currency)
    }
    _createClass(Currency, null, [
      {
        key: 'formatMoney',
        value: function formatMoney (cents, format) {
          if (typeof cents === 'string') {
            cents = cents.replace('.', '')
          }
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || '${{amount}}'

          function defaultTo (value, defaultValue) {
            return value == null || value !== value ? defaultValue : value
          }

          function formatWithDelimiters (number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2)
            thousands = defaultTo(thousands, ',')
            decimal = defaultTo(decimal, '.')
            if (isNaN(number) || number == null) {
              return 0
            }
            number = (number / 100.0).toFixed(precision)
            var parts = number.split('.'),
              dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1' + thousands
              ),
              centsAmount = parts[1] ? decimal + parts[1] : ''
            return dollarsAmount + centsAmount
          }
          var value = ''
          var withDecimal = !1
          switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2)
              withDecimal = !0
              break
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0)
              break
            case 'amount_with_space_separator':
              value = formatWithDelimiters(cents, 2, ' ', '.')
              break
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, ',', '.')
              break
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ')
              break
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',')
              break
          }
          if (formatString.indexOf('with_comma_separator') !== -1) {
            return formatString
              .replace(placeholderRegex, value)
              .replace(',00', '')
          } else {
            if (withDecimal) {
              return formatString.replace(placeholderRegex, value)
            } else {
              return formatString
                .replace(placeholderRegex, value)
                .replace('.00', '')
            }
          }
        }
      }
    ])
    return Currency
  })()
  // var VariantSelector = function() {
  //     function VariantSelector(element, parentProductVariants) {
  //         var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  //         _classCallCheck(this, VariantSelector);
  //         this.element = element;
  //         this.parentProductVariants = parentProductVariants;
  //         this.delegateElement = new domDelegate.Delegate(this.element);
  //         this.activator = options.activator || document.querySelector("[aria-controls=\"".concat(element.getAttribute('id'), "\"]"));
  //         this.onValueChangedCallback = options.onValueChanged || function() {};
  //         this.isOpen = !1;
  //         this.pageOverlayElement = document.querySelector('.PageOverlay');
  //         this.variantChoiceList = Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__Choice'));
  //         this.variantCarousel = new Carousel(this.element.querySelector('.VariantSelector__Carousel'), {
  //             onSelect: this._variantChanged.bind(this),
  //             onClick: this._variantSelected.bind(this)
  //         });
  //         this._attachListeners()
  //     }
  //     _createClass(VariantSelector, [{
  //         key: "destroy",
  //         value: function destroy() {
  //             this.element.removeEventListener('keyup', this._handleKeyboardListener);
  //             this.delegateElement.off('click');
  //             this.activator.removeEventListener('click', this._toggleListener);
  //             this.variantCarousel.destroy()
  //         }
  //     }, {
  //         key: "toggle",
  //         value: function toggle() {
  //             this.isOpen ? this.close() : this.open()
  //         }
  //     }, {
  //         key: "open",
  //         value: function open() {
  //             if (this.isOpen) {
  //                 return
  //             }
  //             this.element.setAttribute('aria-hidden', 'false');
  //             this.activator.setAttribute('aria-expanded', 'true');
  //             Accessibility.trapFocus(this.element, 'variant-selector');
  //             document.documentElement.classList.add('no-scroll');
  //             this.element.setAttribute('style', '');
  //             this.pageOverlayElement.classList.add('is-visible');
  //             this.pageOverlayElement.addEventListener('click', this._closeListener);
  //             this.isOpen = !0
  //         }
  //     }, {
  //         key: "close",
  //         value: function close() {
  //             if (!this.isOpen) {
  //                 return
  //             }
  //             this.element.setAttribute('aria-hidden', 'true');
  //             this.activator.setAttribute('aria-expanded', 'false');
  //             Accessibility.removeTrapFocus(this.element, 'variant-selector');
  //             document.documentElement.classList.remove('no-scroll');
  //             this.pageOverlayElement.classList.remove('is-visible');
  //             this.pageOverlayElement.removeEventListener('click', this._closeListener);
  //             this.isOpen = !1
  //         }
  //     }, {
  //         key: "_attachListeners",
  //         value: function _attachListeners() {
  //             this._handleKeyboardListener = this._handleKeyboard.bind(this);
  //             this._closeListener = this.close.bind(this);
  //             this._toggleListener = this.toggle.bind(this);
  //             this.element.addEventListener('keyup', this._handleKeyboardListener);
  //             this.activator.addEventListener('click', this._toggleListener);
  //             this.delegateElement.on('click', '[data-action="select-variant"]', this._onVariantSelect.bind(this));
  //             this.parentProductVariants.delegateElement.on('variant:changed', this._onVariantChanged.bind(this))
  //         }
  //     }, {
  //         key: "_variantChanged",
  //         value: function _variantChanged(selectedIndex) {
  //             var activeChoice = this.variantChoiceList[selectedIndex];
  //             activeChoice.classList.add('is-selected');
  //             Dom.getSiblings(activeChoice, '.is-selected').forEach(function(item) {
  //                 return item.classList.remove('is-selected')
  //             })
  //         }
  //     }, {
  //         key: "_variantSelected",
  //         value: function _variantSelected(cellElement, cellIndex) {
  //             if (this.variantCarousel.getSelectedIndex() === cellIndex) {
  //                 this.onValueChangedCallback(cellElement.getAttribute('data-option-value'), cellElement, this.activator);
  //                 this.close()
  //             } else {
  //                 this.variantCarousel.selectCell(cellIndex)
  //             }
  //         }
  //     }, {
  //         key: "_onVariantChanged",
  //         value: function _onVariantChanged(event) {
  //             var _this = this;
  //             var selectedVariant = event.detail.variant,
  //                 imageWrapperElements = this.element.querySelectorAll('.VariantSelector__ImageWrapper'),
  //                 found = !1;
  //             Dom.nodeListToArray(imageWrapperElements).forEach(function(image) {
  //                 var colorPosition = parseInt(image.parentElement.getAttribute('data-option-position')) - 1,
  //                     combinationExcludedColor = '';
  //                 selectedVariant.options.forEach(function(optionValue, index) {
  //                     if (index !== colorPosition) {
  //                         combinationExcludedColor += optionValue
  //                     }
  //                 });
  //                 if (image.getAttribute('data-variant-title') === combinationExcludedColor) {
  //                     image.setAttribute('aria-hidden', 'false');
  //                     found = !0
  //                 } else {
  //                     image.setAttribute('aria-hidden', 'true')
  //                 }
  //             });
  //             if (!found) {
  //                 imageWrapperElements.children[0].setAttribute('aria-hidden', 'false')
  //             }
  //             var foundColorIndex = 0;
  //             Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector__ChoicePrice')).forEach(function(priceElement, index) {
  //                 var colorPosition = parseInt(priceElement.getAttribute('data-color-position')) - 1;
  //                 _this.parentProductVariants.productData.variants.forEach(function(variant) {
  //                     var matchOptionsExcludedColor = !0;
  //                     variant.options.forEach(function(option, index) {
  //                         if (index !== colorPosition) {
  //                             if (variant.options[index] !== selectedVariant.options[index]) {
  //                                 matchOptionsExcludedColor = !1
  //                             }
  //                         }
  //                     });
  //                     if (matchOptionsExcludedColor && variant.options[colorPosition] === selectedVariant.options[colorPosition]) {
  //                         if (foundColorIndex++ === index) {
  //                             priceElement.innerHTML = "<span class=\"Heading Text--subdued\">".concat(Currency.formatMoney(variant.price, window.theme.moneyFormat), "</span>")
  //                         }
  //                     }
  //                 })
  //             })
  //         }
  //     }, {
  //         key: "_onVariantSelect",
  //         value: function _onVariantSelect() {
  //             var selectedCell = this.variantCarousel.flickityInstance.selectedCell.element;
  //             this.onValueChangedCallback(selectedCell.getAttribute('data-option-value'), selectedCell, this.activator);
  //             this.close()
  //         }
  //     }, {
  //         key: "_handleKeyboard",
  //         value: function _handleKeyboard(event) {
  //             if (this.isOpen && event.keyCode === 27) {
  //                 this.close()
  //             }
  //         }
  //     }]);
  //     return VariantSelector
  // }();
  var StoreAvailability = (function () {
    function StoreAvailability (element, productTitle) {
      _classCallCheck(this, StoreAvailability)
      this.element = element
      this.productTitle = productTitle
      this.existingDrawers = {}
    }
    _createClass(StoreAvailability, [
      {
        key: 'updateWithVariant',
        value: function updateWithVariant (variant) {
          if (!this.element) {
            return
          }
          if (!variant) {
            this.element.textContent = ''
            return
          }
          this._renderAvailabilitySection(variant.id)
        }
      },
      {
        key: '_renderAvailabilitySection',
        value: function _renderAvailabilitySection (id) {
          var _this = this
          this.element.innerHTML = ''
          var availabilityModal = document.getElementById(
            'StoreAvailabilityModal-'.concat(id)
          )
          if (availabilityModal) {
            availabilityModal.remove()
          }
          if (this.existingDrawers['StoreAvailabilityModal-'.concat(id)]) {
            this.existingDrawers['StoreAvailabilityModal-'.concat(id)].destroy()
            delete this.existingDrawers['StoreAvailabilityModal-'.concat(id)]
          }
          return fetch(
            ''
              .concat(window.routes.rootUrlWithoutSlash, '/variants/')
              .concat(id, '?section_id=store-availability')
          ).then(function (response) {
            return response.text().then(function (content) {
              _this.element.innerHTML = content
              _this.element.innerHTML =
                _this.element.firstElementChild.innerHTML
              var productTitle = _this.element.querySelector(
                '.store-availabilities-modal__product-title'
              )
              if (productTitle) {
                productTitle.textContent = _this.productTitle
              }
              var availabilityModal = document.getElementById(
                'StoreAvailabilityModal-'.concat(id)
              )
              document.body.appendChild(availabilityModal)
              _this.existingDrawers['StoreAvailabilityModal-'.concat(id)] =
                new Drawer(availabilityModal)
            })
          })
        }
      }
    ])
    return StoreAvailability
  })()
  /*var ProductVariants = function() {
        function ProductVariants(container, options) {
            var _this = this;
            _classCallCheck(this, ProductVariants);
            this.element = container;
            this.delegateElement = new domDelegate.Delegate(this.element);
            this.options = options;
            var jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
            this.productData = jsonData.product;
            this.variantsInventories = jsonData.inventories || {};
            this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData.id));
            this.productData.variants.forEach(function(variant) {
                if (variant.id === jsonData.selected_variant_id) {
                    _this.currentVariant = variant;
                    _this.option1 = variant.option1;
                    _this.option2 = variant.option2;
                    _this.option3 = variant.option3
                }
            });
            this.storeAvailability = new StoreAvailability(this.element.querySelector('.ProductMeta__StoreAvailabilityContainer'), this.productData.title);
            this.storeAvailability.updateWithVariant(this.currentVariant);
            this._attachListeners();
            this._createSelectors()
        }
        _createClass(ProductVariants, [{
            key: "destroy",
            value: function destroy() {
                this.delegateElement.off('click');
                this.formPopovers.forEach(function(popover) {
                    return popover.destroy()
                });
                this.formVariantSelectors.forEach(function(selector) {
                    return selector.destroy()
                })
            }
        }, {
            key: "_attachListeners",
            value: function _attachListeners() {
                this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
                this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
                this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
                this.delegateElement.on('change', '[name="quantity"]', this._validateQuantity.bind(this));
                this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this))
            }
        }, {
            key: "_createSelectors",
            value: function _createSelectors() {
                var _this2 = this;
                this.formPopovers = [];
                this.formVariantSelectors = [];
                Dom.nodeListToArray(this.element.querySelectorAll('.OptionSelector')).forEach(function(item) {
                    var popover = new Popover(item, {
                        preferredPosition: 'left',
                        onValueChanged: _this2._onOptionChanged.bind(_this2)
                    });
                    _this2.formPopovers.push(popover)
                });
                Dom.nodeListToArray(this.element.querySelectorAll('.VariantSelector')).forEach(function(item) {
                    var variantSelector = new VariantSelector(item, _this2, {
                        onValueChanged: _this2._onOptionChanged.bind(_this2)
                    });
                    _this2.formVariantSelectors.push(variantSelector)
                })
            }
        }, {
            key: "_onVariantChanged",
            value: function _onVariantChanged(previousVariant, newVariant) {
                this._updateProductPrices(newVariant, previousVariant);
                this._updateInventory(newVariant, previousVariant);
                this._updateSku(newVariant, previousVariant);
                this._updateUnitPrice(newVariant, previousVariant);
                this._updateAddToCartButton(newVariant, previousVariant);
                this._updateMetafields(newVariant, previousVariant);
                this.storeAvailability.updateWithVariant(newVariant);
                this.element.dispatchEvent(new CustomEvent('variant:changed', {
                    bubbles: !0,
                    detail: {
                        variant: newVariant,
                        previousVariant: previousVariant
                    }
                }))
            }
        }, {
            key: "_updateProductPrices",
            value: function _updateProductPrices(newVariant, previousVariant) {
                var productMetaPrices = this.element.querySelectorAll('.ProductMeta__PriceList'),
                    currencyFormat = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
                if (!productMetaPrices) {
                    return
                }
                productMetaPrices.forEach((priceCont) => {
                    if (!newVariant) {} else {
                        priceCont.innerHTML = '';
                        if (newVariant.compare_at_price > newVariant.price) {
                            priceCont.innerHTML += '<span class=" Price--compareAt u-h4 Price--highlight" style="color: var(--heading-color) !important; margin-left: 10px !important;margin-right: 10px !important;"> '.concat(Currency.formatMoney(newVariant.compare_at_price, currencyFormat), "</span>");
                            priceCont.innerHTML += "<span class=\"ProductMeta__Price Price Price--highlight u-h4\" data-money-convertible>  ".concat(Currency.formatMoney(newVariant.price, currencyFormat), "</span>")
                        } else {
                            priceCont.innerHTML += "  <span class=\"ProductMeta__Price Price u-h4\" data-money-convertible>".concat(Currency.formatMoney(newVariant.price, currencyFormat), "</span>")
                        }
                        priceCont.style.display = ''
                    }
                });
                console.log('_updateProductPrices')
            }
        }, {
            key: "_updateInventory",
            value: function _updateInventory(newVariant) {
                if (!this.options.showInventoryQuantity) {
                    return
                }
                var productFormInventory = this.element.querySelector('.ProductForm__Inventory'),
                    variantInventory = newVariant ? this.variantsInventories[newVariant.id] : null;
                if (!newVariant || null === variantInventory.inventory_management || variantInventory.inventory_quantity <= 0 || this.options.inventoryQuantityThreshold > 0 && variantInventory.inventory_quantity > this.options.inventoryQuantityThreshold) {
                    productFormInventory.style.display = 'none'
                } else {
                    productFormInventory.innerHTML = variantInventory.inventory_message;
                    productFormInventory.style.display = ''
                }
            }
        }, {
            key: "_updateMetafields",
            value: function _updateMetafields(newVariant) {
                var availableDateContainer = this.element.querySelector('.available-soon .available-date');
                var availableDateContainer_1 = this.element.querySelector('.available-soon strong');
                var instockMsg = this.element.querySelector('.available-soon .instock_msg');
                variant_metafield.forEach(function(item) {
                    for (var i in item) {
                        if (newVariant !== null && i == newVariant.id) {
                            var metafieldValues = item[i];
                            const available_date_string = metafieldValues.find(value => value.includes('available_date_string'));
                            if (available_date_string) {
                                const available_date_string_split = available_date_string.split('-');
                                availableDateContainer.innerHTML = available_date_string_split[1]
                            }
                            variant_inventory.forEach(function(el) {
                                for (var j in el) {
                                    if (j == newVariant.id) {
                                        var inventory = el[j];
                                        if (inventory > 0) {
                                            availableDateContainer_1.classList.add('hide');
                                            instockMsg.classList.remove('hide')
                                        } else {
                                            availableDateContainer_1.classList.remove('hide');
                                            instockMsg.classList.add('hide')
                                        }
                                    }
                                }
                            })
                        }
                    }
                })
            }
        }, {
            key: "_updateSku",
            value: function _updateSku(newVariant) {
                if (!this.options.showSku || !newVariant) {
                    return
                }
                var productSkuNumberElements = this.element.querySelectorAll('.ProductMeta__SkuNumber');
                if (productSkuNumberElements && newVariant.sku) {
                    productSkuNumberElements.forEach(el => el.innerText = newVariant.sku)
                }
            }
        }, {
            key: "_updateUnitPrice",
            value: function _updateUnitPrice(newVariant) {
                if (!newVariant) {
                    return
                }
                var unitPriceMeasurement = this.element.querySelector('.ProductMeta__UnitPriceMeasurement');
                if (!unitPriceMeasurement) {
                    return
                }
                if (!newVariant.hasOwnProperty('unit_price')) {
                    unitPriceMeasurement.style.display = 'none';
                    return
                }
                unitPriceMeasurement.style.display = 'block';
                unitPriceMeasurement.querySelector('.UnitPriceMeasurement__Price').innerHTML = Currency.formatMoney(newVariant.unit_price, window.theme.moneyFormat);
                unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceUnit').textContent = newVariant.unit_price_measurement.reference_unit;
                var unitPriceReferenceValue = unitPriceMeasurement.querySelector('.UnitPriceMeasurement__ReferenceValue');
                unitPriceReferenceValue.textContent = newVariant.unit_price_measurement.reference_value;
                unitPriceReferenceValue.style.display = newVariant.unit_price_measurement.reference_value === 1 ? 'none' : 'inline';
                console.log('price update in atc button')
            }
        }, {
            key: "_updateAddToCartButton",
            value: function _updateAddToCartButton(newVariant) {
                var addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
                    shopifyPaymentButton = this.element.querySelector('.shopify-payment-button');
                if (addToCartButton) {
                    addToCartButton.classList.remove('Button--secondary');
                    addToCartButton.classList.remove('Button--primary');
                    if (!newVariant) {
                        addToCartButton.setAttribute('disabled', 'disabled');
                        addToCartButton.removeAttribute('data-action');
                        addToCartButton.classList.add('Button--secondary');
                        addToCartButton.innerHTML = window.languages.productFormUnavailable
                    } else {
                        if (newVariant.available) {
                            addToCartButton.removeAttribute('disabled');
                            addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
                            addToCartButton.setAttribute('data-action', 'add-to-cart');
                            if (undefined === this.options.showPriceInButton || this.options.showPriceInButton) {
                                addToCartButton.innerHTML = "\n            <span>".concat(window.languages.productFormAddToCart, "</span>\n            <span class=\"Button__SeparatorDot\"></span>\n            <span class=\"subtotall-price\" data-money-convertible>").concat(Currency.formatMoney(newVariant.price, window.theme.moneyFormat), "</span>\n          ")
                            } else {
                                addToCartButton.innerHTML = "<span>".concat(window.languages.productFormAddToCart, "</span>")
                            }
                        } else {
                            addToCartButton.setAttribute('disabled', 'disabled');
                            addToCartButton.classList.add('Button--secondary');
                            addToCartButton.removeAttribute('data-action');
                            addToCartButton.innerHTML = window.languages.productFormSoldOut
                        }
                    }
                }
                if (this.options.showPaymentButton && shopifyPaymentButton) {
                    if (!newVariant || !newVariant.available) {
                        shopifyPaymentButton.style.display = 'none'
                    } else {
                        shopifyPaymentButton.style.display = 'block'
                    }
                }
            }
        }, {
            key: "_onOptionChanged",
            value: function _onOptionChanged(newValue, target, activator) {
                if (activator) {
                    this['option' + target.getAttribute('data-option-position')] = newValue;
                    const activatorValue = activator.querySelector('.ProductForm__SelectedValue');
                    if (activatorValue.classList.contains('ProductForm__SelectedValue--Group')) {
                        const optionEl = document.querySelectorAll('.ProductForm__SelectedValue--Group');
                        optionEl.forEach((el) => {
                            el.innerHTML = ''
                        })
                    }
                    activatorValue.innerHTML = newValue
                } else {
                    this['option' + target.getAttribute('data-option-position')] = target.value;
                    var selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');
                    if (selectedValue) {
                        if (selectedValue.classList.contains('ProductForm__SelectedValue--Group')) {
                            const optionEl = document.querySelectorAll('.ProductForm__SelectedValue--Group');
                            console.log(target, 'dddddddddddddddddddd');
                            selectedValue = target.closest('.ProductVariant__GroupContainer').querySelector('.ProductForm__SelectedValue')
                            optionEl.forEach((el) => {
                                el.innerHTML = ''
                            })
                        }
                        selectedValue.innerHTML = target.value
                    }
                }
                var previousVariant = this.currentVariant;
                this.currentVariant = this._getCurrentVariantFromOptions();
                this._onVariantChanged(previousVariant, this.currentVariant);
                if (this.currentVariant) {
                    if (this.options.enableHistoryState) {
                        this._updateHistoryState(this.currentVariant)
                    }
                    this.masterSelector && this.masterSelector.querySelector('[selected]').removeAttribute('selected');
                    this.masterSelector && this.masterSelector.querySelector("[value=\"".concat(this.currentVariant.id, "\"]")).setAttribute('selected', 'selected');
                    this.masterSelector && this.masterSelector.dispatchEvent(new Event('change', {
                        bubbles: !0
                    }))
                }
            }
        }, {
            key: "_getCurrentVariantFromOptions",
            value: function _getCurrentVariantFromOptions() {
                var _this3 = this;
                var found = !1;
                this.productData.variants.forEach(function(variant) {
                    if (variant.option1 === _this3.option1 && variant.option2 === _this3.option2 && variant.option3 === _this3.option3) {
                        found = variant
                    }
                });
                return found || null
            }
        }, {
            key: "_updateHistoryState",
            value: function _updateHistoryState(variant) {
                if (!history.replaceState) {
                    return
                }
                var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(variant.id);
                window.history.replaceState({
                    path: newUrl
                }, '', newUrl)
            }
        }, {
            key: "_addToCart",
            value: function _addToCart(event) {
                var _this4 = this;
                if (!this.options.useAjaxCart) {
                    return
                }
                event.preventDefault();
                var addToCartButton = this.element.querySelector('.ProductForm__AddToCart');
                addToCartButton.setAttribute('disabled', 'disabled');
                document.dispatchEvent(new CustomEvent('theme:loading:start'));
                var formElement = this.element.querySelector('form[action*="/cart/add"]');
                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                    body: JSON.stringify(Form.serialize(formElement)),
                    credentials: 'same-origin',
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then(function(response) {
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                    var quantityElement = formElement.querySelector('[name="quantity"]');
                    if (response.ok) {
                        addToCartButton.removeAttribute('disabled');
                        _this4.element.dispatchEvent(new CustomEvent('product:added', {
                            bubbles: !0,
                            detail: {
                                variant: _this4.currentVariant,
                                quantity: quantityElement ? parseInt(quantityElement.value) : 1
                            }
                        }))
                    } else {
                        response.json().then(function(content) {
                            var errorMessageElement = document.createElement('span');
                            errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
                            errorMessageElement.innerHTML = content.description;
                            addToCartButton.removeAttribute('disabled');
                            addToCartButton.insertAdjacentElement('afterend', errorMessageElement);
                            setTimeout(function() {
                                errorMessageElement.remove()
                            }, 2500)
                        })
                    }
                });
                event.preventDefault()
            }
        }, {
            key: "_decreaseQuantity",
            value: function _decreaseQuantity(event, target) {
                target.nextElementSibling.value = Math.max(parseInt(target.nextElementSibling.value) - 1, 1)
            }
        }, {
            key: "_increaseQuantity",
            value: function _increaseQuantity(event, target) {
                target.previousElementSibling.value = parseInt(target.previousElementSibling.value) + 1
            }
        }, {
            key: "_validateQuantity",
            value: function _validateQuantity(event, target) {
                target.value = Math.max(parseInt(target.value) || 1, 1)
            }
        }]);
        return ProductVariants
    }();*/
  var ProductVideo = (function () {
    function ProductVideo (element, stackProductImages, enableVideoLooping) {
      _classCallCheck(this, ProductVideo)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.stackProductImages = stackProductImages
      this.enableVideoLooping = enableVideoLooping
      this.player = null
      switch (this.element.getAttribute('data-media-type')) {
        case 'video':
          var stylesheet = document.createElement('link')
          stylesheet.rel = 'stylesheet'
          stylesheet.href =
            'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css'
          document.head.appendChild(stylesheet)
          window.Shopify.loadFeatures([
            {
              name: 'video-ui',
              version: '1.0',
              onLoad: this._setupHtml5Video.bind(this)
            }
          ])
          break
        case 'external_video':
          this._setupExternalVideo()
          break
      }
    }
    _createClass(ProductVideo, [
      {
        key: 'destroy',
        value: function destroy () {
          if (this.player) {
            this.player.destroy()
          }
        }
      },
      {
        key: 'hasBeenSelected',
        value: function hasBeenSelected () {
          if (Responsive.matchesBreakpoint('supports-hover')) {
            this.play()
          }
        }
      },
      {
        key: 'hasBeenDeselected',
        value: function hasBeenDeselected () {
          this.pause()
        }
      },
      {
        key: 'play',
        value: function play () {
          switch (this.element.getAttribute('data-media-type')) {
            case 'video':
              this.player.play()
              break
            case 'external_video':
              this.player.playVideo()
              break
          }
        }
      },
      {
        key: 'pause',
        value: function pause () {
          switch (this.element.getAttribute('data-media-type')) {
            case 'video':
              this.player.pause()
              break
            case 'external_video':
              this.player.pauseVideo()
              break
          }
        }
      },
      {
        key: '_setupHtml5Video',
        value: function _setupHtml5Video () {
          var _this = this
          this.player = new Shopify.Plyr(this.element.querySelector('video'), {
            controls: [
              'play',
              'progress',
              'mute',
              'volume',
              'play-large',
              'fullscreen'
            ],
            loop: {
              active: this.enableVideoLooping
            },
            hideControlsOnPause: !0,
            clickToPlay: !0,
            iconUrl:
              '//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg',
            tooltips: {
              controls: !1,
              seek: !0
            }
          })
          this.player.on('play', function () {
            _this.element.dispatchEvent(
              new CustomEvent('video:played', {
                bubbles: !0
              })
            )
          })
          this.player.on('pause', function () {
            _this.element.dispatchEvent(
              new CustomEvent('video:paused', {
                bubbles: !0
              })
            )
          })
        }
      },
      {
        key: '_setupExternalVideo',
        value: function _setupExternalVideo () {
          if (this.element.getAttribute('data-video-host') === 'youtube') {
            this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this))
          }
        }
      },
      {
        key: '_setupYouTubePlayer',
        value: function _setupYouTubePlayer () {
          var _this2 = this
          var playerLoadingInterval = setInterval(function () {
            if (window.YT !== undefined && window.YT.Player !== undefined) {
              _this2.player = new YT.Player(
                _this2.element.querySelector('iframe'),
                {
                  videoId: _this2.element.getAttribute('data-video-id'),
                  events: {
                    onStateChange: function onStateChange (event) {
                      if (event.data === window.YT.PlayerState.PLAYING) {
                        _this2.element.dispatchEvent(
                          new CustomEvent('video:played', {
                            bubbles: !0
                          })
                        )
                      } else if (event.data === YT.PlayerState.PAUSED) {
                        _this2.element.dispatchEvent(
                          new CustomEvent('video:paused', {
                            bubbles: !0
                          })
                        )
                      }
                      if (
                        event.data === window.YT.PlayerState.ENDED &&
                        _this2.enableVideoLooping
                      ) {
                        event.target.seekTo(0)
                      }
                    }
                  }
                }
              )
              clearInterval(playerLoadingInterval)
            }
          }, 50)
        }
      },
      {
        key: '_loadYouTubeScript',
        value: function _loadYouTubeScript () {
          return new Promise(function (resolve, reject) {
            var script = document.createElement('script')
            document.body.appendChild(script)
            script.onload = resolve
            script.onerror = reject
            script.async = !0
            script.src = '//www.youtube.com/iframe_api'
          })
        }
      }
    ])
    return ProductVideo
  })()
  var ScrollSpy = (function () {
    function ScrollSpy (container, elementsToSpy, observerOptions) {
      var _this = this
      _classCallCheck(this, ScrollSpy)
      this.container = container
      this.targets = []
      this.targetIndices = {}
      this.indicesInViewPort = []
      this.observer = new IntersectionObserver(
        this._onIntersectionChange.bind(this),
        observerOptions
      )
      elementsToSpy.forEach(function (elementToSpy, index) {
        _this.targets.push(elementToSpy)
        _this.targetIndices[elementToSpy.id] = index
        _this.observer.observe(elementToSpy)
      })
    }
    _createClass(ScrollSpy, [
      {
        key: 'destroy',
        value: function destroy () {
          this.observer.disconnect()
        }
      },
      {
        key: '_onIntersectionChange',
        value: function _onIntersectionChange (changes) {
          var oldTargetIndex = this.indicesInViewPort[0] || 0
          for (var i = changes.length - 1; i >= 0; i--) {
            this._updateIndicesInViewPort(changes[i], oldTargetIndex)
          }
          this.indicesInViewPort = this.indicesInViewPort.filter(function (
            value,
            index,
            self
          ) {
            return self.indexOf(value) === index
          })
          if (
            this.indicesInViewPort.length === 0 ||
            oldTargetIndex === this.indicesInViewPort[0]
          ) {
            return
          }
          var event = new CustomEvent('scrollspy:target:changed', {
            detail: {
              newTarget: this.targets[this.indicesInViewPort[0]],
              oldTarget: this.targets[oldTargetIndex]
            }
          })
          this.container.dispatchEvent(event)
        }
      },
      {
        key: '_updateIndicesInViewPort',
        value: function _updateIndicesInViewPort (change, oldTargetIndex) {
          var index = this.targetIndices[change.target.id]
          if (change.intersectionRatio === 0) {
            var indexInViewPort = this.indicesInViewPort.indexOf(index)
            if (indexInViewPort !== -1) {
              this.indicesInViewPort.splice(indexInViewPort, 1)
            }
          } else {
            if (index < oldTargetIndex) {
              this.indicesInViewPort.unshift(index)
            } else if (
              index > this.indicesInViewPort[this.indicesInViewPort.length - 1]
            ) {
              this.indicesInViewPort.push(index)
            } else {
              this.indicesInViewPort.push(index)
              this.indicesInViewPort.sort()
            }
          }
        }
      }
    ])
    return ScrollSpy
  })()
  var SearchBar = (function () {
    function SearchBar () {
      _classCallCheck(this, SearchBar)
      this.documentDelegate = new domDelegate.Delegate(document.body)
      this.searchElement = document.getElementById('Search')
      this.searchInputElement = this.searchElement.querySelector('[name="q"]')
      this.searchResultsElement =
        this.searchElement.querySelector('.Search__Results')
      this.queryMap = {}
      this.isOpen = !1
      this.pageOverlayElement = document.querySelector('.PageOverlay')
      this._attachListeners()
    }
    _createClass(SearchBar, [
      {
        key: 'destroy',
        value: function destroy () {
          this.searchInputElement.removeEventListener(
            'keydown',
            this._preventSubmissionListener
          )
          this.searchInputElement.removeEventListener(
            'input',
            this._onInputListener
          )
          this.documentDelegate.off()
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._preventSubmissionListener = this._preventSubmission.bind(this)
          this._onInputListener = this._debounce(this._onInput.bind(this), 250)
          this.searchInputElement.addEventListener(
            'keydown',
            this._preventSubmissionListener
          )
          this.searchInputElement.addEventListener(
            'input',
            this._onInputListener
          )
          this.documentDelegate.on(
            'click',
            '[data-action="toggle-search"]',
            this._toggleSearch.bind(this)
          )
          this.documentDelegate.on(
            'click',
            '[data-action="open-search"]',
            this._openSearch.bind(this)
          )
          this.documentDelegate.on(
            'click',
            '[data-action="close-search"]',
            this._closeSearch.bind(this)
          )
          this.documentDelegate.on('search:close', this._closeSearch.bind(this))
        }
      },
      {
        key: '_toggleSearch',
        value: function _toggleSearch (event) {
          if (this.isOpen) {
            this._closeSearch(event)
          } else {
            this._openSearch(event)
          }
          event.preventDefault()
        }
      },
      {
        key: '_openSearch',
        value: function _openSearch () {
          var _this = this
          this.searchElement.setAttribute('aria-hidden', 'false')
          document.documentElement.classList.add('no-scroll')
          Accessibility.trapFocus(
            this.searchElement,
            'search',
            this.searchElement.querySelector('[name="q"]')
          )
          var onFocusListener = function onFocusListener () {
            _this.searchInputElement.focus()
            _this.searchElement.removeEventListener(
              'transitionend',
              onFocusListener
            )
          }
          this.searchElement.addEventListener('transitionend', onFocusListener)
          this.isOpen = !0
          this.pageOverlayElement.classList.add('is-visible')
          document.querySelector('#shopify-section-header').style.zIndex = 10
        }
      },
      {
        key: '_closeSearch',
        value: function _closeSearch () {
          var _this2 = this
          this.searchElement.setAttribute('aria-hidden', 'true')
          document.documentElement.classList.remove('no-scroll')
          Accessibility.removeTrapFocus(this.searchElement, 'search')
          this.isOpen = !1
          var onTransitionEnd = function onTransitionEnd (event) {
            if (event.propertyName === 'visibility') {
              document.querySelector('#shopify-section-header').style.zIndex =
                ''
              _this2.pageOverlayElement.removeEventListener(
                'transitionend',
                onTransitionEnd
              )
            }
          }
          this.pageOverlayElement.addEventListener(
            'transitionend',
            onTransitionEnd
          )
          this.pageOverlayElement.classList.remove('is-visible')
        }
      },
      {
        key: '_preventSubmission',
        value: function _preventSubmission (event) {
          if (event.keyCode === 13 && window.theme.searchMode !== 'product') {
            const form = this.searchElement.querySelector('.Search__Form')
            if (form) {
              event.preventDefault()
              form.submit()
            }
          }
        }
      },
      {
        key: '_onInput',
        value: function _onInput (event) {
          var _this3 = this
          if (event.keyCode === 13) {
            return
          }
          this.lastInputValue = event.target.value
          if (this.lastInputValue === '') {
            this._resetSearch()
            return
          }
          var queryOptions = {
            method: 'GET',
            credentials: 'same-origin'
          }
          var queries = [
            fetch(
              ''
                .concat(
                  window.routes.searchUrl,
                  '?section_id=predictive-search&q='
                )
                .concat(
                  encodeURIComponent(this.lastInputValue),
                  '*&type=product'
                ),
              queryOptions
            )
          ]
          if (window.theme.searchMode !== 'product') {
            queries.push(
              fetch(
                ''
                  .concat(
                    window.routes.searchUrl,
                    '?section_id=predictive-search&q='
                  )
                  .concat(encodeURIComponent(this.lastInputValue), '*&type=')
                  .concat(window.theme.searchMode.replace('product,', '')),
                queryOptions
              )
            )
          }
          this.queryMap[this.lastInputValue] = !0
          document.dispatchEvent(new CustomEvent('theme:loading:start'))
          Promise.all(queries).then(function (responses) {
            if (_this3.lastInputValue !== event.target.value) {
              return
            }
            delete _this3.queryMap[event.target.value]
            Promise.all(
              responses.map(function (response) {
                return response.text()
              })
            ).then(function (contents) {
              if (window.theme.searchMode === 'product') {
                _this3.searchResultsElement.innerHTML = contents[0]
              } else {
                _this3.searchResultsElement.innerHTML =
                  '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">'
                    .concat(
                      contents[0],
                      '</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">'
                    )
                    .concat(contents[1], '</div>\n            </div>')
              }
              _this3.searchResultsElement.setAttribute('aria-hidden', 'false')
            })
            document.dispatchEvent(new CustomEvent('theme:loading:end'))
          })
        }
      },
      {
        key: '_resetSearch',
        value: function _resetSearch () {
          if (window.theme.searchMode === 'product') {
            this.searchResultsElement.innerHTML = ''
          } else {
            this.searchResultsElement.innerHTML =
              '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>'
          }
          this.searchResultsElement.setAttribute('aria-hidden', 'true')
          document.dispatchEvent(new CustomEvent('theme:loading:end'))
        }
      },
      {
        key: '_debounce',
        value: function _debounce (fn, delay) {
          var _this4 = this
          var timer = null
          return function () {
            for (
              var _len = arguments.length, args = new Array(_len), _key = 0;
              _key < _len;
              _key++
            ) {
              args[_key] = arguments[_key]
            }
            clearTimeout(timer)
            timer = setTimeout(function () {
              fn.apply(_this4, args)
            }, delay)
          }
        }
      }
    ])
    return SearchBar
  })()
  var CountrySelector = (function () {
    function CountrySelector (countrySelect, provinceSelect) {
      _classCallCheck(this, CountrySelector)
      this.countrySelect = countrySelect
      this.provinceSelect = provinceSelect
      if (this.countrySelect && this.provinceSelect) {
        this._attachListeners()
        this._initSelectors()
      }
    }
    _createClass(CountrySelector, [
      {
        key: 'destroy',
        value: function destroy () {
          if (this.countrySelect) {
            this.countrySelect.removeEventListener(
              'change',
              this._onCountryChangedListener
            )
          }
        }
      },
      {
        key: '_initSelectors',
        value: function _initSelectors () {
          var defaultCountry = this.countrySelect.getAttribute('data-default')
          if (defaultCountry) {
            for (var i = 0; i !== this.countrySelect.options.length; ++i) {
              if (this.countrySelect.options[i].text === defaultCountry) {
                this.countrySelect.selectedIndex = i
                break
              }
            }
          } else {
            this.countrySelect.selectedIndex = 0
          }
          var event = new Event('change', {
            bubbles: !0
          })
          this.countrySelect.dispatchEvent(event)
          var defaultProvince = this.provinceSelect.getAttribute('data-default')
          if (defaultProvince) {
            for (var _i = 0; _i !== this.provinceSelect.options.length; ++_i) {
              if (this.provinceSelect.options[_i].text === defaultProvince) {
                this.provinceSelect.selectedIndex = _i
                break
              }
            }
          }
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._onCountryChangedListener = this._onCountryChanged.bind(this)
          this.countrySelect.addEventListener(
            'change',
            this._onCountryChangedListener
          )
        }
      },
      {
        key: '_onCountryChanged',
        value: function _onCountryChanged () {
          var _this = this
          var selectedOption =
              this.countrySelect.options[this.countrySelect.selectedIndex],
            provinces = JSON.parse(
              selectedOption.getAttribute('data-provinces') || '[]'
            )
          this.provinceSelect.innerHTML = ''
          if (provinces.length === 0) {
            this.provinceSelect.parentNode.style.display = 'none'
            return
          }
          provinces.forEach(function (data) {
            _this.provinceSelect.options.add(new Option(data[1], data[0]))
          })
          this.provinceSelect.parentNode.style.display = 'block'
        }
      }
    ])
    return CountrySelector
  })()
  var ShippingEstimator = (function () {
    function ShippingEstimator (element) {
      _classCallCheck(this, ShippingEstimator)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.countrySelector = new CountrySelector(
        this.element.querySelector('[name="country"]'),
        this.element.querySelector('[name="province"]')
      )
      this._attachListeners()
    }
    _createClass(ShippingEstimator, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.delegateElement.off('click')
          this.countrySelector.destroy()
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'click',
            '.ShippingEstimator__Submit',
            this._fetchRates.bind(this)
          )
        }
      },
      {
        key: '_fetchRates',
        value: function _fetchRates () {
          var _this = this
          var country = this.element.querySelector('[name="country"]').value,
            province = this.element.querySelector('[name="province"]').value,
            zip = this.element.querySelector('[name="zip"]').value
          document.dispatchEvent(new CustomEvent('theme:loading:start'))
          fetch(
            ''
              .concat(
                window.routes.cartUrl,
                '/shipping_rates.json?shipping_address[zip]='
              )
              .concat(zip, '&shipping_address[country]=')
              .concat(country, '&shipping_address[province]=')
              .concat(province),
            {
              credentials: 'same-origin',
              method: 'GET'
            }
          ).then(function (response) {
            response.json().then(function (result) {
              document.dispatchEvent(new CustomEvent('theme:loading:end'))
              var resultsContainer = _this.element.querySelector(
                  '.ShippingEstimator__Results'
                ),
                errorContainer = _this.element.querySelector(
                  '.ShippingEstimator__Error'
                )
              if (response.ok) {
                var shippingRates = result.shipping_rates
                if (shippingRates.length === 0) {
                  resultsContainer.innerHTML = '<p>'.concat(
                    window.languages.shippingEstimatorNoResults,
                    '</p>'
                  )
                } else {
                  var html = ''
                  if (shippingRates.length === 1) {
                    html += '<p>'.concat(
                      window.languages.shippingEstimatorOneResult,
                      '</p><ul>'
                    )
                  } else {
                    html += '<p>'.concat(
                      window.languages.shippingEstimatorMoreResults.replace(
                        '{{count}}',
                        shippingRates.length
                      ),
                      '</p><ul>'
                    )
                  }
                  shippingRates.forEach(function (item) {
                    html += '<li>'
                      .concat(item.name, ': ')
                      .concat(
                        Currency.formatMoney(
                          item.price,
                          window.theme.moneyFormat
                        ),
                        '</li>'
                      )
                  })
                  html += '</ul>'
                  resultsContainer.firstElementChild.innerHTML = html
                }
                TweenLite.fromTo(
                  resultsContainer.firstElementChild,
                  0.6,
                  {
                    autoAlpha: 0,
                    y: -15
                  },
                  {
                    autoAlpha: 1,
                    y: 0,
                    delay: 0.35
                  }
                )
                errorContainer.style.display = 'none'
                resultsContainer.style.display = 'block'
                Animation.slideDown(resultsContainer)
              } else {
                var errorHtml = ''
                Object.keys(result).forEach(function (key) {
                  errorHtml += '<li class="Alert__ErrorItem">'
                    .concat(key, ' ')
                    .concat(result[key], '</li>')
                })
                errorContainer.innerHTML =
                  '<ul class="Alert__ErrorList">'.concat(errorHtml, '</ul>')
                resultsContainer.style.display = 'none'
                errorContainer.style.display = 'block'
              }
            })
          })
        }
      }
    ])
    return ShippingEstimator
  })()
  var AddressesSection = function AddressesSection () {
    var _this = this
    _classCallCheck(this, AddressesSection)
    this.countrySelectors = []
    Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(
      function (modal) {
        _this.countrySelectors.push(
          new CountrySelector(
            modal.querySelector('[name="address[country]"]'),
            modal.querySelector('[name="address[province]"]')
          )
        )
      }
    )
  }
  var ArticleList = (function () {
    function ArticleList (container) {
      var _this = this
      _classCallCheck(this, ArticleList)
      this.element = container
      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        })
        this.intersectionObserver = new IntersectionObserver(
          this._reveal.bind(this)
        )
        Dom.nodeListToArray(
          this.element.querySelectorAll('.ArticleItem')
        ).forEach(function (item) {
          _this.intersectionObserver.observe(item)
        })
      }
    }
    _createClass(ArticleList, [
      {
        key: 'onUnload',
        value: function onUnload () {
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect()
            this.timeline.kill()
          }
        }
      },
      {
        key: '_reveal',
        value: function _reveal (results) {
          var _this2 = this
          var toReveal = []
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target)
              _this2.intersectionObserver.unobserve(result.target)
            }
          })
          if (toReveal.length === 0) {
            return
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.45,
            {
              autoAlpha: 0,
              y: 30
            },
            {
              autoAlpha: 1,
              y: 0
            },
            0.2
          )
        }
      }
    ])
    return ArticleList
  })()
  var ArticleSection = (function () {
    function ArticleSection (container) {
      var _this = this
      _classCallCheck(this, ArticleSection)
      this.element = container
      this.toolbarElement = this.element.querySelector('.ArticleToolbar')
      this.articleNavElement = this.element.querySelector('.ArticleNav')
      var articleImageElement = this.element.querySelector('.Article__Image')
      if (
        articleImageElement &&
        window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
      ) {
        this.parallaxInstance = new Rellax('.Article__Image', {
          speed: -7,
          center: !1,
          round: !0
        })
      }
      if (window.theme.showElementStaggering) {
        this.timeline = new TimelineLite({
          delay: window.theme.showPageTransition ? 0.5 : 0
        })
        this.intersectionObserver = new IntersectionObserver(
          this._reveal.bind(this)
        )
        Dom.nodeListToArray(
          this.element.querySelectorAll('.ArticleItem')
        ).forEach(function (item) {
          _this.intersectionObserver.observe(item)
        })
      }
      this._attachListeners()
    }
    _createClass(ArticleSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          if (this.parallaxInstance) {
            this.parallaxInstance.destroy()
          }
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect()
            this.timeline.kill()
          }
          window.removeEventListener('scroll', this._onScrollListener)
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._onScrollListener = this._checkToolbarVisibility.bind(this)
          window.addEventListener('scroll', this._onScrollListener)
        }
      },
      {
        key: '_checkToolbarVisibility',
        value: function _checkToolbarVisibility () {
          var _this2 = this
          var lastYPosition = 0,
            headerHeight = 0,
            navBottom = 0,
            isFixedHeader = 0,
            header = document.querySelector('.Header')
          fastdom.measure(function () {
            lastYPosition = window.pageYOffset
            headerHeight = header.offsetHeight
            isFixedHeader = parseInt(
              window
                .getComputedStyle(document.body)
                .getPropertyValue('--use-sticky-header') || 0
            )
            if (_this2.articleNavElement) {
              navBottom =
                _this2.articleNavElement.offsetTop +
                _this2.articleNavElement.clientHeight -
                headerHeight
            }
          })
          fastdom.mutate(function () {
            _this2.toolbarElement.style.top = isFixedHeader
              ? headerHeight + 'px'
              : null
            if (_this2.articleNavElement) {
              if (
                lastYPosition > 150 &&
                _this2.articleNavElement &&
                lastYPosition < navBottom
              ) {
                _this2.toolbarElement.classList.add('is-visible')
              } else {
                _this2.toolbarElement.classList.remove('is-visible')
              }
            } else {
              if (lastYPosition > 150) {
                _this2.toolbarElement.classList.add('is-visible')
              } else {
                _this2.toolbarElement.classList.remove('is-visible')
              }
            }
          })
        }
      },
      {
        key: '_reveal',
        value: function _reveal (results) {
          var _this3 = this
          var toReveal = []
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target)
              _this3.intersectionObserver.unobserve(result.target)
            }
          })
          if (toReveal.length === 0) {
            return
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.45,
            {
              autoAlpha: 0,
              y: 30
            },
            {
              autoAlpha: 1,
              y: 0
            },
            0.2
          )
        }
      }
    ])
    return ArticleSection
  })()
  var CartSection = (function () {
    function CartSection (container) {
      _classCallCheck(this, CartSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.documentDelegate = new domDelegate.Delegate(document.documentElement)
      this.options = JSON.parse(
        this.element.getAttribute('data-section-settings')
      )
      this.itemCount = this.options.itemCount
      this.isCartNoteOpen = !1
      if (this.options.drawer) {
        this.sidebarDrawer = new Drawer(this.element, {
          onClose: this._onDrawerClosed.bind(this)
        })
      }
      if (this.options.hasShippingEstimator) {
        this.shippingEstimator = new ShippingEstimator(
          this.element.querySelector('.ShippingEstimator')
        )
      }
      this._attachListeners()
    }
    _createClass(CartSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          if (this.options.hasShippingEstimator) {
            this.shippingEstimator.destroy()
          }
          this.delegateElement.off()
          document.removeEventListener(
            'product:added',
            this._onProductAddedListener
          )
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._onProductAddedListener = this._onProductAdded.bind(this)
          this.delegateElement.on(
            'change',
            '#cart-note',
            this._updateCartNote.bind(this)
          )
          if (this.options.type !== 'page') {
            this.delegateElement.on(
              'click',
              '[data-action="update-item-quantity"], [data-action="remove-item"]',
              this._updateItemQuantity.bind(this)
            )
            this.delegateElement.on(
              'change',
              '.QuantitySelector__CurrentQuantity',
              this._updateItemQuantity.bind(this)
            )
          } else {
            this.delegateElement.on(
              'change',
              '.QuantitySelector__CurrentQuantity',
              this._reloadPageWithQuantity.bind(this)
            )
          }
          if (this.options.drawer) {
            this.delegateElement.on(
              'click',
              '[data-action="toggle-cart-note"]',
              this._toggleCartNote.bind(this)
            )
          }
          document.addEventListener(
            'product:added',
            this._onProductAddedListener
          )
          this.documentDelegate.on(
            'cart:refresh',
            this._rerenderCart.bind(this, !1)
          )
        }
      },
      {
        key: '_updateCartNote',
        value: function _updateCartNote (event, target) {
          fetch(''.concat(window.routes.cartUrl, '/update.js'), {
            body: JSON.stringify({
              note: target.value
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
        }
      },
      {
        key: '_toggleCartNote',
        value: function _toggleCartNote () {
          var _this = this
          var noteContainer = this.element.querySelector(
              '.Cart__OffscreenNoteContainer'
            ),
            cartNote = this.element.querySelector('#cart-note')
          this.element.classList.toggle('has-note-open')
          this.element.querySelector('.Cart__NoteButton').innerHTML =
            cartNote.value !== ''
              ? window.languages.cartEditNote
              : window.languages.cartAddNote
          noteContainer.setAttribute(
            'aria-hidden',
            noteContainer.getAttribute('aria-hidden') === 'true'
              ? 'false'
              : 'true'
          )
          this.isCartNoteOpen =
            noteContainer.getAttribute('aria-hidden') === 'false'
          if (this.element.classList.contains('has-note-open')) {
            var transitionEndListener = function transitionEndListener () {
              _this.element.querySelector('#cart-note').focus()
              noteContainer.removeEventListener(
                'transitionend',
                transitionEndListener
              )
            }
            noteContainer.addEventListener(
              'transitionend',
              transitionEndListener
            )
          }
        }
      },
      {
        key: '_updateItemQuantity',
        value: function _updateItemQuantity (event, target) {
          var _this2 = this
          document.dispatchEvent(new CustomEvent('theme:loading:start'))
          var quantity = null,
            elementToAnimate = null
          if (target.tagName === 'INPUT') {
            quantity = parseInt(Math.max(parseInt(target.value) || 1, 1))
          } else {
            quantity = parseInt(target.getAttribute('data-quantity'))
          }
          if (quantity === 0) {
            elementToAnimate = target.closest('.CartItemWrapper')
          }
          fetch(''.concat(window.routes.cartChangeUrl, '.js'), {
            body: JSON.stringify({
              line: target.getAttribute('data-line'),
              quantity: quantity
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (cart) {
            cart.json().then(function (content) {
              _this2.itemCount = content.item_count
              _this2._rerenderCart(elementToAnimate)
              document.dispatchEvent(new CustomEvent('theme:loading:end'))
            })
          })
          event.preventDefault()
        }
      },
      {
        key: '_reloadPageWithQuantity',
        value: function _reloadPageWithQuantity (event, target) {
          window.location.href = ''
            .concat(window.routes.cartChangeUrl, '?quantity=')
            .concat(parseInt(target.value), '&line=')
            .concat(target.getAttribute('data-line'))
        }
      },
      {
        key: '_onProductAdded',
        value: function _onProductAdded (event) {
          var _this3 = this
          this.itemCount += event.detail.quantity
          this._rerenderCart().then(function () {
            _this3.sidebarDrawer.open()
          })
        }
      },
      {
        key: '_onDrawerClosed',
        value: function _onDrawerClosed () {
          if (this.isCartNoteOpen) {
            this._toggleCartNote()
          }
        }
      },
      {
        key: '_rerenderCart',
        value: function _rerenderCart (elementToAnimate) {
          var _this4 = this
          return fetch(
            ''
              .concat(window.routes.cartUrl, '?section_id=')
              .concat(
                this.options.drawer && window.theme.pageType !== 'cart'
                  ? 'mini-cart'
                  : 'main-cart',
                '&timestamp='
              )
              .concat(Date.now()),
            {
              credentials: 'same-origin',
              method: 'GET'
            }
          ).then(function (content) {
            if (_this4.options.drawer && elementToAnimate) {
              var timelineLite = new TimelineLite({
                onComplete: function onComplete () {
                  content.text().then(function (html) {
                    _this4._replaceContent(html)
                  })
                }
              })
              timelineLite.to(
                elementToAnimate,
                0.5,
                {
                  height: 0,
                  opacity: 0,
                  ease: Cubic.easeOut
                },
                0
              )
              if (_this4.itemCount === 0) {
                timelineLite.to(
                  _this4.element.querySelector('.Drawer__Footer'),
                  0.5,
                  {
                    y: '100%',
                    transition: 'none',
                    ease: Cubic.easeInOut
                  },
                  0
                )
              }
            } else {
              content.text().then(function (html) {
                _this4._replaceContent(html)
              })
            }
          })
        }
      },
      {
        key: '_replaceContent',
        value: function _replaceContent (html) {
          var _this5 = this
          var tempElement = document.createElement('div')
          tempElement.innerHTML = html
          var cartNodeParent = this.element.querySelector('.Cart').parentNode
          if (this.options.drawer && window.theme.pageType !== 'cart') {
            var currentScrollPosition =
              this.element.querySelector('.Drawer__Main').scrollTop
            cartNodeParent.replaceChild(
              tempElement.querySelector('.Cart'),
              this.element.querySelector('.Cart')
            )
            this.element.querySelector('.Drawer__Main').scrollTop =
              currentScrollPosition
          } else {
            if (this.itemCount === 0) {
              this.element.innerHTML =
                tempElement.querySelector(
                  '.shopify-section'
                ).firstElementChild.innerHTML
            } else {
              cartNodeParent.replaceChild(
                tempElement.querySelector('.Cart'),
                this.element.querySelector('.Cart')
              )
              this.element.querySelector('.PageHeader').innerHTML =
                tempElement.querySelector('.PageHeader').innerHTML
            }
          }
          var cartResult = JSON.parse(
            tempElement
              .querySelector('[data-section-type="cart"]')
              .getAttribute('data-section-settings')
          )
          var cartDot = Dom.nodeListToArray(
              document.querySelectorAll('.Header__CartDot')
            ),
            cartQuantity = Dom.nodeListToArray(
              document.querySelectorAll('.Header__CartCount')
            )
          this.itemCount = cartResult.itemCount
          cartDot.forEach(function (item) {
            if (_this5.itemCount === 0) {
              item.classList.remove('is-visible')
            } else {
              item.classList.add('is-visible')
            }
          })
          cartQuantity.forEach(function (item) {
            item.textContent = _this5.itemCount
          })
        }
      }
    ])
    return CartSection
  })()
  var CollectionListSection = (function () {
    function CollectionListSection (container) {
      _classCallCheck(this, CollectionListSection)
      this.element = container
      var collectionListElement = this.element.querySelector(
        '[data-flickity-config]'
      )
      if (collectionListElement) {
        this.carousel = new Carousel(collectionListElement)
      }
    }
    _createClass(CollectionListSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          if (this.carousel) {
            this.carousel.destroy()
          }
        }
      },
      {
        key: 'onBlockSelect',
        value: function onBlockSelect (event) {
          if (this.carousel) {
            this.carousel.selectCell(
              event.target.getAttribute('data-slide-index'),
              !0,
              !event.detail.load
            )
          }
        }
      },
      {
        key: 'onBlockDeselect',
        value: function onBlockDeselect () {
          if (this.carousel) {
            this.carousel.unpausePlayer()
          }
        }
      }
    ])
    return CollectionListSection
  })()
  var OverflowScroller = (function () {
    function OverflowScroller (element) {
      _classCallCheck(this, OverflowScroller)
      if (!element) {
        return
      }
      this.element = element
      this.lastKnownY = window.scrollY
      this.currentTop = 0
      this.initialTopOffset = parseInt(
        window.getComputedStyle(this.element).top
      )
      this._attachListeners()
    }
    _createClass(OverflowScroller, [
      {
        key: 'destroy',
        value: function destroy () {
          window.removeEventListener('scroll', this._checkPositionListener)
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._checkPositionListener = this._checkPosition.bind(this)
          window.addEventListener('scroll', this._checkPositionListener)
        }
      },
      {
        key: '_checkPosition',
        value: function _checkPosition () {
          var _this = this
          fastdom.measure(function () {
            var bounds = _this.element.getBoundingClientRect(),
              maxTop =
                bounds.top +
                window.scrollY -
                _this.element.offsetTop +
                _this.initialTopOffset,
              minTop = _this.element.clientHeight - window.innerHeight
            if (window.scrollY < _this.lastKnownY) {
              _this.currentTop -= window.scrollY - _this.lastKnownY
            } else {
              _this.currentTop += _this.lastKnownY - window.scrollY
            }
            _this.currentTop = Math.min(
              Math.max(_this.currentTop, -minTop),
              maxTop,
              _this.initialTopOffset
            )
            _this.lastKnownY = window.scrollY
          })
          fastdom.mutate(function () {
            _this.element.style.top = ''.concat(_this.currentTop, 'px')
          })
        }
      }
    ])
    return OverflowScroller
  })()
  var CollectionSection = (function () {
    function CollectionSection (element) {
      _classCallCheck(this, CollectionSection)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.toolbarElement = this.element.querySelector('.CollectionToolbar')
      this.collectionInnerElement = this.element.querySelector(
        '.CollectionInner__Products'
      )
      this.settings = JSON.parse(
        this.element.getAttribute('data-section-settings')
      )
      var sortPopoverElement = document.getElementById(
        'collection-sort-popover'
      )
      if (sortPopoverElement) {
        this.sortPopover = new Popover(sortPopoverElement, {
          onValueChanged: this._sortByChanged.bind(this)
        })
      }
      var filterDrawerElement = document.getElementById(
        'collection-filter-drawer'
      )
      if (filterDrawerElement) {
        this.filterDrawer = new Drawer(filterDrawerElement)
      }
      if (this.settings.filterPosition === 'sidebar') {
        this.filterInnerSidebarScroller = new OverflowScroller(
          this.element.querySelector('.CollectionInner__Sidebar')
        )
      }
      var collectionImageElement = this.element.querySelector(
        '.PageHeader__ImageWrapper'
      )
      if (
        collectionImageElement &&
        window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
      ) {
        this.parallaxInstance = new Rellax('.PageHeader__ImageWrapper', {
          speed: -7,
          center: !1,
          round: !0
        })
      }
      new ProductItemColorSwatch(this.element.querySelector('.ProductList'))
      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      })
      this._setupAnimation()
      this._attachListeners()
    }
    _createClass(CollectionSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.delegateElement.off('click')
          if (this.sortPopover) {
            this.sortPopover.destroy()
          }
          if (this.filterDrawer) {
            this.filterDrawer.destroy()
          }
          if (this.filterInnerSidebarScroller) {
            this.filterInnerSidebarScroller.destroy()
          }
          if (this.parallaxInstance) {
            this.parallaxInstance.destroy()
          }
          if (window.theme.showElementStaggering) {
            this.intersectionObserver.disconnect()
            this.timeline.kill()
          }
        }
      },
      {
        key: '_setupAnimation',
        value: function _setupAnimation () {
          var _this = this
          var forceLoadFromTop =
            arguments.length > 0 && arguments[0] !== undefined
              ? arguments[0]
              : !1
          if (!window.theme.showElementStaggering) {
            return
          }
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect()
          }
          if (forceLoadFromTop) {
            this.timeline.clear()
            this.timeline.staggerFromTo(
              this.element.querySelectorAll(
                '.ProductList .ProductItem, .ArticleList .ArticleItem'
              ),
              0.25,
              {
                autoAlpha: 0,
                y: 25
              },
              {
                autoAlpha: 1,
                y: 0
              },
              0.1
            )
          } else {
            this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this),
              {
                threshold: 0.3
              }
            )
            Dom.nodeListToArray(
              this.element.querySelectorAll(
                '.ProductList .ProductItem, .ArticleList .ArticleItem'
              )
            ).forEach(function (item) {
              _this.intersectionObserver.observe(item)
            })
          }
        }
      },
      {
        key: '_reveal',
        value: function _reveal (results) {
          var _this2 = this
          var toReveal = []
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target)
              _this2.intersectionObserver.unobserve(result.target)
            }
          })
          if (toReveal.length === 0) {
            return
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.35,
            {
              autoAlpha: 0,
              y: 25
            },
            {
              autoAlpha: 1,
              y: 0
            },
            0.15
          )
        }
      },
      {
        key: '_changeLayoutMode',
        value: function _changeLayoutMode (event, target) {
          var _this3 = this
          var layoutType = target.getAttribute('data-grid-type'),
            newCount = parseInt(target.getAttribute('data-count'))
          var productList =
            this.collectionInnerElement.querySelector('.ProductList')
          if (productList) {
            var previousCount = parseInt(
              productList.getAttribute('data-'.concat(layoutType, '-count'))
            )
            if (previousCount === newCount) {
              return
            }
            productList.setAttribute(
              'data-'.concat(layoutType, '-count'),
              newCount
            )
            Dom.nodeListToArray(
              productList.querySelectorAll('.Grid__Cell')
            ).forEach(function (item) {
              if (layoutType === 'mobile') {
                item.classList.remove('1/'.concat(previousCount, '--phone'))
                item.classList.add('1/'.concat(newCount, '--phone'))
              } else {
                var previousTabletCount = previousCount === 2 ? 2 : 3,
                  newTabletCount = newCount === 2 ? 2 : 3
                if (_this3.settings.filterPosition === 'drawer') {
                  item.classList.remove(
                    '1/'.concat(previousCount, '--lap-and-up')
                  )
                  item.classList.add('1/'.concat(newCount, '--lap-and-up'))
                } else {
                  item.classList.remove('1/'.concat(previousCount, '--desk'))
                  item.classList.add('1/'.concat(newCount, '--desk'))
                }
                item.classList.remove(
                  '1/'.concat(previousTabletCount, '--tablet-and-up')
                )
                item.classList.add(
                  '1/'.concat(newTabletCount, '--tablet-and-up')
                )
              }
              if (window.theme.showElementStaggering) {
                item.firstElementChild.style.visibility = 'hidden'
              }
            })
            lazySizes.autoSizer.checkElems()
          }
          target.classList.add('is-active')
          Dom.getSiblings(target)[0].classList.remove('is-active')
          this._setupAnimation()
          fetch(''.concat(window.routes.cartUrl, '/update.js'), {
            body: JSON.stringify({
              attributes: _defineProperty(
                {},
                'collection_'.concat(layoutType, '_items_per_row'),
                newCount
              )
            }),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
        }
      },
      {
        key: '_sortByChanged',
        value: function _sortByChanged (sortBy) {
          var currentUrl = new URL(location.href)
          currentUrl.searchParams.set('sort_by', sortBy)
          currentUrl.searchParams.delete('page')
          this._reloadProducts(currentUrl.toString())
        }
      },
      {
        key: '_onFiltersCleared',
        value: function _onFiltersCleared (event) {
          this._reloadProducts(event.target.getAttribute('data-url'))
        }
      },
      {
        key: '_onFilterChanged',
        value: function _onFilterChanged (event) {
          var formData = new FormData(event.target.closest('form'))
          var searchParamsAsString = new URLSearchParams(formData).toString()
          this._reloadProducts(
            ''
              .concat(window.location.pathname, '?')
              .concat(searchParamsAsString)
          )
        }
      },
      {
        key: '_reloadProducts',
        value: function _reloadProducts (url) {
          var _this4 = this
          if (this.abortController) {
            this.abortController.abort()
          }
          document.dispatchEvent(new CustomEvent('theme:loading:start'))
          if (history.replaceState) {
            window.history.pushState(
              {
                path: url
              },
              '',
              url
            )
          }
          var currentUrl = new URL(window.location)
          currentUrl.searchParams.set('section_id', this.settings.sectionId)
          try {
            this.abortController = new AbortController()
            fetch(currentUrl.toString(), {
              signal: this.abortController.signal
            }).then(function (response) {
              response.text().then(function (content) {
                var tempElement = document.createElement('div')
                tempElement.innerHTML = content
                _this4.collectionInnerElement.innerHTML =
                  tempElement.querySelector(
                    '.CollectionInner__Products'
                  ).innerHTML
                var toolbarFilter = tempElement.querySelector(
                  '.CollectionToolbar__Item--filter'
                )
                if (toolbarFilter) {
                  var newToolbarFilter = _this4.element.querySelector(
                    '.CollectionToolbar__Item--filter'
                  )
                  newToolbarFilter.innerHTML = toolbarFilter.innerHTML
                  newToolbarFilter.className = toolbarFilter.className
                }
                var collectionFiltersDrawer = _this4.element.querySelector(
                    '#collection-filters-drawer-form'
                  ),
                  collectionFiltersSidebar = _this4.element.querySelector(
                    '#collection-filters-sidebar-form'
                  )
                if (collectionFiltersDrawer) {
                  var newDrawerContent = tempElement.querySelector(
                    '#collection-filters-drawer-form'
                  )
                  Array.from(
                    collectionFiltersDrawer.querySelectorAll('.Collapsible')
                  ).forEach(function (collapsible) {
                    var newCollapsible = newDrawerContent.querySelector(
                      '[data-filter-index="'.concat(
                        collapsible.getAttribute('data-filter-index'),
                        '"]'
                      )
                    )
                    if (
                      collapsible.firstElementChild.getAttribute(
                        'aria-expanded'
                      ) === 'true'
                    ) {
                      newCollapsible.style.overflow = 'visible'
                      newCollapsible.firstElementChild.setAttribute(
                        'aria-expanded',
                        'true'
                      )
                      newCollapsible.lastElementChild.style.height = 'auto'
                      newCollapsible.lastElementChild.style.overflow = 'visible'
                    }
                  })
                  collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML
                  new ProductItemColorSwatch(
                    _this4.element.querySelector('.ProductList')
                  )
                }
                if (collectionFiltersSidebar) {
                  var newSidebarContent = tempElement.querySelector(
                    '#collection-filters-sidebar-form'
                  )
                  Array.from(
                    collectionFiltersSidebar.querySelectorAll('.Collapsible')
                  ).forEach(function (collapsible) {
                    var newCollapsible = newSidebarContent.querySelector(
                      '[data-filter-index="'.concat(
                        collapsible.getAttribute('data-filter-index'),
                        '"]'
                      )
                    )
                    if (
                      collapsible.firstElementChild.getAttribute(
                        'aria-expanded'
                      ) === 'true'
                    ) {
                      newCollapsible.style.overflow = 'visible'
                      newCollapsible.firstElementChild.setAttribute(
                        'aria-expanded',
                        'true'
                      )
                      newCollapsible.lastElementChild.style.height = 'auto'
                      newCollapsible.lastElementChild.style.overflow = 'visible'
                    }
                  })
                  collectionFiltersSidebar.innerHTML =
                    newSidebarContent.innerHTML
                }
                document.dispatchEvent(new CustomEvent('theme:loading:end'))
                _this4._setupAnimation(!0)
                var elementOffset =
                  _this4.element
                    .querySelector('.CollectionMain')
                    .getBoundingClientRect().top -
                  parseInt(
                    document.documentElement.style.getPropertyValue(
                      '--header-height'
                    )
                  )
                if (
                  Responsive.matchesBreakpoint('lap-and-up') &&
                  _this4.toolbarElement &&
                  _this4.toolbarElement.clientHeight === 0
                ) {
                  elementOffset -= 50
                }
                if (elementOffset < 0) {
                  window.scrollBy({
                    top: elementOffset,
                    behavior: 'smooth'
                  })
                }
              })
            })
          } catch (exception) {}
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._changeLayoutModeListener = this._changeLayoutMode.bind(this)
          this.delegateElement.on(
            'click',
            '[data-action="change-layout-mode"]',
            this._changeLayoutModeListener
          )
          this.delegateElement.on(
            'click',
            '[data-action="clear-filters"]',
            this._onFiltersCleared.bind(this)
          )
          this.delegateElement.on(
            'change',
            '[name^="filter."]',
            this._onFilterChanged.bind(this)
          )
          window.addEventListener('popstate', function (event) {
            if (event.state.path) {
              window.location.href = event.state.path
            }
          })
        }
      }
    ])
    return CollectionSection
  })()
  var FaqSection = (function () {
    function FaqSection (element) {
      _classCallCheck(this, FaqSection)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this._attachListeners()
    }
    _createClass(FaqSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.delegateElement.off()
        }
      },
      {
        key: 'onBlockSelect',
        value: function onBlockSelect (event) {
          this._openItem(event.target)
        }
      },
      {
        key: 'onBlockDeselect',
        value: function onBlockDeselect (event) {
          this._closeItem(event.target)
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'click',
            '.Faq__Question',
            this._toggleItem.bind(this)
          )
          this.delegateElement.on(
            'click',
            '.FaqSummary__Item',
            this._switchToCategory.bind(this)
          )
        }
      },
      {
        key: '_switchToCategory',
        value: function _switchToCategory (event, target) {
          target.classList.add('is-active')
          Dom.getSiblings(target, '.is-active').forEach(function (item) {
            item.classList.remove('is-active')
          })
        }
      },
      {
        key: '_toggleItem',
        value: function _toggleItem (event, target) {
          var item = target.closest('.Faq__Item')
          if (item.getAttribute('aria-expanded') === 'true') {
            this._closeItem(item)
          } else {
            this._openItem(item)
          }
        }
      },
      {
        key: '_openItem',
        value: function _openItem (item) {
          var answerWrapper = item.querySelector('.Faq__AnswerWrapper')
          item.setAttribute('aria-expanded', 'true')
          answerWrapper.setAttribute('aria-hidden', 'false')
          Animation.slideDown(answerWrapper, !0)
          Dom.getSiblings(item, '[aria-expanded="true"]').forEach(function (
            siblingItem
          ) {
            var siblingAnswerWrapper = siblingItem.querySelector(
              '.Faq__AnswerWrapper'
            )
            siblingItem.setAttribute('aria-expanded', 'false')
            siblingAnswerWrapper.setAttribute('aria-hidden', 'true')
            Animation.slideUp(siblingAnswerWrapper)
          })
        }
      },
      {
        key: '_closeItem',
        value: function _closeItem (item) {
          var answerWrapper = item.querySelector('.Faq__AnswerWrapper')
          item.setAttribute('aria-expanded', 'false')
          answerWrapper.setAttribute('aria-hidden', 'true')
          Animation.slideUp(answerWrapper)
        }
      }
    ])
    return FaqSection
  })()
  var FeaturedCollectionsSection = (function () {
    function FeaturedCollectionsSection (container) {
      var _this = this
      _classCallCheck(this, FeaturedCollectionsSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.options = JSON.parse(this.element.getAttribute('data-settings'))
      this.carousels = []
      Dom.nodeListToArray(
        this.element.querySelectorAll('[data-flickity-config]')
      ).forEach(function (item) {
        _this.carousels.push(new Carousel(item))
      })
      new ProductItemColorSwatch(this.element)
      this._setupAnimation()
      this._attachListeners()
    }
    _createClass(FeaturedCollectionsSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.carousels.forEach(function (item) {
            return item.destroy()
          })
          this.delegateElement.off('click')
          this.intersectionObserver.disconnect()
          this.timeline.kill()
        }
      },
      {
        key: 'onBlockSelect',
        value: function onBlockSelect (event) {
          this.element
            .querySelector('[aria-controls="'.concat(event.target.id, '"]'))
            .click()
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'click',
            '[data-action="toggle-tab"]',
            this._switchTab.bind(this)
          )
        }
      },
      {
        key: '_switchTab',
        value: function _switchTab (event, target) {
          var _this2 = this
          if (target.classList.contains('is-active')) {
            return
          }
          target.classList.add('is-active')
          Dom.getSiblings(target, '.is-active').forEach(function (item) {
            item.classList.remove('is-active')
          })
          var tabPanelToShow = this.element.querySelector(
            '#'.concat(target.getAttribute('aria-controls'))
          )
          this.timeline.eventCallback('onReverseComplete', function () {
            tabPanelToShow.setAttribute('aria-hidden', 'false')
            Dom.getSiblings(
              tabPanelToShow,
              '.TabPanel[aria-hidden="false"]'
            ).forEach(function (item) {
              item.setAttribute('aria-hidden', 'true')
            })
            if (Responsive.matchesBreakpoint('lap-and-up')) {
              _this2.carousels.forEach(function (carousel) {
                carousel.flickityInstance.activate()
                carousel.flickityInstance.resize()
              })
            }
            _this2.timeline.clear()
            _this2._setupAnimation()
          })
          if (
            this.options.layout === 'grid' &&
            window.theme.showElementStaggering
          ) {
            this.timeline.reverse().timeScale(3)
          } else {
            this.timeline.reverse()
          }
        }
      },
      {
        key: '_setupAnimation',
        value: function _setupAnimation () {
          var _this3 = this
          if (this.intersectionObserver) {
            this.intersectionObserver.disconnect()
          }
          this.timeline = new TimelineLite({
            delay: 0.5
          })
          if (
            this.options.layout === 'grid' &&
            window.theme.showElementStaggering
          ) {
            this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this)
            )
            Dom.nodeListToArray(
              this.element.querySelectorAll(
                '.TabPanel[aria-hidden="false"] .ProductList .ProductItem'
              )
            ).forEach(function (item) {
              _this3.intersectionObserver.observe(item)
            })
          } else {
            var productList = this.element.querySelector(
              '.TabPanel[aria-hidden="false"] .ProductList'
            )
            if (productList) {
              this.timeline.fromTo(
                productList,
                0.6,
                {
                  autoAlpha: 0,
                  y: 25
                },
                {
                  autoAlpha: 1,
                  y: 0
                }
              )
            }
          }
        }
      },
      {
        key: '_reveal',
        value: function _reveal (results) {
          var _this4 = this
          var toReveal = []
          results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
              toReveal.push(result.target)
              _this4.intersectionObserver.unobserve(result.target)
            }
          })
          if (toReveal.length === 0) {
            return
          }
          this.timeline.staggerFromTo(
            toReveal,
            0.45,
            {
              autoAlpha: 0,
              y: 25
            },
            {
              autoAlpha: 1,
              y: 0
            },
            0.2
          )
        }
      }
    ])
    return FeaturedCollectionsSection
  })()
  var FeaturedProductSection = (function () {
    function FeaturedProductSection (container) {
      _classCallCheck(this, FeaturedProductSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.options = JSON.parse(
        this.element.getAttribute('data-section-settings')
      )
      if (!this.options.usePlaceholder) {
        this.productVariants = new ProductVariants(container, this.options)
      }
      var offscreenElement = this.element.querySelector('.Product__OffScreen')
      if (offscreenElement) {
        this.element.appendChild(offscreenElement)
      }
      this._attachListeners()
    }
    _createClass(FeaturedProductSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.delegateElement.off('click')
          if (this.productVariants) {
            this.productVariants.destroy()
          }
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'variant:changed',
            this._updateMainImage.bind(this)
          )
        }
      },
      {
        key: '_updateMainImage',
        value: function _updateMainImage (event) {
          var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant
          if (
            !variant ||
            !variant.featured_image ||
            (previousVariant.featured_image &&
              previousVariant.featured_image.id === variant.featured_image.id)
          ) {
            return
          }
          var newImage = variant.featured_image
          var mainImageContainer = this.element.querySelector(
            '.FeaturedProduct__Gallery .AspectRatio'
          )
          mainImageContainer.style.cssText = 'max-width: '
            .concat(newImage.width, 'px; --aspect-ratio: ')
            .concat(newImage.width / newImage.height)
          var newImageElement = document.createElement('img')
          newImageElement.classList.add('Image--lazyLoad')
          newImageElement.setAttribute(
            'data-src',
            Image.getSizedImageUrl(newImage.src, '1x1').replace(
              '_1x1.',
              '_{width}x.'
            )
          )
          newImageElement.setAttribute(
            'data-widths',
            '['.concat(
              Image.getSupportedSizes(
                newImage,
                [200, 400, 600, 700, 800, 900, 1000]
              ).join(','),
              ']'
            )
          )
          newImageElement.setAttribute('data-sizes', 'auto')
          mainImageContainer.replaceChild(
            newImageElement,
            mainImageContainer.querySelector('img')
          )
        }
      }
    ])
    return FeaturedProductSection
  })()
  var BackgroundVideoSection = (function () {
    function BackgroundVideoSection (container) {
      _classCallCheck(this, BackgroundVideoSection)
      this.element = container
      this.options = JSON.parse(
        this.element.getAttribute('data-section-settings')
      )
      this._loadScript().then(this._setupPlayer.bind(this))
    }
    _createClass(BackgroundVideoSection, [
      {
        key: '_loadScript',
        value: function _loadScript () {
          var _this = this
          return new Promise(function (resolve, reject) {
            var script = document.createElement('script')
            document.body.appendChild(script)
            script.onload = resolve
            script.onerror = reject
            script.async = !0
            script.src =
              _this.options.videoType === 'youtube'
                ? '//www.youtube.com/iframe_api'
                : '//player.vimeo.com/api/player.js'
          })
        }
      },
      {
        key: 'onUnload',
        value: function onUnload () {
          if (this.player) {
            this.player.destroy()
          }
        }
      },
      {
        key: '_setupPlayer',
        value: function _setupPlayer () {
          var _this2 = this
          var elementToInsert = this.element.querySelector(
            '.ImageHero__VideoHolder'
          )
          var playerLoadingInterval = setInterval(function () {
            if (_this2.options.videoType === 'youtube') {
              if (window.YT) {
                _this2.player = new YT.Player(elementToInsert, {
                  videoId: _this2.options.videoId,
                  playerVars: {
                    showinfo: 0,
                    controls: 0,
                    fs: 0,
                    rel: 0,
                    height: '100%',
                    width: '100%',
                    iv_load_policy: 3,
                    html5: 1,
                    loop: 1,
                    playsinline: 1,
                    modestbranding: 1,
                    disablekb: 1,
                    origin: _this2.options.requestHost
                  },
                  events: {
                    onReady: _this2._onYouTubeReady.bind(_this2),
                    onStateChange: _this2._onYouTubeStateChange.bind(_this2)
                  }
                })
                clearInterval(playerLoadingInterval)
              }
            } else {
              if (window.Vimeo) {
                _this2.player = new Vimeo.Player(elementToInsert.parentNode, {
                  id: _this2.options.videoId,
                  autoplay: !0,
                  autopause: !1,
                  muted: !0,
                  background: !0,
                  loop: !0
                })
                clearInterval(playerLoadingInterval)
              }
            }
          }, 50)
        }
      },
      {
        key: '_onYouTubeReady',
        value: function _onYouTubeReady (event) {
          this.player.mute()
          this.player.playVideo()
        }
      },
      {
        key: '_onYouTubeStateChange',
        value: function _onYouTubeStateChange (event) {
          if (event.data === YT.PlayerState.ENDED) {
            this.player.playVideo()
          }
        }
      }
    ])
    return BackgroundVideoSection
  })()
  var GiftCardSection = (function () {
    function GiftCardSection (container) {
      _classCallCheck(this, GiftCardSection)
      this.element = container
      this._createQrCode()
      this._setupPrint()
    }
    _createClass(GiftCardSection, [
      {
        key: '_createQrCode',
        value: function _createQrCode () {
          var qrCodeElement = document.getElementById('QrCode')
          new QRCode(qrCodeElement, {
            text: qrCodeElement.getAttribute('data-identifier'),
            width: 120,
            height: 120
          })
        }
      },
      {
        key: '_setupPrint',
        value: function _setupPrint () {
          var printElement = document.getElementById('PrintGiftCard')
          if (printElement) {
            printElement.addEventListener('click', function () {
              window.print()
            })
          }
        }
      }
    ])
    return GiftCardSection
  })()
  var HeaderSection = (function () {
    function HeaderSection (container) {
      var _this = this
      _classCallCheck(this, HeaderSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.options = JSON.parse(
        this.element.getAttribute('data-section-settings')
      )
      this.lastScrollPosition = -1
      this.isTouch = window.matchMedia(
        '(-moz-touch-enabled: 1), (hover: none)'
      ).matches
      if (this.options.isSticky) {
        Stickyfill.addOne(this.element.parentNode)
      }
      this.searchBar = new SearchBar()
      this._attachListeners()
      this._verifyNavigationOverlap()
      var mainLogo = this.element.querySelector('.Header__LogoImage--primary')
      if (mainLogo && !mainLogo.complete) {
        mainLogo.addEventListener('load', function () {
          fastdom.measure(function () {
            document.documentElement.style.setProperty(
              '--header-height',
              _this.element.clientHeight + 'px'
            )
            document.documentElement.style.setProperty(
              '--header-is-not-transparent',
              _this.options.hasTransparentHeader ? 0 : 1
            )
          })
        })
      } else {
        fastdom.measure(function () {
          document.documentElement.style.setProperty(
            '--header-height',
            _this.element.clientHeight + 'px'
          )
          document.documentElement.style.setProperty(
            '--header-is-not-transparent',
            _this.options.hasTransparentHeader ? 0 : 1
          )
        })
      }
      window.addEventListener(
        'pageshow',
        this._checkTransparentHeader.bind(this)
      )
      this._setupLocalizationPopovers()
    }
    _createClass(HeaderSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.element.removeEventListener(
            'mouseleave',
            this._closeNavigationListener
          )
          this.element.removeEventListener(
            'mouseenter',
            this._focusNavigationListener
          )
          this.element.removeEventListener(
            'focusin',
            this._focusNavigationListener
          )
          this.delegateElement.off()
          window.removeEventListener(
            'scroll',
            this._checkTransparentHeaderListener
          )
          window.removeEventListener(
            'resize',
            this._verifyNavigationOverlapListener
          )
          if (this.options.isSticky) {
            Stickyfill.removeOne(this.element.parentNode)
          }
          this.searchBar.destroy()
          this.localizationPopovers.forEach(function (localizationPopover) {
            localizationPopover.destroy()
          })
        }
      },
      {
        key: 'onSelect',
        value: function onSelect () {
          this._checkTransparentHeader()
        }
      },
      {
        key: 'onBlockSelect',
        value: function onBlockSelect (event) {
          var _this2 = this
          var listItem = event.target.closest('.HorizontalList__Item')
          fastdom.mutate(function () {
            event.target.setAttribute('aria-hidden', 'false')
            if (listItem) {
              listItem.classList.add('is-expanded')
              Dom.getSiblings(listItem, '.is-expanded').forEach(function (
                item
              ) {
                item.classList.remove('is-expanded')
              })
            }
            _this2.element.classList.remove('Header--transparent')
          })
        }
      },
      {
        key: 'onBlockDeselect',
        value: function onBlockDeselect (event) {
          var listItem = event.target.closest('.HorizontalList__Item')
          fastdom.mutate(function () {
            event.target.setAttribute('aria-hidden', 'true')
            if (listItem) {
              listItem.classList.remove('is-expanded')
            }
          })
          this._checkTransparentHeader()
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._checkTransparentHeaderListener =
            this._checkTransparentHeader.bind(this)
          this._closeNavigationListener = this._closeNavigation.bind(this)
          this._focusNavigationListener = this._focusNavigation.bind(this)
          this._verifyNavigationOverlapListener =
            this._verifyNavigationOverlap.bind(this)
          this.element.addEventListener(
            'mouseleave',
            this._closeNavigationListener
          )
          this.delegateElement.on(
            'mouseenter',
            '.Header__MainNav .HorizontalList__Item, [aria-haspopup]',
            this._openMenu.bind(this),
            !0
          )
          this.delegateElement.on(
            'focusin',
            '[aria-haspopup]',
            this._openMenu.bind(this),
            !0
          )
          this.delegateElement.on(
            'focusout',
            '[aria-haspopup]',
            this._closeMenu.bind(this),
            !1
          )
          this.delegateElement.on(
            'click',
            '[data-action="toggle-search"]',
            this._closeNavigationListener
          )
          this.delegateElement.on(
            'mouseleave',
            '.DropdownMenu [aria-haspopup]',
            this._closeMenu.bind(this),
            !0
          )
          this.delegateElement.on(
            'mouseenter',
            '.DropdownMenu [aria-haspopup]',
            this._adjustDropdownPosition.bind(this),
            !0
          )
          if (this.isTouch) {
            this.delegateElement.on(
              'click',
              '.Header__MainNav [aria-haspopup]',
              this._handleTouchMenu.bind(this)
            )
          }
          if (this.options.hasTransparentHeader) {
            this.element.addEventListener(
              'mouseenter',
              this._focusNavigationListener
            )
            this.element.addEventListener(
              'focusin',
              this._focusNavigationListener
            )
          }
          if (this.options.isSticky && this.options.hasTransparentHeader) {
            window.addEventListener(
              'scroll',
              this._checkTransparentHeaderListener
            )
          }
          if (
            this.options.navigationStyle === 'inline' ||
            this.options.navigationStyle === 'logoLeft'
          ) {
            window.addEventListener(
              'resize',
              this._verifyNavigationOverlapListener
            )
          }
        }
      },
      {
        key: '_setupLocalizationPopovers',
        value: function _setupLocalizationPopovers () {
          this.localizationPopovers = []
          Dom.nodeListToArray(
            document.querySelectorAll('#header-locale-popover')
          ).forEach(function (item, index) {
            item.id = ''.concat(item.id, '-').concat(index)
          })
          Dom.nodeListToArray(
            document.querySelectorAll('[aria-controls="header-locale-popover"]')
          ).forEach(function (item, index) {
            item.setAttribute(
              'aria-controls',
              ''.concat(item.getAttribute('aria-controls'), '-').concat(index)
            )
          })
          Dom.nodeListToArray(
            document.querySelectorAll('#header-currency-popover')
          ).forEach(function (item, index) {
            item.id = ''.concat(item.id, '-').concat(index)
          })
          Dom.nodeListToArray(
            document.querySelectorAll(
              '[aria-controls="header-currency-popover"]'
            )
          ).forEach(function (item, index) {
            item.setAttribute(
              'aria-controls',
              ''.concat(item.getAttribute('aria-controls'), '-').concat(index)
            )
          })
          var localePopoverElement1 = document.getElementById(
            'header-locale-popover-0'
          )
          if (localePopoverElement1) {
            this.localizationPopovers.push(
              new Popover(localePopoverElement1, {
                preferredAlignment: 'center',
                preferredPosition: 'bottom',
                threshold: 12
              })
            )
          }
          var localePopoverElement2 = document.getElementById(
            'header-locale-popover-1'
          )
          if (localePopoverElement2) {
            this.localizationPopovers.push(
              new Popover(localePopoverElement2, {
                preferredAlignment: 'center',
                preferredPosition: 'bottom',
                threshold: 12
              })
            )
          }
          var currencyPopoverElement1 = document.getElementById(
            'header-currency-popover-0'
          )
          if (currencyPopoverElement1) {
            this.localizationPopovers.push(
              new Popover(currencyPopoverElement1, {
                preferredAlignment: 'center',
                preferredPosition: 'bottom',
                threshold: 12
              })
            )
          }
          var currencyPopoverElement2 = document.getElementById(
            'header-currency-popover-1'
          )
          if (currencyPopoverElement2) {
            this.localizationPopovers.push(
              new Popover(currencyPopoverElement2, {
                preferredAlignment: 'center',
                preferredPosition: 'bottom',
                threshold: 12
              })
            )
          }
        }
      },
      {
        key: '_focusNavigation',
        value: function _focusNavigation () {
          var _this3 = this
          fastdom.mutate(function () {
            if (!_this3.isTouch || Responsive.matchesBreakpoint('desk')) {
              _this3.element.classList.remove('Header--transparent')
            }
          })
        }
      },
      {
        key: '_closeNavigation',
        value: function _closeNavigation () {
          var _this4 = this
          fastdom.mutate(function () {
            Dom.nodeListToArray(
              _this4.element.querySelectorAll('.is-expanded')
            ).forEach(function (item) {
              item.classList.remove('is-expanded')
            })
            Dom.nodeListToArray(
              _this4.element.querySelectorAll(
                '.Header__MainNav [aria-hidden="false"]'
              )
            ).forEach(function (item) {
              item.setAttribute('aria-hidden', 'true')
            })
          })
          if (this.options.hasTransparentHeader) {
            this._checkTransparentHeader()
          }
        }
      },
      {
        key: '_openMenu',
        value: function _openMenu (event, target) {
          if (event.type === 'mouseenter' && target !== event.target) {
            return
          }
          fastdom.mutate(function () {
            target.classList.add('is-expanded')
            Dom.nodeListToArray(
              target.children,
              '.Header__MainNav [aria-hidden="true"]'
            ).forEach(function (item) {
              item.setAttribute('aria-hidden', 'false')
            })
            Dom.getSiblings(target, '.is-expanded').forEach(function (item) {
              item.classList.remove('is-expanded')
              Dom.nodeListToArray(
                item.children,
                '.Header__MainNav [aria-hidden="false"]'
              ).forEach(function (item) {
                item.setAttribute('aria-hidden', 'true')
              })
            })
          })
        }
      },
      {
        key: '_closeMenu',
        value: function _closeMenu (event, target) {
          if (event.type === 'mouseleave' && target !== event.target) {
            return
          }
          fastdom.mutate(function () {
            target.classList.remove('is-expanded')
            Dom.nodeListToArray(
              target.children,
              '.Header__MainNav [aria-hidden="false"]'
            ).forEach(function (item) {
              item.setAttribute('aria-hidden', 'true')
            })
          })
        }
      },
      {
        key: '_adjustDropdownPosition',
        value: function _adjustDropdownPosition (event, target) {
          var nestedMenus = Dom.nodeListToArray(
              target.querySelectorAll('.DropdownMenu')
            ),
            shouldOpenLeft = !1
          fastdom.measure(function () {
            var windowWidth = window.innerWidth,
              rightEdge = target.getBoundingClientRect().right
            nestedMenus.forEach(function (item) {
              if (rightEdge + item.offsetWidth > windowWidth) {
                shouldOpenLeft = !0
              }
            })
          })
          fastdom.mutate(function () {
            if (shouldOpenLeft) {
              nestedMenus.forEach(function (item) {
                item.classList.add('DropdownMenu--reversed')
              })
            } else {
              nestedMenus.forEach(function (item) {
                item.classList.remove('DropdownMenu--reversed')
              })
            }
          })
        }
      },
      {
        key: '_handleTouchMenu',
        value: function _handleTouchMenu (event, target) {
          if (!target.classList.contains('is-expanded')) {
            event.preventDefault()
          }
        }
      },
      {
        key: '_verifyNavigationOverlap',
        value: function _verifyNavigationOverlap () {
          var _this5 = this
          var isOverlapping = !1,
            mainTopMenu = this.element.querySelector('.Header__MainNav')
          fastdom.measure(function () {
            if (mainTopMenu) {
              var firstNavElementHeight = Dom.outerHeightWithMargin(
                  mainTopMenu.querySelector('.HorizontalList__Item')
                ),
                mainNavHeight = mainTopMenu.scrollHeight
              if (mainNavHeight > firstNavElementHeight) {
                isOverlapping = !0
              }
            }
          })
          this.element.classList.remove(
            'Header--logoLeft',
            'Header--inline',
            'Header--center'
          )
          this.element.classList.add(
            'Header--'.concat(this.options.navigationStyle)
          )
          this.element.clientWidth
          fastdom.mutate(function () {
            if (isOverlapping) {
              _this5.element.classList.remove(
                'Header--'.concat(_this5.options.navigationStyle)
              )
              _this5.element.classList.add('Header--center')
              if (mainTopMenu) {
                var itemTopSet = new Set()
                Array.from(
                  mainTopMenu.querySelectorAll('.HorizontalList__Item')
                ).forEach(function (item) {
                  itemTopSet.add(item.getBoundingClientRect().top)
                })
                isOverlapping = itemTopSet.size > 1
              }
            } else {
              _this5.element.classList.add(
                'Header--'.concat(_this5.options.navigationStyle)
              )
              _this5.element.classList.remove('Header--center')
            }
            var logo = _this5.element.querySelector('.Header__FlexItem--logo')
            logo.classList.toggle(
              'Header__FlexItem--increaseSpace',
              isOverlapping
            )
            _this5.element.classList.add('Header--initialized')
            fastdom.measure(function () {
              document.documentElement.style.setProperty(
                '--header-height',
                _this5.element.clientHeight + 'px'
              )
            })
          })
        }
      },
      {
        key: '_checkTransparentHeader',
        value: function _checkTransparentHeader () {
          var _this6 = this
          if (!this.options.hasTransparentHeader) {
            return
          }
          var scrollThreshold = 10
          fastdom.measure(function () {
            _this6.lastScrollPosition = window.pageYOffset
          })
          fastdom.mutate(function () {
            if (_this6.lastScrollPosition <= scrollThreshold) {
              _this6.element.classList.add('Header--transparent')
            } else {
              _this6.element.classList.remove('Header--transparent')
            }
          })
        }
      }
    ])
    return HeaderSection
  })()
  var FooterSection = (function () {
    function FooterSection (container) {
      _classCallCheck(this, FooterSection)
      this.element = container
      var localePopoverElement = document.getElementById(
        'footer-locale-popover'
      )
      if (localePopoverElement) {
        this.localePopover = new Popover(localePopoverElement, {
          preferredAlignment: 'center',
          preferredPosition: 'top',
          threshold: 12
        })
      }
      var currencyPopoverElement = document.getElementById(
        'footer-currency-popover'
      )
      if (currencyPopoverElement) {
        this.currencyPopover = new Popover(currencyPopoverElement, {
          preferredAlignment: 'center',
          preferredPosition: 'top',
          threshold: 12
        })
      }
    }
    _createClass(FooterSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          if (this.localePopover) {
            this.localePopover.destroy()
          }
          if (this.currencyPopover) {
            this.currencyPopover.destroy()
          }
        }
      }
    ])
    return FooterSection
  })()
  var ImageWithTextBlockSection = (function () {
    function ImageWithTextBlockSection (container) {
      _classCallCheck(this, ImageWithTextBlockSection)
      this.element = container
    }
    _createClass(ImageWithTextBlockSection, [
      {
        key: 'onUnload',
        value: function onUnload () {}
      }
    ])
    return ImageWithTextBlockSection
  })()
  var LoginSection = (function () {
    function LoginSection (container) {
      _classCallCheck(this, LoginSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.timelineLite = new TimelineLite()
      this.customerLoginForm = this.element.querySelector('#customer_login')
      this.recoverPasswordForm = this.element.querySelector(
        '#recover_customer_password'
      )
      this.delegateElement.on(
        'click',
        '[data-action="toggle-recover-form"]',
        this._showRecoverPassword.bind(this)
      )
    }
    _createClass(LoginSection, [
      {
        key: '_showRecoverPassword',
        value: function _showRecoverPassword () {
          var isLoginActive = this.customerLoginForm.style.display === 'block'
          if (isLoginActive) {
            this.timelineLite
              .fromTo(
                this.customerLoginForm,
                0.5,
                {
                  autoAlpha: 1,
                  display: 'block',
                  y: 0
                },
                {
                  autoAlpha: 0,
                  y: 20,
                  display: 'none'
                }
              )
              .fromTo(
                this.recoverPasswordForm,
                0.5,
                {
                  autoAlpha: 0,
                  display: 'none',
                  y: 20
                },
                {
                  autoAlpha: 1,
                  display: 'block',
                  y: 0,
                  delay: 0.25
                }
              )
          } else {
            this.timelineLite
              .fromTo(
                this.recoverPasswordForm,
                0.5,
                {
                  autoAlpha: 1,
                  display: 'block',
                  y: 0
                },
                {
                  autoAlpha: 0,
                  y: 20,
                  display: 'none'
                }
              )
              .fromTo(
                this.customerLoginForm,
                0.5,
                {
                  autoAlpha: 0,
                  display: 'none',
                  y: 20
                },
                {
                  autoAlpha: 1,
                  display: 'block',
                  y: 0,
                  delay: 0.25
                }
              )
          }
        }
      }
    ])
    return LoginSection
  })()
  var MapSection = (function () {
    function MapSection (element) {
      _classCallCheck(this, MapSection)
      this.element = element
      this.options = JSON.parse(element.getAttribute('data-section-settings'))
      if (this.options.apiKey && this.options.mapAddress) {
        this._loadScript().then(this._initMap.bind(this))
      }
    }
    _createClass(MapSection, [
      {
        key: '_loadScript',
        value: function _loadScript () {
          var _this = this
          return new Promise(function (resolve, reject) {
            var script = document.createElement('script')
            document.body.appendChild(script)
            script.onload = resolve
            script.onerror = reject
            script.async = !0
            script.src = 'https://maps.googleapis.com/maps/api/js?key='.concat(
              _this.options.apiKey
            )
          })
        }
      },
      {
        key: '_initMap',
        value: function _initMap () {
          var _this2 = this
          var geocoder = new google.maps.Geocoder()
          geocoder.geocode(
            {
              address: this.options.mapAddress
            },
            function (results, status) {
              if (status !== google.maps.GeocoderStatus.OK) {
                if (Shopify.designMode);
              } else {
                var mapOptions = {
                  zoom: _this2.options.zoom,
                  center: results[0].geometry.location,
                  draggable: !1,
                  clickableIcons: !1,
                  scrollwheel: !1,
                  disableDoubleClickZoom: !0,
                  disableDefaultUI: !0
                }
                var map = new google.maps.Map(
                    _this2.element.querySelector('.FeaturedMap__GMap'),
                    mapOptions
                  ),
                  center = map.getCenter()
                map.setCenter(center)
                var icon = {
                  path: 'M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z',
                  fillColor: _this2.options.markerColor,
                  fillOpacity: 1,
                  anchor: new google.maps.Point(15, 55),
                  strokeWeight: 0,
                  scale: 0.6
                }
                new google.maps.Marker({
                  map: map,
                  position: map.getCenter(),
                  icon: icon
                })
                var styledMapType = new google.maps.StyledMapType(
                  JSON.parse(
                    _this2.element.querySelector('[data-gmap-style]').innerHTML
                  )
                )
                map.mapTypes.set('styled_map', styledMapType)
                map.setMapTypeId('styled_map')
                google.maps.event.addDomListener(window, 'resize', function () {
                  google.maps.event.trigger(map, 'resize')
                  map.setCenter(center)
                })
              }
            }
          )
        }
      }
    ])
    return MapSection
  })()
  var NewsletterPopupSection = (function () {
    function NewsletterPopupSection (element) {
      _classCallCheck(this, NewsletterPopupSection)
      this.element = element
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.options = JSON.parse(element.getAttribute('data-section-settings'))
      try {
        if (
          window.location.hash === '#newsletter-popup' &&
          window.theme.pageType !== null
        ) {
          this._openPopup()
        } else if (
          !this.options.showOnlyOnce ||
          (this.options.showOnlyOnce &&
            localStorage.getItem('themePopup') === null)
        ) {
          setTimeout(
            this._openPopup.bind(this),
            this.options.apparitionDelay * 1000
          )
        }
      } catch (error) {}
      this._attachListeners()
    }
    _createClass(NewsletterPopupSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.delegateElement.off()
        }
      },
      {
        key: 'onSelect',
        value: function onSelect () {
          this._openPopup()
        }
      },
      {
        key: 'onDeselect',
        value: function onDeselect () {
          this._closePopup()
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'click',
            '[data-action="close-popup"]',
            this._closePopup.bind(this)
          )
        }
      },
      {
        key: '_openPopup',
        value: function _openPopup () {
          this.element.setAttribute('aria-hidden', 'false')
          localStorage.setItem('themePopup', 'true')
        }
      },
      {
        key: '_closePopup',
        value: function _closePopup () {
          this.element.setAttribute('aria-hidden', 'true')
        }
      }
    ])
    return NewsletterPopupSection
  })()
  var ProductRecommendationsSection = (function () {
    function ProductRecommendationsSection (container) {
      _classCallCheck(this, ProductRecommendationsSection)
      this.element = container
      this.options = JSON.parse(
        this.element.getAttribute('data-section-settings')
      )
      if (this.options.useRecommendations) {
        this._loadRecommendations().then(this._createSlideshow.bind(this))
      } else {
        this._createSlideshow()
      }
    }
    _createClass(ProductRecommendationsSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.carousel.destroy()
        }
      },
      {
        key: '_loadRecommendations',
        value: function _loadRecommendations () {
          var _this = this
          var url = ''
            .concat(window.routes.productRecommendationsUrl, '?section_id=')
            .concat(
              this.element.getAttribute('data-section-id'),
              '&product_id='
            )
            .concat(this.options.productId, '&limit=')
            .concat(this.options.recommendationsCount)
          return fetch(url).then(function (response) {
            return response.text().then(function (content) {
              var container = document.createElement('div')
              container.innerHTML = content
              _this.element.querySelector('.ProductRecommendations').innerHTML =
                container.querySelector('.ProductRecommendations').innerHTML
            })
          })
        }
      },
      {
        key: '_createSlideshow',
        value: function _createSlideshow () {
          var flickityElement = this.element.querySelector(
            '[data-flickity-config]'
          )
          if (!flickityElement) {
            return
          }
          this.carousel = new Carousel(flickityElement)
          new ProductItemColorSwatch(this.element)
        }
      }
    ])
    return ProductRecommendationsSection
  })()
  var ProductSection = (function () {
    function ProductSection (container) {
      var _this = this
      _classCallCheck(this, ProductSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.options = JSON.parse(
        this.element.getAttribute('data-section-settings')
      )
      this.viewInSpaceElement = this.element.querySelector('[data-shopify-xr]')
      this.productVariants = null //new ProductVariants(container, this.options);
      this.productReviews = new ProductReviews(container)
      // var productSlideshowElement = this.element.querySelector('.Product__Slideshow');
      // if (productSlideshowElement) {
      //     this.productSlideshow = new Carousel(productSlideshowElement, {
      //         onSelect: this._onImageChanged.bind(this),
      //         onSettle: this._onImageSettled.bind(this)
      //     }, {
      //         draggable: !Responsive.matchesBreakpoint('supports-hover')
      //     });
      //     this.mediaList = {};
      //     this.previouslySelectedMedia = null;
      //     productSlideshowElement.querySelectorAll('[data-media-type="model"]').forEach(function(model) {
      //         _this.mediaList[model.getAttribute('data-media-id')] = new ProductModel(model, _this.options.stackProductImages)
      //     });
      //     productSlideshowElement.querySelectorAll('[data-media-type="video"], [data-media-type="external_video"]').forEach(function(video) {
      //         _this.mediaList[video.getAttribute('data-media-id')] = new ProductVideo(video, _this.options.stackProductImages, _this.options.enableVideoLooping)
      //     });
      //     if (this.options.stackProductImages) {
      //         this.slideshowNavDots = this.element.querySelector('.Product__SlideshowNav--dots');
      //         this.slideshowNavDotsItems = this.slideshowNavDots ? Dom.nodeListToArray(this.slideshowNavDots.querySelectorAll('a')) : []
      //     }
      //     if (this.options.showThumbnails) {
      //         this.slideshowNavThumbnails = this.element.querySelector('.Product__SlideshowNav--thumbnails');
      //         this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails ? Dom.nodeListToArray(this.slideshowNavThumbnails.querySelectorAll('.Product__SlideshowNavImage')) : []
      //     }
      //     this.slideshowImages = Dom.nodeListToArray(productSlideshowElement.querySelectorAll('.Carousel__Cell'));
      //     this._setupSlideshowMobileNav()
      // }
      this.productWrapperElement =
        this.element.querySelector('.Product__Wrapper')
      this.productInfoElement = this.element.querySelector('.Product__Info')
      this.productAsideElement = this.element.querySelector('.Product__Aside')
      this.productGalleryElement =
        this.element.querySelector('.Product__Gallery')
      this.quickNav = this.element.querySelector('.Product__QuickNav')
      if (this.options.enableImageZoom) {
        this.imageZoomInstance = new ProductImageZoom(
          this.element,
          this.productSlideshow
        )
      }
      Stickyfill.addOne(this.productInfoElement)
      var offscreenElement = this.element.querySelector('.Product__OffScreen')
      if (offscreenElement) {
        this.element.appendChild(offscreenElement)
      }
      this._setupDeviceFeatures()
      this._attachListeners()
    }
    _createClass(ProductSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.delegateElement.off('click')
          this.productReviews.destroy()
          if (this.productVariants) {
            this.productVariants.destroy()
          }
          if (this.productSlideshow) {
            this.productSlideshow.destroy()
          }
          if (this.options.enableImageZoom) {
            this.imageZoomInstance.destroy()
          }
          if (this.carouselNavScrollSpy) {
            this.carouselNavScrollSpy.destroy()
          }
          if (this.quickNav) {
            window.removeEventListener('scroll', this._checkQuickNavListener)
          }
          if (this.productInfoScroller) {
            this.productInfoScroller.destroy()
          }
          if (this.productThumbnailsScroller) {
            this.productThumbnailsScroller.destroy()
          }
          if (window.ResizeObserver && this.productInfoResizeObserver) {
            this.productInfoResizeObserver.disconnect()
          }
          Stickyfill.removeOne(this.productInfoElement)
          document.removeEventListener(
            'breakpoint:changed',
            this._onBreakpointChangedListener
          )
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._onBreakpointChangedListener =
            this._setupDeviceFeatures.bind(this)
          this._checkQuickNavListener = this._checkQuickNav.bind(this)
          this.delegateElement.on(
            'click',
            '[data-action="toggle-social-share"]',
            this._toggleSocialShare.bind(this)
          )
          this.delegateElement.on(
            'variant:changed',
            this._updateSlideshowImage.bind(this)
          )
          this.delegateElement.on(
            'scrollspy:target:changed',
            this._onScrollTargetChanged.bind(this)
          )
          this.delegateElement.on(
            'model:played',
            this._onMediaPlayed.bind(this)
          )
          this.delegateElement.on(
            'video:played',
            this._onMediaPlayed.bind(this)
          )
          this.delegateElement.on(
            'model:paused',
            this._onMediaPaused.bind(this)
          )
          this.delegateElement.on(
            'video:paused',
            this._onMediaPaused.bind(this)
          )
          document.addEventListener(
            'breakpoint:changed',
            this._onBreakpointChangedListener
          )
          if (this.quickNav) {
            window.addEventListener('scroll', this._checkQuickNavListener)
          }
          this.delegateElement.on(
            'click',
            '.Product__SlideshowNavImage',
            this._switchToImage.bind(this)
          )
        }
      },
      {
        key: '_setupSlideshowMobileNav',
        value: function _setupSlideshowMobileNav () {
          var _this2 = this
          this.slideshowMobileNav = this.element.querySelector(
            '.Product__SlideshowMobileNav'
          )
          if (this.slideshowMobileNav) {
            var slideshowMobileNavDelegate = new domDelegate.Delegate(
              this.slideshowMobileNav
            )
            slideshowMobileNavDelegate.on(
              'click',
              '.dot',
              function (event, element) {
                _this2._slideWillChange()
                _this2.productSlideshow.selectCell(
                  parseInt(element.getAttribute('data-index'))
                )
              }
            )
            slideshowMobileNavDelegate.on(
              'click',
              '.Product__SlideshowNavArrow',
              function (event, element) {
                _this2._slideWillChange()
                if (element.getAttribute('data-direction') === 'next') {
                  _this2.productSlideshow.next()
                } else {
                  _this2.productSlideshow.previous()
                }
              }
            )
          }
        }
      },
      {
        key: '_updateSlideshowImage',
        value: function _updateSlideshowImage (event) {
          var variant = event.detail.variant,
            previousVariant = event.detail.previousVariant
          if (
            !variant ||
            !variant.featured_media ||
            (previousVariant &&
              previousVariant.featured_media &&
              previousVariant.featured_media.id === variant.featured_media.id)
          ) {
            return
          }
          this._slideWillChange()
          if (
            Responsive.matchesBreakpoint('pocket') ||
            !this.options.stackProductImages
          ) {
            for (
              var i = 0;
              i !== this.productSlideshow.flickityInstance.cells.length;
              ++i
            ) {
              var cellElement =
                  this.productSlideshow.flickityInstance.cells[i].element,
                mediaId = parseInt(cellElement.getAttribute('data-media-id'))
              if (mediaId === variant.featured_media.id) {
                this.productSlideshow.selectCell(
                  parseInt(cellElement.getAttribute('data-media-position')) - 1
                )
              }
            }
          } else {
            document
              .querySelector(
                '[href="#Media'.concat(variant.featured_media.id, '"]')
              )
              .click()
          }
        }
      },
      {
        key: '_onMediaPlayed',
        value: function _onMediaPlayed (event) {
          this.productSlideshow.getFlickityInstance().options.draggable = !1
          this.productSlideshow.getFlickityInstance().unbindDrag()
          if (
            this.previouslySelectedMedia &&
            this.previouslySelectedMedia !== event.target
          ) {
            this.mediaList[
              this.previouslySelectedMedia.getAttribute('data-media-id')
            ].hasBeenDeselected()
          }
          if (this.options.stackProductImages) {
            this.previouslySelectedMedia = event.target
          }
        }
      },
      {
        key: '_onMediaPaused',
        value: function _onMediaPaused () {
          this.productSlideshow.getFlickityInstance().options.draggable =
            !Responsive.matchesBreakpoint('supports-hover')
          this.productSlideshow.getFlickityInstance().bindDrag()
        }
      },
      {
        key: '_handleMedia',
        value: function _handleMedia (item) {
          if (
            this.previouslySelectedMedia &&
            this.previouslySelectedMedia !== item
          ) {
            switch (
              this.previouslySelectedMedia.getAttribute('data-media-type')
            ) {
              case 'video':
              case 'external_video':
              case 'model':
                this.mediaList[
                  this.previouslySelectedMedia.getAttribute('data-media-id')
                ].hasBeenDeselected()
            }
            if (
              this.previouslySelectedMedia.getAttribute('data-media-type') ===
                'model' &&
              this.viewInSpaceElement
            ) {
              this.viewInSpaceElement.setAttribute(
                'data-shopify-model3d-id',
                this.viewInSpaceElement.getAttribute(
                  'data-shopify-model3d-default-id'
                )
              )
            }
          }
          switch (item.getAttribute('data-media-type')) {
            case 'video':
            case 'external_video':
            case 'model':
              this.mediaList[
                item.getAttribute('data-media-id')
              ].hasBeenSelected()
              break
          }
          if (
            item.getAttribute('data-media-type') === 'model' &&
            this.viewInSpaceElement
          ) {
            this.viewInSpaceElement.setAttribute(
              'data-shopify-model3d-id',
              item.getAttribute('data-media-id')
            )
          }
          this.previouslySelectedMedia = item
        }
      },
      {
        key: '_onScrollTargetChanged',
        value: function _onScrollTargetChanged (event) {
          if (this.options.stackProductImages) {
            this.slideshowNavDotsItems.forEach(function (item) {
              return item.classList.remove('is-selected')
            })
            this.slideshowNavDotsItems[
              parseInt(
                event.detail.newTarget.getAttribute('data-media-position')
              ) - 1
            ].classList.add('is-selected')
            if (this.options.showThumbnails) {
              this.slideshowNavThumbnailsItems.forEach(function (item) {
                return item.classList.remove('is-selected')
              })
              this.slideshowNavThumbnailsItems[
                parseInt(
                  event.detail.newTarget.getAttribute('data-media-position')
                ) - 1
              ].classList.add('is-selected')
            }
          }
        }
      },
      {
        key: '_switchToImage',
        value: function _switchToImage (event, target) {
          event.preventDefault()
          console.log(parseInt(target.getAttribute('data-media-id')))
          this._slideWillChange()
          for (
            var i = 0;
            i !== this.productSlideshow.flickityInstance.cells.length;
            ++i
          ) {
            var cellElement =
                this.productSlideshow.flickityInstance.cells[i].element,
              mediaId = parseInt(cellElement.getAttribute('data-media-id'))
            if (mediaId === parseInt(target.getAttribute('data-media-id'))) {
              this.productSlideshow.selectCell(
                parseInt(cellElement.getAttribute('data-media-position')) - 1
              )
            }
          }
        }
      },
      {
        key: '_checkQuickNav',
        value: function _checkQuickNav () {
          var _this3 = this
          var showAsideQuickNav = !1
          fastdom.measure(function () {
            showAsideQuickNav =
              window.scrollY >=
              _this3.productAsideElement.offsetTop -
                _this3.productAsideElement.clientHeight
          })
          fastdom.mutate(function () {
            if (showAsideQuickNav) {
              _this3.quickNav.classList.add('is-flipped')
            } else {
              _this3.quickNav.classList.remove('is-flipped')
            }
          })
        }
      },
      {
        key: '_toggleSocialShare',
        value: function _toggleSocialShare (event, target) {
          target.classList.toggle('is-active')
          target.classList.toggle('RoundButton--secondaryState')
          target.setAttribute(
            'aria-expanded',
            target.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
          )
          target.nextElementSibling.setAttribute(
            'aria-hidden',
            target.nextElementSibling.getAttribute('aria-hidden') === 'true'
              ? 'false'
              : 'true'
          )
        }
      },
      {
        key: '_onImageChanged',
        value: function _onImageChanged (event, cell) {
          if (Responsive.matchesBreakpoint('pocket')) {
            var productGalleryActionListElement = this.element.querySelector(
              '.Product__Gallery .Product__ActionList'
            )
            if (productGalleryActionListElement) {
              if (cell.classList.contains('Product__SlideItem--image')) {
                productGalleryActionListElement.classList.remove('is-hidden')
              } else {
                productGalleryActionListElement.classList.add('is-hidden')
              }
            }
          }
          if (!this.options.stackProductImages && this.options.showThumbnails) {
            var mediaId = cell.getAttribute('data-media-id')
            this.slideshowNavThumbnailsItems.forEach(function (thumbnail) {
              if (thumbnail.getAttribute('data-media-id') === mediaId) {
                thumbnail.classList.add('is-selected')
              } else {
                thumbnail.classList.remove('is-selected')
              }
            })
          }
          if (this.slideshowMobileNav) {
            var selectedIndex =
              parseInt(cell.getAttribute('data-media-position')) - 1
            Dom.nodeListToArray(
              this.slideshowMobileNav.querySelectorAll('.dot')
            ).forEach(function (item, index) {
              if (index === selectedIndex) {
                item.classList.add('is-selected')
              } else {
                item.classList.remove('is-selected')
              }
            })
          }
        }
      },
      {
        key: '_onImageSettled',
        value: function _onImageSettled (index, cell) {
          this._handleMedia(cell)
          if (Responsive.matchesBreakpoint('lap-and-up')) {
            var slides = this.element.querySelectorAll(
              '.Product__SlideItem:not(.is-selected)'
            )
            slides.forEach(function (slide) {
              slide.classList.add('Product__SlideItem--hidden')
            })
          }
        }
      },
      {
        key: '_slideWillChange',
        value: function _slideWillChange () {
          if (Responsive.matchesBreakpoint('lap-and-up')) {
            var slides = this.element.querySelectorAll('.Product__SlideItem')
            slides.forEach(function (slide) {
              slide.classList.remove('Product__SlideItem--hidden')
            })
          }
        }
      },
      {
        key: '_setupDeviceFeatures',
        value: function _setupDeviceFeatures (event) {
          var _this4 = this
          var currentBreakpoint = event
              ? event.detail.currentBreakpoint
              : Responsive.getCurrentBreakpoint(),
            previousBreakpoint = event ? event.detail.previousBreakpoint : null
          if (currentBreakpoint === previousBreakpoint) {
            return
          }
          if (currentBreakpoint === 'phone' || currentBreakpoint === 'tablet') {
            if (this.carouselNavScrollSpy) {
              this.carouselNavScrollSpy.destroy()
            }
            if (this.productInfoScroller) {
              this.productInfoScroller.destroy()
            }
            if (this.productThumbnailsScroller) {
              this.productThumbnailsScroller.destroy()
            }
            if (this.productAsideElement) {
              this.productAsideElement.style.minHeight = null
            } else {
              this.productWrapperElement.style.minHeight = null
            }
            this.productInfoElement.parentNode.style.maxHeight = null
          } else {
            if (this.slideshowImages && this.slideshowImages.length > 1) {
              var offsetTop = 0
              if (this.options.stackProductImages && this.slideshowNavDots) {
                offsetTop = this.slideshowNavDots.firstElementChild.offsetTop
              }
              if (
                this.options.showThumbnails &&
                Responsive.matchesBreakpoint('desk')
              ) {
                offsetTop = 250
              }
              this.carouselNavScrollSpy = new ScrollSpy(
                this.element,
                this.slideshowImages,
                {
                  rootMargin: '-'.concat(offsetTop, 'px 0px 0px 0px')
                }
              )
            }
            var productInfoStyles = window.getComputedStyle(
                this.productInfoElement
              ),
              productInfoPadding =
                parseInt(productInfoStyles.paddingTop) +
                parseInt(productInfoStyles.paddingBottom),
              productGalleryHeight = this.productGalleryElement
                ? parseInt(this.productGalleryElement.scrollHeight)
                : 0
            // Disabled: calculateMinHeight was causing excessive min-height on Product wrapper
            // var calculateMinHeight = function calculateMinHeight() {
            //     if (_this4.productAsideElement) {
            //         _this4.productAsideElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - productInfoPadding - productGalleryHeight, "px");
            //         _this4.productInfoElement.closest('.Product__InfoWrapper').style.maxHeight = _this4.productAsideElement.offsetTop + _this4.productInfoElement.scrollHeight - productInfoPadding + 'px'
            //     } else {
            //         _this4.productWrapperElement.style.minHeight = "".concat(_this4.productInfoElement.scrollHeight - parseInt(productInfoStyles.paddingTop), "px")
            //     }
            // };
            // calculateMinHeight();
            // if (window.ResizeObserver) {
            //     this.productInfoResizeObserver = new ResizeObserver(function() {
            //         calculateMinHeight()
            //     });
            //     this.productInfoResizeObserver.observe(this.productInfoElement)
            // }
            this.productInfoScroller = new OverflowScroller(
              this.productInfoElement
            )
            if (this.options.showThumbnails && this.slideshowNavThumbnails) {
              this.productThumbnailsScroller = new OverflowScroller(
                this.slideshowNavThumbnails
              )
            }
          }
        }
      }
    ])
    return ProductSection
  })()
  var RecentlyViewedProductsSection = (function () {
    function RecentlyViewedProductsSection (container) {
      _classCallCheck(this, RecentlyViewedProductsSection)
      this.element = container
      this.options = JSON.parse(
        this.element.getAttribute('data-section-settings')
      )
      new ProductItemColorSwatch(this.element)
      this._fetchProducts()
    }
    _createClass(RecentlyViewedProductsSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          if (this.carousel) {
            this.carousel.destroy()
          }
        }
      },
      {
        key: '_fetchProducts',
        value: function _fetchProducts () {
          var _this = this
          var queryString = this._getSearchQueryString()
          if (queryString === '') {
            return
          }
          fetch(
            ''
              .concat(window.routes.searchUrl, '?section_id=')
              .concat(
                this.element.getAttribute('data-section-id'),
                '&type=product&q='
              )
              .concat(queryString),
            {
              credentials: 'same-origin',
              method: 'GET'
            }
          ).then(function (response) {
            response.text().then(function (content) {
              var tempElement = document.createElement('div')
              tempElement.innerHTML = content
              _this.element.innerHTML =
                tempElement.querySelector('.Section').innerHTML
              _this.element.parentNode.style.display = 'block'
              _this.carousel = new Carousel(
                _this.element.querySelector('[data-flickity-config]')
              )
            })
          })
        }
      },
      {
        key: '_getSearchQueryString',
        value: function _getSearchQueryString () {
          var items = JSON.parse(
            localStorage.getItem('recentlyViewedProducts') || '[]'
          )
          if (items.includes(this.options.productId)) {
            items.splice(items.indexOf(this.options.productId), 1)
          }
          return items
            .map(function (item) {
              return 'id:' + item
            })
            .join(' OR ')
        }
      }
    ])
    return RecentlyViewedProductsSection
  })()
  var SectionContainer = (function () {
    function SectionContainer () {
      _classCallCheck(this, SectionContainer)
      this.constructors = []
      this.instances = []
      this._attachListeners()
    }
    _createClass(SectionContainer, [
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          document.addEventListener(
            'shopify:section:load',
            this._onSectionLoad.bind(this)
          )
          document.addEventListener(
            'shopify:section:unload',
            this._onSectionUnload.bind(this)
          )
          document.addEventListener(
            'shopify:section:select',
            this._onSelect.bind(this)
          )
          document.addEventListener(
            'shopify:section:deselect',
            this._onDeselect.bind(this)
          )
          document.addEventListener(
            'shopify:section:reorder',
            this._onReorder.bind(this)
          )
          document.addEventListener(
            'shopify:block:select',
            this._onBlockSelect.bind(this)
          )
          document.addEventListener(
            'shopify:block:deselect',
            this._onBlockDeselect.bind(this)
          )
        }
      },
      {
        key: 'register',
        value: function register (type, constructor) {
          var _this = this
          this.constructors[type] = constructor
          Dom.nodeListToArray(
            document.querySelectorAll('[data-section-type='.concat(type, ']'))
          ).forEach(function (container) {
            _this._createInstance(container, constructor)
          })
        }
      },
      {
        key: '_findInstance',
        value: function _findInstance (array, key, value) {
          for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
              return array[i]
            }
          }
        }
      },
      {
        key: '_removeInstance',
        value: function _removeInstance (array, key, value) {
          var i = array.length
          while (i--) {
            if (array[i][key] === value) {
              array.splice(i, 1)
              break
            }
          }
          return array
        }
      },
      {
        key: '_onSectionLoad',
        value: function _onSectionLoad (event) {
          var container = event.target.querySelector('[data-section-id]')
          if (container) {
            this._createInstance(container)
          }
        }
      },
      {
        key: '_onSectionUnload',
        value: function _onSectionUnload (event) {
          var instance = this._findInstance(
            this.instances,
            'id',
            event.detail.sectionId
          )
          if (!instance) {
            return
          }
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(event)
          }
          this.instances = this._removeInstance(
            this.instances,
            'id',
            event.detail.sectionId
          )
        }
      },
      {
        key: '_onSelect',
        value: function _onSelect (event) {
          var instance = this._findInstance(
            this.instances,
            'id',
            event.detail.sectionId
          )
          if (instance && typeof instance.onSelect === 'function') {
            instance.onSelect(event)
          }
        }
      },
      {
        key: '_onDeselect',
        value: function _onDeselect (event) {
          var instance = this._findInstance(
            this.instances,
            'id',
            event.detail.sectionId
          )
          if (instance && typeof instance.onDeselect === 'function') {
            instance.onDeselect(event)
          }
        }
      },
      {
        key: '_onReorder',
        value: function _onReorder (event) {
          var instance = this._findInstance(
            this.instances,
            'id',
            event.detail.sectionId
          )
          if (instance && typeof instance.onReorder === 'function') {
            instance.onReorder(event)
          }
        }
      },
      {
        key: '_onBlockSelect',
        value: function _onBlockSelect (event) {
          var instance = this._findInstance(
            this.instances,
            'id',
            event.detail.sectionId
          )
          if (instance && typeof instance.onBlockSelect === 'function') {
            instance.onBlockSelect(event)
          }
        }
      },
      {
        key: '_onBlockDeselect',
        value: function _onBlockDeselect (event) {
          var instance = this._findInstance(
            this.instances,
            'id',
            event.detail.sectionId
          )
          if (instance && typeof instance.onBlockDeselect === 'function') {
            instance.onBlockDeselect(event)
          }
        }
      },
      {
        key: '_createInstance',
        value: function _createInstance (container, constructor) {
          var id = container.getAttribute('data-section-id'),
            type = container.getAttribute('data-section-type')
          constructor = constructor || this.constructors[type]
          if (typeof constructor === 'undefined') {
            return
          }
          var instance = Object.assign(new constructor(container), {
            id: id,
            type: type,
            container: container
          })
          this.instances.push(instance)
        }
      }
    ])
    return SectionContainer
  })()
  var ShopNowSection = (function () {
    function ShopNowSection (container) {
      _classCallCheck(this, ShopNowSection)
      this.element = container
      this.carousel = new Carousel(
        this.element.querySelector('[data-flickity-config]')
      )
      new ProductItemColorSwatch(this.element)
    }
    _createClass(ShopNowSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.carousel.destroy()
        }
      }
    ])
    return ShopNowSection
  })()
  var ShopTheLookSection = (function () {
    function ShopTheLookSection (container) {
      _classCallCheck(this, ShopTheLookSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.usePocketMode = Responsive.matchesBreakpoint('pocket')
      this.pocketActivatorButton = this.element.querySelector(
        '[data-action="open-look"]'
      )
      this._createOuterCarousel()
      this._createPocketPopovers()
      this._attachListeners()
    }
    _createClass(ShopTheLookSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.outerCarousel.destroy()
          this.innerCarousels.forEach(function (item) {
            item.forEach(function (innerItem) {
              return innerItem.destroy()
            })
          })
          this.popovers.forEach(function (item) {
            return item.destroy()
          })
          this.delegateElement.off()
        }
      },
      {
        key: 'onBlockSelect',
        value: function onBlockSelect (event) {
          this.outerCarousel.selectCell(
            event.target.getAttribute('data-slide-index'),
            !0,
            !event.detail.load
          )
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'click',
            '.ShopTheLook__Dot',
            this._onDotClicked.bind(this)
          )
        }
      },
      {
        key: '_createPocketPopovers',
        value: function _createPocketPopovers () {
          var _this = this
          this.popovers = []
          Dom.nodeListToArray(
            this.element.querySelectorAll('.Popover')
          ).forEach(function (popover) {
            _this.popovers.push(
              new Popover(popover, {
                activator: _this.pocketActivatorButton,
                showOverlay: !1,
                onOpen: _this._openPocketZoom.bind(_this),
                onClose: _this._closePocketZoom.bind(_this)
              })
            )
          })
        }
      },
      {
        key: '_createOuterCarousel',
        value: function _createOuterCarousel () {
          var _this2 = this
          this.outerCarousel = new Carousel(
            this.element.querySelector('.ShopTheLook'),
            {
              onSelect: this._onLookChanged.bind(this)
            }
          )
          this.innerCarousels = new Array(
            this.outerCarousel.flickityInstance.cells.length
          )
          for (var i = 0; i !== this.innerCarousels.length; ++i) {
            this.innerCarousels[i] = []
          }
          Dom.nodeListToArray(
            this.element.querySelectorAll('.ShopTheLook__ProductList')
          ).forEach(function (item) {
            var lookIndex = parseInt(item.getAttribute('data-look-index'))
            _this2.innerCarousels[lookIndex].push(
              new Carousel(item, {
                onSelect: _this2._onProductChanged.bind(_this2)
              })
            )
            item.insertBefore(
              item.querySelector('.flickity-viewport'),
              item.querySelector('.ShopTheLook__ViewButton')
            )
          })
          this.outerCarousel.resize()
        }
      },
      {
        key: '_onLookChanged',
        value: function _onLookChanged (selectedIndex, selectedCell) {
          this.pocketActivatorButton.setAttribute(
            'aria-controls',
            ''.concat(selectedCell.getAttribute('id'), '-popover')
          )
        }
      },
      {
        key: '_onProductChanged',
        value: function _onProductChanged (selectedIndex, selectedCell) {
          var lookItem = this.outerCarousel.getSelectedCell(),
            activeDot = null
          Dom.nodeListToArray(
            lookItem.querySelectorAll('.ShopTheLook__Dot')
          ).forEach(function (dot, index) {
            dot.classList.remove('is-active')
            if (index === selectedIndex) {
              dot.classList.add('is-active')
              activeDot = dot
            }
          })
          lookItem
            .querySelector('.ShopTheLook__ViewButton')
            .setAttribute('href', selectedCell.getAttribute('data-product-url'))
          lookItem.dispatchEvent(
            new CustomEvent('product:changed', {
              detail: {
                dot: activeDot
              }
            })
          )
        }
      },
      {
        key: '_onDotClicked',
        value: function _onDotClicked (event, target) {
          var shouldAnimateCarousel = !1,
            hasOnePopoverOpen = !1,
            lookIndex = this.outerCarousel.getSelectedIndex()
          this.popovers.forEach(function (item) {
            if (item.isOpen) {
              hasOnePopoverOpen = !0
              shouldAnimateCarousel = !0
            }
          })
          this.innerCarousels[lookIndex].forEach(function (innerCarousel) {
            innerCarousel.selectCell(
              parseInt(target.getAttribute('data-product-index')) - 1,
              !1,
              shouldAnimateCarousel
            )
          })
          if (this.usePocketMode && !hasOnePopoverOpen) {
            this.popovers[lookIndex].open()
          }
        }
      },
      {
        key: '_openPocketZoom',
        value: function _openPocketZoom (popover) {
          var _this3 = this
          this._calculateImageTransform(popover)
          fastdom.mutate(function () {
            document.getElementById('shopify-section-header').style.cssText =
              'transform: translateY(-100%); transition: transform 0.3s ease-in-out;'
            _this3.outerCarousel.flickityInstance.unbindDrag()
            _this3.outerCarousel.flickityInstance.element.classList.add(
              'is-zoomed'
            )
            _this3.outerCarousel.getSelectedCell().classList.add('is-expanded')
          })
        }
      },
      {
        key: '_calculateImageTransform',
        value: function _calculateImageTransform (openPopover) {
          var _this4 = this
          var selectedCell = this.outerCarousel.getSelectedCell()
          fastdom.measure(function () {
            var scale =
                window.innerWidth /
                (selectedCell.offsetWidth -
                  parseInt(window.getComputedStyle(selectedCell).paddingLeft) *
                    2),
              heightAfterScale = Math.round(selectedCell.offsetHeight * scale),
              hiddenImageHeight = Math.round(
                Math.max(
                  heightAfterScale -
                    (window.innerHeight - openPopover.element.offsetHeight),
                  0
                )
              ),
              visibleImageHeight = heightAfterScale - hiddenImageHeight,
              minTranslateY = Math.round(
                -(
                  selectedCell.getBoundingClientRect().top -
                  (heightAfterScale - selectedCell.offsetHeight) / 2
                )
              ),
              maxTranslateY = Math.round(minTranslateY - hiddenImageHeight)
            _this4._calculateTransformForDotListener = function (event) {
              var dotTopPosition = Math.round(
                  (event.detail.dot.offsetTop +
                    event.detail.dot.offsetHeight / 2) *
                    scale
                ),
                offsetToMove = Math.round(
                  dotTopPosition - visibleImageHeight / 2
                ),
                translateY = Math.min(
                  Math.max(minTranslateY - offsetToMove, maxTranslateY),
                  minTranslateY
                )
              fastdom.mutate(function () {
                _this4.outerCarousel.flickityInstance.viewport.style.transform =
                  'translate3d(0, '
                    .concat(Math.round(translateY), 'px, 0) scale(')
                    .concat(scale, ')')
              })
            }
            selectedCell.addEventListener(
              'product:changed',
              _this4._calculateTransformForDotListener
            )
            selectedCell.dispatchEvent(
              new CustomEvent('product:changed', {
                detail: {
                  dot: selectedCell.querySelector('.ShopTheLook__Dot.is-active')
                }
              })
            )
          })
        }
      },
      {
        key: '_closePocketZoom',
        value: function _closePocketZoom () {
          var _this5 = this
          var selectedCell = this.outerCarousel.getSelectedCell()
          selectedCell.removeEventListener(
            'product:changed',
            this._calculateTransformForDotListener
          )
          fastdom.mutate(function () {
            document.getElementById('shopify-section-header').style.cssText =
              'transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;'
            _this5.outerCarousel.flickityInstance.bindDrag()
            _this5.outerCarousel.flickityInstance.element.classList.remove(
              'is-zoomed'
            )
            _this5.outerCarousel.flickityInstance.viewport.style.transform =
              null
            selectedCell.classList.remove('is-expanded')
          })
        }
      }
    ])
    return ShopTheLookSection
  })()
  var SidebarMenuSection = (function () {
    function SidebarMenuSection (container) {
      _classCallCheck(this, SidebarMenuSection)
      this.element = container
      this.sidebarDrawer = new Drawer(container)
    }
    _createClass(SidebarMenuSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.sidebarDrawer.destroy()
        }
      },
      {
        key: 'onSelect',
        value: function onSelect () {
          this.sidebarDrawer.open()
        }
      },
      {
        key: 'onDeselect',
        value: function onDeselect () {
          this.sidebarDrawer.close()
        }
      }
    ])
    return SidebarMenuSection
  })()
  var SlideshowSection = (function () {
    function SlideshowSection (container) {
      _classCallCheck(this, SlideshowSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.slideshow = new Carousel(
        this.element.querySelector('[data-flickity-config]'),
        {
          onSelect: this._onSlideChanged.bind(this)
        }
      )
      this.selectedSlide = null
      this.shouldAnimate = !0
      this.timeline = new TimelineLite({
        delay: window.theme.showPageTransition ? 0.5 : 0
      })
      if (this.slideshow.flickityInstance.cells.length > 0) {
        this._transitionToSlide(
          this.slideshow.flickityInstance.selectedCell.element,
          !0
        )
      }
      this._attachListeners()
    }
    _createClass(SlideshowSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.slideshow.destroy()
          this.timeline.kill()
          this.delegateElement.off()
          document.removeEventListener(
            'breakpoint:changed',
            this._onBreakpointChangedListener
          )
        }
      },
      {
        key: 'onBlockSelect',
        value: function onBlockSelect (event) {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.stopPlayer()
          }
          this.shouldAnimate = !event.detail.load
          this.slideshow.selectCell(
            event.target.getAttribute('data-slide-index'),
            !1,
            !event.detail.load
          )
        }
      },
      {
        key: 'onBlockDeselect',
        value: function onBlockDeselect () {
          this.shouldAnimate = !0
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.playPlayer()
          }
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this._onBreakpointChangedListener =
            this._onBreakpointChanged.bind(this)
          this.delegateElement.on(
            'mouseenter',
            '.Button',
            this._pauseSlideshow.bind(this),
            !0
          )
          this.delegateElement.on(
            'mouseleave',
            '.Button',
            this._resumeSlideshow.bind(this),
            !0
          )
          document.addEventListener(
            'breakpoint:changed',
            this._onBreakpointChangedListener
          )
        }
      },
      {
        key: '_pauseSlideshow',
        value: function _pauseSlideshow () {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.pausePlayer()
          }
        }
      },
      {
        key: '_resumeSlideshow',
        value: function _resumeSlideshow () {
          if (this.slideshow.flickityInstance.options.autoPlay) {
            this.slideshow.flickityInstance.unpausePlayer()
          }
        }
      },
      {
        key: '_onSlideChanged',
        value: function _onSlideChanged (index, element) {
          this._transitionToSlide(element)
        }
      },
      {
        key: '_transitionToSlide',
        value: function _transitionToSlide (slide) {
          var _this = this
          this.timeline.clear()
          if (this.selectedSlide) {
            this._slideLeave(this.selectedSlide)
            this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0)
          }
          this._lazyLoadNextImage()
          this.timeline.fromTo(
            slide,
            this.selectedSlide && this.shouldAnimate ? 0.3 : 0,
            {
              autoAlpha: 0
            },
            {
              autoAlpha: 1,
              ease: Cubic.easeInOut
            },
            'enter'
          )
          if (
            this.slideshow.flickityInstance.options.autoPlay &&
            this.slideshow.flickityInstance.player.state === 'playing'
          ) {
            this.slideshow.flickityInstance.pausePlayer()
          }
          Dom.nodeListToArray(
            slide.querySelectorAll('.Slideshow__Image')
          ).forEach(function (image) {
            if (
              image.classList.contains('Image--lazyLoading') ||
              image.classList.contains('Image--lazyLoad')
            ) {
              image.addEventListener(
                'lazyloaded',
                _this._slideEnter.bind(_this, slide)
              )
            } else {
              _this._slideEnter(slide)
            }
          })
          this.selectedSlide = slide
        }
      },
      {
        key: '_slideLeave',
        value: function _slideLeave (slide) {
          var content = slide.querySelector('.SectionHeader'),
            buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper')
          this.timeline.fromTo(
            slide,
            this.shouldAnimate ? 0.3 : 0,
            {
              autoAlpha: 1
            },
            {
              autoAlpha: 0,
              ease: Cubic.easeInOut,
              delay: this.shouldAnimate ? 0.35 : 0
            }
          )
          if (content) {
            this.timeline.fromTo(
              content,
              this.shouldAnimate ? 0.4 : 0,
              {
                autoAlpha: 1,
                y: 0
              },
              {
                autoAlpha: 0,
                y: 20,
                ease: Cubic.easeIn
              },
              0
            )
          }
          if (buttonWrapper) {
            this.timeline.fromTo(
              buttonWrapper,
              this.shouldAnimate ? 0.4 : 0,
              {
                autoAlpha: 1,
                y: 0
              },
              {
                autoAlpha: 0,
                y: 10,
                ease: Cubic.easeIn
              },
              0
            )
          }
        }
      },
      {
        key: '_slideEnter',
        value: function _slideEnter (slide) {
          var images = slide.querySelectorAll('.Slideshow__Image'),
            content = slide.querySelector('.SectionHeader'),
            buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper')
          if (
            this.slideshow.flickityInstance.options.autoPlay &&
            this.slideshow.flickityInstance.player.state === 'paused'
          ) {
            this.slideshow.flickityInstance.unpausePlayer()
          }
          if (
            window.CSS &&
            window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')
          ) {
            if (window.theme.showImageZooming) {
              this.timeline.fromTo(
                images,
                this.shouldAnimate ? 1.2 : 0,
                {
                  opacity: 0,
                  scale: 1.2
                },
                {
                  opacity: 1,
                  scale: 1,
                  ease: Quad.easeOut
                },
                'enter'
              )
            } else {
              this.timeline.fromTo(
                images,
                this.shouldAnimate ? 1.2 : 0,
                {
                  opacity: 0
                },
                {
                  opacity: 1,
                  ease: Quad.easeOut
                },
                'enter'
              )
            }
          }
          if (content) {
            this.timeline.fromTo(
              content,
              this.shouldAnimate ? 0.8 : 0,
              {
                autoAlpha: 0,
                y: 30
              },
              {
                autoAlpha: 1,
                y: 0,
                delay: this.shouldAnimate ? 0.8 : 0,
                ease: Cubic.easeOut
              },
              'enter'
            )
          }
          if (buttonWrapper) {
            this.timeline.fromTo(
              buttonWrapper,
              this.shouldAnimate ? 0.8 : 0,
              {
                autoAlpha: 0,
                y: 20
              },
              {
                autoAlpha: 1,
                y: 0,
                delay: this.shouldAnimate ? 0.8 : 0,
                ease: Cubic.easeOut
              },
              'enter'
            )
          }
        }
      },
      {
        key: '_lazyLoadNextImage',
        value: function _lazyLoadNextImage () {
          var currentIndex = this.slideshow.flickityInstance.selectedIndex,
            breakpoint = Responsive.getCurrentBreakpoint()
          if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
            var nextCellElement =
                this.slideshow.flickityInstance.cells[currentIndex + 1].element,
              imageContainers = Dom.nodeListToArray(
                nextCellElement.querySelectorAll('.Slideshow__ImageContainer')
              ),
              imageToReveal = null
            if (breakpoint === 'phone') {
              imageToReveal = imageContainers[0]
            } else {
              imageToReveal = imageContainers[1]
            }
            if (
              window.lazySizes &&
              imageToReveal &&
              imageToReveal.classList.contains('Image--lazyLoad')
            ) {
              lazySizes.loader.unveil(imageToReveal.firstElementChild)
            }
          }
        }
      },
      {
        key: '_onBreakpointChanged',
        value: function _onBreakpointChanged (event) {
          if (
            (event.detail.previousBreakpoint === 'phone' &&
              event.detail.currentBreakpoint !== 'phone') ||
            (event.detail.previousBreakpoint !== 'phone' &&
              event.detail.currentBreakpoint === 'phone')
          ) {
            this.selectedSlide = null
            this._transitionToSlide(
              this.slideshow.flickityInstance.selectedElement
            )
          }
        }
      }
    ])
    return SlideshowSection
  })()
  var TestimonialsSection = (function () {
    function TestimonialsSection (container) {
      _classCallCheck(this, TestimonialsSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.navItems = Dom.nodeListToArray(
        this.element.querySelectorAll('.TestimonialNav__Item')
      )
      this.carousel = new Carousel(
        this.element.querySelector('.TestimonialList'),
        {
          onSelect: this._testimonialChanged.bind(this)
        }
      )
      this._attachListeners()
    }
    _createClass(TestimonialsSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.carousel.destroy()
          this.delegateElement.off('click')
        }
      },
      {
        key: 'onBlockSelect',
        value: function onBlockSelect (event) {
          this.carousel.selectCell(
            event.target.getAttribute('data-slide-index'),
            !0
          )
        }
      },
      {
        key: 'onBlockDeselect',
        value: function onBlockDeselect () {
          this.carousel.unpausePlayer()
        }
      },
      {
        key: '_testimonialClicked',
        value: function _testimonialClicked (event, target) {
          this.carousel.pausePlayer()
          this.carousel.selectCell(parseInt(target.getAttribute('data-index')))
          this.carousel.unpausePlayer()
        }
      },
      {
        key: '_testimonialChanged',
        value: function _testimonialChanged (newIndex) {
          this.navItems.forEach(function (item, index) {
            item.classList.remove('is-selected')
            if (newIndex === index) {
              item.classList.add('is-selected')
            }
          })
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'click',
            '.TestimonialNav__Item',
            this._testimonialClicked.bind(this)
          )
        }
      }
    ])
    return TestimonialsSection
  })()
  var TimelineSection = (function () {
    function TimelineSection (container) {
      _classCallCheck(this, TimelineSection)
      this.element = container
      this.delegateElement = new domDelegate.Delegate(this.element)
      this.items = Dom.nodeListToArray(
        this.element.querySelectorAll('.Timeline__Item')
      )
      this.navItems = Dom.nodeListToArray(
        this.element.querySelectorAll('.Timeline__NavItem')
      )
      this._attachListeners()
    }
    _createClass(TimelineSection, [
      {
        key: 'onUnload',
        value: function onUnload () {
          this.delegateElement.off('click')
        }
      },
      {
        key: 'onBlockSelect',
        value: function onBlockSelect (event) {
          this.navItems[
            parseInt(event.target.getAttribute('data-index'))
          ].click()
        }
      },
      {
        key: '_attachListeners',
        value: function _attachListeners () {
          this.delegateElement.on(
            'click',
            '.Timeline__NavItem',
            this._clickOnNavItem.bind(this)
          )
        }
      },
      {
        key: '_clickOnNavItem',
        value: function _clickOnNavItem (event, target) {
          var newItem = this.items[parseInt(target.getAttribute('data-index'))]
          if (newItem.classList.contains('is-selected')) {
            return
          }
          var isContentLarger = !1,
            navWrapper = target.parentNode,
            scrollableOffset = 0
          fastdom.measure(function () {
            var scrollableWidth = navWrapper.scrollWidth,
              visibleWidth = navWrapper.offsetWidth
            isContentLarger = visibleWidth < scrollableWidth
            if (isContentLarger) {
              var beginBound = target.offsetLeft,
                endBound = beginBound + target.offsetWidth,
                closerToLeft = beginBound <= visibleWidth - endBound
              var itemToUse = null
              if (closerToLeft) {
                itemToUse = target.previousElementSibling || target
              } else {
                itemToUse = target.nextElementSibling || target
              }
              var itemBeginBound = itemToUse.offsetLeft - navWrapper.scrollLeft,
                itemEndBound = itemBeginBound + itemToUse.offsetWidth
              if (itemEndBound > visibleWidth) {
                scrollableOffset = itemEndBound - visibleWidth
              } else if (itemBeginBound < 0) {
                scrollableOffset = itemBeginBound
              }
            }
          })
          fastdom.mutate(function () {
            if (isContentLarger) {
              navWrapper.scrollBy({
                behavior: 'smooth',
                left: scrollableOffset
              })
            }
            target.classList.add('is-selected')
            Dom.getSiblings(target, '.is-selected').forEach(function (item) {
              item.classList.remove('is-selected')
            })
            newItem.classList.add('is-selected')
            Dom.getSiblings(newItem, '.is-selected').forEach(function (item) {
              item.classList.remove('is-selected')
            })
          })
        }
      }
    ])
    return TimelineSection
  })()
  var PriceRange = (function (_HTMLElement) {
    _inherits(PriceRange, _HTMLElement)
    var _super = _createSuper(PriceRange)

    function PriceRange () {
      _classCallCheck(this, PriceRange)
      return _super.apply(this, arguments)
    }
    _createClass(PriceRange, [
      {
        key: 'connectedCallback',
        value: function connectedCallback () {
          var _this = this
          this.rangeLowerBound = this.querySelector(
            '.price-range__range-group input:first-child'
          )
          this.rangeHigherBound = this.querySelector(
            '.price-range__range-group input:last-child'
          )
          this.textInputLowerBound = this.querySelector(
            '.price-range__input:first-child input'
          )
          this.textInputHigherBound = this.querySelector(
            '.price-range__input:last-child input'
          )
          this.textInputLowerBound.addEventListener('focus', function () {
            return _this.textInputLowerBound.select()
          })
          this.textInputHigherBound.addEventListener('focus', function () {
            return _this.textInputHigherBound.select()
          })
          this.textInputLowerBound.addEventListener('change', function (event) {
            event.target.value = Math.max(
              Math.min(
                parseInt(event.target.value),
                parseInt(_this.textInputHigherBound.value || event.target.max) -
                  1
              ),
              event.target.min
            )
            _this.rangeLowerBound.value = event.target.value
            _this.rangeLowerBound.parentElement.style.setProperty(
              '--range-min',
              ''.concat(
                (parseInt(_this.rangeLowerBound.value) /
                  parseInt(_this.rangeLowerBound.max)) *
                  100,
                '%'
              )
            )
          })
          this.textInputHigherBound.addEventListener(
            'change',
            function (event) {
              event.target.value = Math.min(
                Math.max(
                  parseInt(event.target.value),
                  parseInt(
                    _this.textInputLowerBound.value || event.target.min
                  ) + 1
                ),
                event.target.max
              )
              _this.rangeHigherBound.value = event.target.value
              _this.rangeHigherBound.parentElement.style.setProperty(
                '--range-max',
                ''.concat(
                  (parseInt(_this.rangeHigherBound.value) /
                    parseInt(_this.rangeHigherBound.max)) *
                    100,
                  '%'
                )
              )
            }
          )
          this.rangeLowerBound.addEventListener('change', function (event) {
            _this.textInputLowerBound.value = event.target.value
            _this.textInputLowerBound.dispatchEvent(
              new Event('change', {
                bubbles: !0
              })
            )
          })
          this.rangeHigherBound.addEventListener('change', function (event) {
            _this.textInputHigherBound.value = event.target.value
            _this.textInputHigherBound.dispatchEvent(
              new Event('change', {
                bubbles: !0
              })
            )
          })
          this.rangeLowerBound.addEventListener('input', function (event) {
            event.target.value = Math.min(
              parseInt(event.target.value),
              parseInt(_this.textInputHigherBound.value || event.target.max) - 1
            )
            event.target.parentElement.style.setProperty(
              '--range-min',
              ''.concat(
                (parseInt(event.target.value) / parseInt(event.target.max)) *
                  100,
                '%'
              )
            )
            _this.textInputLowerBound.value = event.target.value
          })
          this.rangeHigherBound.addEventListener('input', function (event) {
            event.target.value = Math.max(
              parseInt(event.target.value),
              parseInt(_this.textInputLowerBound.value || event.target.min) + 1
            )
            event.target.parentElement.style.setProperty(
              '--range-max',
              ''.concat(
                (parseInt(event.target.value) / parseInt(event.target.max)) *
                  100,
                '%'
              )
            )
            _this.textInputHigherBound.value = event.target.value
          })
        }
      }
    ])
    return PriceRange
  })(_wrapNativeSuper(HTMLElement))
  window.customElements.define('price-range', PriceRange)
  ;(function () {
    new Collapsible()
    new Modal()
    new Responsive()
    if (
      window.theme.pageType !== 'password' &&
      window.theme.pageType !== 'gift_card'
    ) {
      new LoadingBar()
    }
    var sections = new SectionContainer()
    sections.register('header', HeaderSection)
    sections.register('footer', FooterSection)
    sections.register('sidebar-menu', SidebarMenuSection)
    sections.register('cart', CartSection)
    sections.register('newsletter-popup', NewsletterPopupSection)
    sections.register('slideshow', SlideshowSection)
    sections.register('collection-list', CollectionListSection)
    sections.register('article-list', ArticleList)
    sections.register('featured-product', FeaturedProductSection)
    sections.register('image-with-text-block', ImageWithTextBlockSection)
    sections.register('timeline', TimelineSection)
    sections.register('map', MapSection)
    sections.register('featured-collections', FeaturedCollectionsSection)
    sections.register('shop-the-look', ShopTheLookSection)
    sections.register('testimonials', TestimonialsSection)
    sections.register('background-video', BackgroundVideoSection)
    sections.register('product', ProductSection)
    sections.register('product-recommendations', ProductRecommendationsSection)
    sections.register('collection', CollectionSection)
    sections.register('article-list', ArticleList)
    sections.register('article', ArticleSection)
    sections.register('faq', FaqSection)
    sections.register('login', LoginSection)
    sections.register('addresses', AddressesSection)
    sections.register('gift-card', GiftCardSection)
    sections.register('recently-viewed-products', RecentlyViewedProductsSection)
    sections.register('shop-now', ShopNowSection)
    Flickity.defaults.dragThreshold = 7
    ;(function () {
      var touchingCarousel = !1,
        touchStartCoords
      document.body.addEventListener('touchstart', function (e) {
        if (e.target.closest('.flickity-slider')) {
          touchingCarousel = !0
        } else {
          touchingCarousel = !1
          return
        }
        touchStartCoords = {
          x: e.touches[0].pageX,
          y: e.touches[0].pageY
        }
      })
      document.body.addEventListener(
        'touchmove',
        function (e) {
          if (!(touchingCarousel && e.cancelable)) {
            return
          }
          var moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y
          }
          if (Math.abs(moveVector.x) > Flickity.defaults.dragThreshold)
            e.preventDefault()
        },
        {
          passive: !1
        }
      )
    })()
    ;(function () {
      if (window.Flickity) {
        var originalResizeMethod = window.Flickity.prototype.resize,
          lastWidth = window.innerWidth
        window.Flickity.prototype.resize = function () {
          if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
            return
          }
          lastWidth = window.innerWidth
          originalResizeMethod.apply(this, arguments)
        }
      }
    })()
    ;(function () {
      Dom.nodeListToArray(document.querySelectorAll('.Rte table')).forEach(
        function (table) {
          table.outerHTML =
            '<div class="TableWrapper">' + table.outerHTML + '</div>'
        }
      )
      Dom.nodeListToArray(document.querySelectorAll('.Rte iframe')).forEach(
        function (iframe) {
          if (
            iframe.src.indexOf('youtube') !== -1 ||
            iframe.src.indexOf('youtu.be') !== -1 ||
            iframe.src.indexOf('vimeo') !== -1
          ) {
            iframe.outerHTML =
              '<div class="VideoWrapper">' + iframe.outerHTML + '</div>'
            iframe.src = iframe.src
          }
        }
      )
    })()
    ;(function () {
      var documentDelegate = new domDelegate.Delegate(document.body),
        announcementBar = document.querySelector('.AnnouncementBar')
      documentDelegate.on(
        'click',
        '[href^="#"], [data-href]',
        function (event, target) {
          var selector = target.hasAttribute('href')
            ? target.getAttribute('href')
            : target.getAttribute('data-href')
          if (selector === '#' || selector === '#main') {
            return
          }
          var element = document.querySelector(selector),
            offset = parseInt(target.getAttribute('data-offset') || 0)
          if (announcementBar) {
            offset -= announcementBar.clientHeight
          }
          if (target.hasAttribute('data-focus-on-click')) {
            var prevScrollY = window.pageYOffset
            element.focus({
              preventScroll: !0
            })
            if (window.pageYOffset !== prevScrollY) {
              window.scrollTo(window.pageXOffset, prevScrollY)
            }
            element.focus()
          }
          window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - offset
          })
          event.preventDefault()
        }
      )
    })()
    ;(function () {
      var windowWidth = window.innerWidth,
        headerSection = document.getElementById('shopify-section-header')
      window.addEventListener('resize', function () {
        var newWidth = -1
        fastdom.measure(function () {
          newWidth = window.innerWidth
        })
        fastdom.mutate(function () {
          if (newWidth === windowWidth) {
            return
          }
          windowWidth = newWidth
          document.documentElement.style.setProperty(
            '--window-height',
            window.innerHeight + 'px'
          )
          if (headerSection) {
            document.documentElement.style.setProperty(
              '--header-height',
              headerSection.clientHeight + 'px'
            )
          }
        })
      })
    })()
    ;(function () {
      function handleFirstTab (event) {
        if (event.keyCode === 9) {
          document.body.classList.add('is-tabbing')
          window.removeEventListener('keydown', handleFirstTab)
        }
      }
      window.addEventListener('keydown', handleFirstTab)
    })()
    ;(function () {
      jQuery(document).on(
        'click',
        '.add-to-cart.launchtip_add_to_cart',
        function () {
          let $clickedElement = jQuery(this)
          $clickedElement.css('cursor', 'wait')
          setTimeout(function () {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: !0
              })
            )
            jQuery(
              '[data-action="open-drawer"][data-drawer-id="sidebar-cart"]'
            )[0].click()
            let $cartCounter = jQuery('.Header__CartCount')
            let cartQuantity = parseInt($cartCounter.html())
            cartQuantity++
            $cartCounter.html(cartQuantity)
            $clickedElement.css('cursor', 'pointer')
          }, 1300)
        }
      )
    })()
    if (window.theme.showPageTransition) {
      PageTransition.getInstance()
    }
  })()
})
;(function () {
  var Shopify = Shopify || {}
  Shopify.harFormatMoney = function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '')
    }
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}'

    function defaultTo (value, defaultValue) {
      return value == null || value !== value ? defaultValue : value
    }

    function formatWithDelimiters (number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2)
      thousands = defaultTo(thousands, ',')
      decimal = defaultTo(decimal, '.')
      if (isNaN(number) || number == null) {
        return 0
      }
      number = (number / 100.0).toFixed(precision)
      var parts = number.split('.'),
        dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        ),
        centsAmount = parts[1] ? decimal + parts[1] : ''
      return dollarsAmount + centsAmount
    }
    var value = ''
    var withDecimal = !1
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        withDecimal = !0
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.')
        break
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ')
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
    }
    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '')
    } else {
      if (withDecimal) {
        return formatString.replace(placeholderRegex, value)
      } else {
        return formatString.replace(placeholderRegex, value).replace('.00', '')
      }
    }
  }
  var targetLaunchtipUpsell = document.querySelector(
    '#launchtip_upsell_wrapper1'
  )
  if (
    typeof targetLaunchtipUpsell != 'undefined' &&
    targetLaunchtipUpsell != null
  ) {
    var observerLaunchTip = new MutationObserver(function (
      mutations,
      observer
    ) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          let upsell_container = document.querySelector(
            '#launchtip_upsell_wrapper1'
          )
          let productUpsellPrices =
            upsell_container.querySelectorAll('.detail_price')
          console.log('productUpsellPrices: ')
          console.log(productUpsellPrices)
          if (productUpsellPrices.length > 0) {
            let currencyFormat = window.theme.currencyCodeEnabled
              ? window.theme.moneyWithCurrencyFormat
              : window.theme.moneyFormat
            productUpsellPrices.forEach(upsellPrice => {
              let priceListHtml = ''
              let originalPrice =
                parseFloat(upsellPrice.querySelector('.main_price').value) *
                100
              priceListHtml += '<span> '.concat(
                Shopify.harFormatMoney(originalPrice, currencyFormat),
                '</span>'
              )
              setTimeout(function () {
                upsellPrice.style.textTransform = 'uppercase'
                upsellPrice.innerHTML = priceListHtml
                console.log('upsell price updated')
                observer.disconnect()
              }, 100)
            })
            console.log('upsell container detected')
          }
        }
      })
    })
    var configLaunchTip = {
      attributes: !0,
      childList: !0,
      characterData: !0
    }
    observerLaunchTip.observe(targetLaunchtipUpsell, configLaunchTip)
  }
})()
